<template>
  <div class="menu-page" :style="introVisible ? { padding: '0' } : { paddingTop: (topFixedHeight || 0) + 'px' }">
	<!--过敏成分筛选 png jpg参数 开台输入人数 包餐 类别加参数 默认显示方式-->
    <div v-if="introVisible" class="menu-intro">
      <div class="menu-intro-card">
        <div class="menu-intro-title-row">
          <div class="menu-intro-logo" v-if="logoSrc">
            <img :src="logoSrc" @error="onLogoError" alt="logo">
          </div>
          <div class="menu-intro-title">{{ shopName }}</div>
        </div>
        <div class="menu-intro-desc" v-if="shopIntro">{{ shopIntro }}</div>
        <div class="menu-intro-phone" v-if="shopPhone">
          <span class="menu-intro-phone-label">{{$lang[pickxb].l2}}</span>
          <span class="menu-intro-phone-value">{{ shopPhone }}</span>
        </div>
        <div class="menu-intro-table-row" v-if="introHasDiningTime&&introDiningTimeText!='00:00 - 23:59'">
          <span class="menu-intro-table-label">{{$lang[pickxb].l3}}</span>
          <span class="menu-intro-table-value">{{ introDiningTimeText }}</span>
        </div>
        <div class="menu-intro-table-row">
		  <template v-if="DeskID=='Food'">
			<span class="menu-intro-table-value desk">
		  	  {{foodlist[pickxb].on2}}	
			</span>
		  </template>
		  <template v-else>
			<span class="menu-intro-table-label">{{$lang[pickxb].l5}}</span>
			<span class="menu-intro-table-value desk">
			  {{ deskName }}		
			</span>
		  </template>
        </div>
        <div class="menu-intro-table-row" v-if="IsBuffetzt && DeskMin > 0">
          <span class="menu-intro-table-label">{{$lang[pickxb].l23}}</span>
          <span class="menu-intro-table-value">{{ DeskMin }}M</span>
          <span class="menu-intro-table-value" v-if="Numberpoints > 0">| {{$lang[pickxb].l24}}: {{ Numberpoints }}</span>
        </div>

        <div class="menu-intro-lang-title" v-if="introLangList.length > 1"></div>
        <div class="menu-intro-langs" v-if="introLangList.length > 1">
          <div
            v-for="(item, idx) in introLangList"
            :key="(item && (item.id || item.label)) ? (item.id || item.label) : ('lang_' + idx)"
            class="menu-intro-lang"
            :class="{ on: pickindex === idx }"
            @click="chooseIntroLang(idx)"
          >{{ item && item.label ? item.label : '' }}</div>
        </div>

        <div class="menu-intro-banner">
          <template v-if="ShopID && ShopID !== '2605261454'">
            <swiper :options="swiperOptionIntro" ref="introSwiper">
              <swiper-slide v-for="index in 5" :key="'intro_' + index">
                <div class="menu-intro-banner-card">
                  <img :src="$lujin + '/Data/' + ShopID + '/PicWeb/p' + index + '.jpg?time=' + introBannerSeed" alt="banner">
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </template>
          <template v-else-if="ShopID">
            <div class="menu-intro-banner-card">
              <img :src="$lujin + '/Data/' + ShopID + '/PicWeb/p1.jpg?time=' + introBannerSeed" alt="banner">
            </div>
          </template>
        </div>

        <div class="menu-intro-start" @click="startOrdering">{{$lang[pickxb].l1}}</div>
      </div>
    </div>

    <div v-else class="menu-shell">
      <div class="menu-top-fixed" ref="topSticky">
        <div class="menu-top-inner">
          <div class="menu-header">
            <div class="menu-brand">
              <div class="menu-logo">
                <img :src="logoSrc" @error="onLogoError" alt="logo">
              </div>
              <div class="menu-meta">
                <div class="menu-title">{{ shopName }}</div>
                <div class="menu-desk" v-if="deskName=='Food'">{{foodlist[pickxb].on2}}	</div>
                <div class="menu-desk" v-if="deskName==!'Food'">{{$lang[pickxb].l5}}: <span>{{ deskName }}</span></div>
                <div class="menu-desk" v-if="IsBuffetzt && DeskMin > 0">
				{{$lang[pickxb].l23}}:<span style="color:red;">{{ DeskMin }}M</span>
				<span v-if="Numberpoints > 0">{{$lang[pickxb].l24}}: {{ Numberpoints }}</span>
				</div>
              </div>
            </div>
            <div class="menu-image" v-if="VipState" @click="memberDisplayName ? openMemberLogoutConfirm() : openMemberLogin()">
              <template v-if="memberDisplayName">
                <div class="menu-member-greet">Hi, {{ memberDisplayName }}</div>
              </template>
              <img v-else src="../../static/images/xin/huiy.png"></img>
            </div>
          </div>

          <div class="menu-search">
            <div class="menu-search-input">
              <input v-model="searchText" type="text" :placeholder="$lang[pickxb].l6">
            </div>
            <div class="menu-search-btn">
              <img src="../../static/images/xin/shouss.png" alt="search">
            </div>
          </div>
        </div>

        <div class="menu-categories menu-depot-categories" v-if="isMadeDepotEnabled && madeDepotList.length" ref="depotBar">
          <div class="menu-categories-track">
            <div
              v-for="item in madeDepotList"
              :key="item.MadeDepotID || item.id || item.MadeDepot || item.TwoMadeDepot || item.ThreeMadeDepot"
              class="menu-category-item"
              :class="{ on: activeMadeDepotId == (item.MadeDepotID || item.id) }"
              @click="onMadeDepotClick(item)"
            >
              <div class="menu-category-thumb">
                <div class="menu-category-fallback">{{ getMadeDepotInitial(item) }}</div>
              </div>
              <div class="menu-category-name">{{ getMadeDepotName(item) }}</div>
            </div>
          </div>
        </div>

        <div
          class="menu-categories"
          :class="{
            'menu-categories-has-depot': isMadeDepotEnabled && madeDepotList.length,
            'menu-categories-empty': isMadeDepotEnabled && madeDepotList.length && !displayMenuTypes.length
          }"
          ref="categoriesBar"
        >
          <div class="menu-categories-track">
            <div
              v-for="item in displayMenuTypes"
              :key="item.TypeID || item.typeId || item.TypeName || item.name"
              class="menu-category-item"
              :class="{ on: activeCategoryId == (item.TypeID || item.typeId) }"
              @click="onCategoryClick(item)"
            >
              <div class="menu-category-thumb" v-if="false">
                <img
                  v-if="!categoryImageErrorMap[item.TypeID || item.typeId]"
                  :src="getCategoryImage(item)"
                  @error="onCategoryError(item.TypeID || item.typeId)"
                  alt="category"
                >
                <div v-else class="menu-category-fallback">{{ getCategoryInitial(item) }}</div>
              </div>
              <div class="menu-category-name">{{ getCategoryName(item) }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="menu-banner">
        <swiper :options="swiperOption" ref="menuSwiper" v-if="false">
          <swiper-slide v-for="(pic, index) in displayBannerPics" :key="pic + '_' + index">
            <div class="menu-banner-card">
              <img :src="pic" @error="onBannerError" alt="banner">
            </div>
          </swiper-slide>
        </swiper>
        <div class="menu-banner-pagination" v-if="bannerPics.length > 1&&false">
          <span
            v-for="(pic, index) in bannerPics"
            :key="'dot_' + index"
            class="menu-banner-dot"
            :class="{ on: currentBannerIndex === index }"
          ></span>
        </div>
      </div>
      <div class="menu-goods" :class="'mode-' + goodsViewMode" ref="goodsGrid">
        <template v-if="useCategoryFlatMode && flatCategoryGroups.length">
          <template v-for="group in flatCategoryGroups">
            <div
              v-if="group && group.title"
              :key="'cat_' + group.typeId"
              class="menu-goods-category menu-goods-category-flat"
              :data-category-type-id="String(group.typeId)"
            >
              <div class="menu-goods-category-title">{{ group.title }}</div>
              <div class="menu-goods-view-toggle" v-if="ShopID!='2605261454'" @click="toggleGoodsView"></div>
            </div>
            <div
              v-for="item in group.items"
              :key="item.GoodsID + '_' + group.typeId"
              class="menu-goods-card"
            >
              <div class="menu-goods-image" @click.stop="changeGoodsQtys(item)">
                <img :src="getGoodsImage(item)" @error="onGoodsImageError(item.GoodsID)" alt="goods">
              </div>
              <div class="menu-goods-body">
                <div class="menu-goods-name">{{ getGoodsName(item) }}</div>
                <div class="menu-goods-meta">
                  <div class="menu-goods-icons" v-if="getIngredientIcons(item).length">
                    <img
                      v-for="icon in getIngredientIcons(item)"
                      :key="icon"
                      :src="icon"
                      alt="ingredient"
                    >
                  </div>
                  <div class="menu-goods-desc" v-if="getGoodsDesc(item)">{{ getGoodsDesc(item) }}</div>
                </div>
                <div class="menu-goods-footer">
                  <div class="menu-goods-price">{{ MoneySymbol }}{{ getGoodsPrice(item) }}</div>
                  <template v-if="isWeightGoods(item) && (goodsWeightMap[item.GoodsID] != null)">
                    <div class="menu-goods-weight-entry" @click.stop="openWeightGoods(item)">
                      <span class="menu-goods-weight-qty">{{ String(goodsWeightMap[item.GoodsID] || 0) }}</span>
                      <span class="menu-goods-weight-unit">kg</span>
                    </div>
                  </template>
                  <template v-else-if="(goodsQtyMap[item.GoodsID] || 0) > 0">
                    <div class="menu-goods-step">
                      <div class="menu-goods-step-btn minus" @click.stop="changeGoodsQty(item, -1, $event)">-</div>
                      <div class="menu-goods-step-qty">{{ goodsQtyMap[item.GoodsID] }}</div>
                      <div class="menu-goods-step-btn plus" @click.stop="changeGoodsQty(item, 1, $event)">+</div>
                    </div>
                  </template>
                  <div class="menu-goods-add" v-else @click.stop="changeGoodsQty(item, 1, $event)">+</div>
                </div>
              </div>
            </div>
          </template>
          <div v-if="!flatCategoryGroups.length" class="menu-goods-empty">No items</div>
        </template>
        <template v-else>
          <div class="menu-goods-category" v-if="activeCategoryTitle">
            <div class="menu-goods-category-title">{{ activeCategoryTitle }}</div>
            <div class="menu-goods-view-toggle" v-if="ShopID!='2605261454'" @click="toggleGoodsView"></div>
          </div>
          <div
            v-for="item in filteredGoods"
            :key="item.GoodsID"
            class="menu-goods-card"
          >
            <div class="menu-goods-image" @click.stop="changeGoodsQtys(item)">
              <img :src="getGoodsImage(item)" @error="onGoodsImageError(item.GoodsID)" alt="goods">
            </div>
            <div class="menu-goods-body">
              <div class="menu-goods-name">{{ getGoodsName(item) }}</div>
              <div class="menu-goods-meta">
                <div class="menu-goods-icons" v-if="getIngredientIcons(item).length">
                  <img
                    v-for="icon in getIngredientIcons(item)"
                    :key="icon"
                    :src="icon"
                    alt="ingredient"
                  >
                </div>
                <div class="menu-goods-desc" v-if="getGoodsDesc(item)">{{ getGoodsDesc(item) }}</div>
              </div>
              <div class="menu-goods-footer">
                <div class="menu-goods-price">{{ MoneySymbol }}{{ getGoodsPrice(item) }}</div>
                <template v-if="isWeightGoods(item) && (goodsWeightMap[item.GoodsID] != null)">
                  <div class="menu-goods-weight-entry" @click.stop="openWeightGoods(item)">
                    <span class="menu-goods-weight-qty">{{ String(goodsWeightMap[item.GoodsID] || 0) }}</span>
                    <span class="menu-goods-weight-unit">kg</span>
                  </div>
                </template>
                <template v-else-if="(goodsQtyMap[item.GoodsID] || 0) > 0">
                  <div class="menu-goods-step">
                    <div class="menu-goods-step-btn minus" @click.stop="changeGoodsQty(item, -1, $event)">-</div>
                    <div class="menu-goods-step-qty">{{ goodsQtyMap[item.GoodsID] }}</div>
                    <div class="menu-goods-step-btn plus" @click.stop="changeGoodsQty(item, 1, $event)">+</div>
                  </div>
                </template>
                <div class="menu-goods-add" v-else @click.stop="changeGoodsQty(item, 1, $event)">+</div>
              </div>
            </div>
          </div>
          <div v-if="!filteredGoods.length" class="menu-goods-empty">No items</div>
        </template>
      </div>
    </div>
    <div v-if="!introVisible" class="menu-bottom-bar">
      <div class="menu-bottom-flow"></div>
      <div class="menu-bottom-item" @click="goToMenuQx">
        <div class="menu-bottom-icon menu-bottom-order"></div>
      </div>
      <div class="menu-bottom-center">
        <div class="menu-bottom-center-btn" ref="cartBtn" @click="openCart">
          <div class="menu-bottom-center-icon"></div>
          <div class="menu-bottom-badge" v-if="cartCount > 0">{{ cartCount }}</div>
        </div>
      </div>
      <div class="menu-bottom-item" @click="goToQua">
        <div class="menu-bottom-icon menu-bottom-checkout"></div>
      </div>
    </div>

    <div class="menu-fly-layer">
      <div
        v-for="b in flyBalls"
        :key="b.id"
        class="menu-fly-ball"
        :style="{
          left: b.x + 'px',
          top: b.y + 'px',
          transform: 'translate(' + (b.moved ? b.dx : 0) + 'px,' + (b.moved ? b.dy : 0) + 'px) scale(' + (b.moved ? 0.2 : 1) + ')',
          opacity: b.moved ? 0.15 : 1
        }"
      ></div>
    </div>

    <div v-if="searchAddToastVisible" class="menu-toast">
      <div class="menu-toast-box">{{ searchAddToastText }}</div>
    </div>

    <div v-if="setMealVisible" class="menu-setmeal">
      <div class="menu-setmeal-top">
        <div class="menu-setmeal-top-left" @click="closeSetMeal">
          <span class="menu-cart-back-arrow"></span>
          <span class="menu-cart-back-text">{{$lang[pickxb].l7}}</span>
        </div>
        <div class="menu-setmeal-top-title">{{ getGoodsName(setMealGoods) }}</div>
        <div class="menu-setmeal-top-right"></div>
      </div>
      <div class="menu-setmeal-body">
        <div class="menu-setmeal-image">
          <img :src="getGoodsImage(setMealGoods)" @error="onGoodsImageError(setMealGoods && setMealGoods.GoodsID)" alt="goods">
        </div>
        <div class="menu-setmeal-info">
          <div class="menu-setmeal-name">{{ getGoodsName(setMealGoods) }}</div>
          <div class="menu-setmeal-desc" v-if="getGoodsDesc(setMealGoods)">{{ getGoodsDesc(setMealGoods) }}</div>
          <div class="menu-setmeal-icons" v-if="getIngredientIcons(setMealGoods).length">
            <img v-for="icon in getIngredientIcons(setMealGoods)" :key="icon" :src="icon" alt="icon">
          </div>
          <div class="menu-setmeal-money-row">
            <div class="menu-setmeal-money">{{ MoneySymbol }}{{ getSetMealTotalMoney() }}</div>
            <div v-if="setMealKind === 'weight'" class="menu-weight-stepper in-info">
              <div class="menu-weight-step-btn minus" @click="changeSetMealQty(-1)">-</div>
              <input
                class="menu-weight-input"
                type="text"
                inputmode="decimal"
                pattern="[0-9]*\.?[0-9]*"
                :value="setMealQty"
                @input.stop="onWeightQtyInput($event)"
                @click.stop
              >
              <span class="menu-weight-unit">{{ getGoodsUnit(setMealGoods) }}</span>
              <div class="menu-weight-step-btn plus" @click="changeSetMealQty(1)">+</div>
            </div>
            <div v-else class="menu-setmeal-stepper in-info">
              <div class="menu-setmeal-step-btn minus" @click="changeSetMealQty(-1)">-</div>
              <div class="menu-setmeal-step-qty">{{ setMealQty }}</div>
              <div class="menu-setmeal-step-btn plus" @click="changeSetMealQty(1)">+</div>
            </div>
          </div>
        </div>
        <div v-if="setMealLoading" class="menu-setmeal-loading">Loading...</div>
        <template v-else>
          <div v-if="setMealKind === 'remark'" class="menu-setmeal-block">
            <div v-if="!setMealRemarkGroups.length" class="menu-setmeal-block-title">{{$lang[pickxb].l10}}</div>
            <div v-if="setMealRemarkGroups.length" class="menu-setmeal-remark-groups">
              <div v-for="(g, gi) in setMealRemarkGroups" :key="(g.GroupID || g.GroupName || gi) + '_' + gi" class="menu-setmeal-remark-group">
                <div class="menu-setmeal-remark-group-title">{{ getRemarkGroupName(g) }}</div>
                <div class="menu-setmeal-remark-grid">
                  <div
                    v-for="(r, ridx) in (g.TRemarkGroupItemsTemp || [])"
                    :key="(r.RemarkID || ridx) + '_' + ridx"
                    class="menu-setmeal-remark-item"
                    :class="{ on: !!r.ZT }"
                    @click="toggleSetMealRemarkGroup(gi, ridx)"
                  >
                    <div class="menu-setmeal-remark-text">
                      <span class="menu-setmeal-remark-name">{{ getRemarkName(r) }}<span class="menu-setmeal-remark-price" v-if="getRemarkAddPrice(r) > 0">+{{ MoneySymbol }}{{ getRemarkAddPrice(r).toFixed(DecimalBit) }}</span></span>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="menu-setmeal-remark-grid">
              <div
                v-for="(r, ridx) in setMealRemarkList"
                :key="(r.RemarkID || ridx) + '_' + ridx"
                class="menu-setmeal-remark-item"
                :class="{ on: !!r.ZT }"
                @click="toggleSetMealRemark(ridx)"
              >
                <div class="menu-setmeal-remark-text">
                  <span class="menu-setmeal-remark-name">{{ getRemarkName(r) }}</span>
                  <span class="menu-setmeal-remark-price" v-if="getRemarkAddPrice(r) > 0">+{{ MoneySymbol }}{{ getRemarkAddPrice(r).toFixed(DecimalBit) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="setMealKind === 'unit'" class="menu-setmeal-block">
            <div class="menu-setmeal-block-title">{{$lang[pickxb].l8}}</div>
            <div class="menu-setmeal-remark-grid">
              <div
                v-for="(u, uidx) in setMealUnitList"
                :key="(u && (u.Unit || u.ID || u.id) ? (u.Unit || u.ID || u.id) : uidx) + '_' + uidx"
                class="menu-setmeal-remark-item"
                :class="{ on: setMealUnitIndex === uidx }"
                @click="selectSetMealUnit(uidx)"
              >
                <div class="menu-setmeal-remark-text">
                  <span class="menu-setmeal-remark-name">{{ getUnitLabel(u) }}</span>
                  <span class="menu-setmeal-remark-price" v-if="getUnitExtra(u) > 0">+{{ MoneySymbol }}{{ getUnitExtra(u).toFixed(DecimalBit) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="setMealKind === 'weight'" class="menu-setmeal-block">
            <div class="menu-setmeal-block-title">{{$lang[pickxb].l130}}</div>
            <div class="menu-weight-card">
              <div class="menu-weight-card-row">
                <div class="menu-weight-card-label">{{$lang[pickxb].l130}}（{{getGoodsUnit(setMealGoods)}}）</div>
                <div class="menu-weight-card-control">
                  <div class="menu-weight-step-btn minus" @click="changeSetMealQty(-1)">-</div>
                  <input
                    class="menu-weight-card-input"
                    type="text"
                    inputmode="decimal"
                    pattern="[0-9]*\.?[0-9]*"
                    :value="setMealQty"
                    @input.stop="onWeightQtyInput($event)"
                    @click.stop
                  >
                  <span class="menu-weight-card-unit">{{getGoodsUnit(setMealGoods)}}</span>
                  <div class="menu-weight-step-btn plus" @click="changeSetMealQty(1)">+</div>
                </div>
              </div>
              <div class="menu-weight-card-row">
                <div class="menu-weight-card-label">{{$lang[pickxb].l123}}</div>
                <div class="menu-weight-card-subtotal">{{ MoneySymbol }}{{ getSetMealTotalMoney() }}</div>
              </div>
              <div class="menu-weight-card-tips">
                <span v-for="n in weightQuickList" :key="n" class="menu-weight-card-chip" @click="setMealQty = n">{{ n }}{{getGoodsUnit(setMealGoods)}}</span>
              </div>
            </div>
          </div>
          <div v-else-if="setMealKind === 'fixed' && setMealFixedList && setMealFixedList.length" class="menu-setmeal-block">
            <div class="menu-setmeal-block-title">{{$lang[pickxb].l9}}</div>
            <div class="menu-setmeal-grid">
              <div v-for="(g, idx) in setMealFixedList" :key="(g.GoodsID || g.ID || idx) + '_' + idx" class="menu-setmeal-card">
                <div class="menu-setmeal-card-image">
                  <img :src="getSetMealChildImage(g)" @error="onSetMealChildImageError(g)" alt="goods">
                </div>
                <div class="menu-setmeal-card-name">{{ getGoodsName(g) }}</div>
                <div class="menu-setmeal-card-qty" v-if="Number(g.Qua || 0) > 0">x{{ Number(g.Qua) }}</div>
              </div>
            </div>
          </div>
          <template v-else>
            <div
              v-for="(group, gi) in setMealOptionalGroups"
              :key="(group.SetMealGroupID || gi) + '_' + gi"
              class="menu-setmeal-block"
            >
              <div class="menu-setmeal-block-head">
                <div class="menu-setmeal-block-title">{{ getSetMealGroupName(group) }}</div>
                <div class="menu-setmeal-block-tip">{{ getSetMealGroupTip(group) }}</div>
              </div>
              <div class="menu-setmeal-grid">
                <div v-for="(g, idx) in (group.list || [])" :key="(g.GoodsID || g.ID || idx) + '_' + idx" class="menu-setmeal-card">
                  <div class="menu-setmeal-card-image">
                    <img :src="getSetMealChildImage(g)" @error="onSetMealChildImageError(g)" alt="goods">
                  </div>
                  <div class="menu-setmeal-card-name">{{ getGoodsName(g) }}</div>
                  <div class="menu-setmeal-card-addmoney" v-if="Number(g.Price || 0) > 0">+{{ MoneySymbol }}{{ Number(g.Price).toFixed(DecimalBit) }}</div>
                  <div v-if="String(group.IsFixup) === '1'" class="menu-setmeal-card-qty">x{{ Number(g.Qua || 1) }}</div>
                  <div v-else class="menu-setmeal-card-stepper">
                    <div class="menu-setmeal-card-stepper-inner">
                      <div
                        class="menu-setmeal-card-step-btn minus"
                        :class="{ 'menu-setmeal-card-step-hidden': Number(g.Qua || 0) <= 0 }"
                        @click.stop="changeSetMealOptionQty(gi, idx, -1)"
                      >-</div>
                      <div
                        class="menu-setmeal-card-step-qty"
                        :class="{ 'menu-setmeal-card-step-hidden': Number(g.Qua || 0) <= 0 }"
                      >{{ Number(g.Qua || 0) }}</div>
                      <div class="menu-setmeal-card-step-btn plus" @click.stop="changeSetMealOptionQty(gi, idx, 1)">+</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
      <div class="menu-setmeal-bottom">
        <div class="menu-setmeal-add-btn full" @click="confirmSetMealAdd">{{$lang[pickxb].l11}}</div>
      </div>
      <div v-if="setMealAlertVisible" class="menu-setmeal-alert-mask" @click="closeSetMealAlert">
        <div class="menu-setmeal-alert-dialog" @click.stop>
          <div class="menu-setmeal-alert-title">{{ setMealAlertTitle }}</div>
          <div class="menu-setmeal-alert-text">{{ setMealAlertText }}</div>
          <div class="menu-setmeal-alert-actions">
            <div class="menu-setmeal-alert-btn" @click="closeSetMealAlert">{{$lang[pickxb].l12}}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="memberLoginVisible" class="menu-member-login-mask" @click="closeMemberLogin">
      <div class="menu-member-login-dialog" @click.stop>
        <div class="menu-member-login-title">{{ $lang[pickxb].l45 }}</div>
        <div class="menu-member-login-form">
          <div class="menu-member-login-input-item">
            <input v-model="memberLoginForm.email" type="text" :placeholder="$lang[pickxb].l70" class="menu-member-login-input" :disabled="memberLoginLoading">
          </div>
          <div class="menu-member-login-input-item">
            <input v-model="memberLoginForm.password" type="password" :placeholder="$lang[pickxb].l71" class="menu-member-login-input" :disabled="memberLoginLoading">
          </div>
          <div class="menu-member-login-actions">
            <div class="menu-member-login-btn login" :class="{ disabled: memberLoginLoading }" @click="handleMemberLogin">
              <span v-if="memberLoginLoading" class="menu-member-login-btn-spinner"></span>
              <span v-else>{{ $lang[pickxb].l46 }}</span>
            </div>
            <div class="menu-member-login-btn register" :class="{ disabled: memberLoginLoading }" @click="handleMemberRegister">{{ $lang[pickxb].l47 }}</div>
          </div>
        </div>
      </div>
      <div v-if="memberLoginLoading" class="menu-member-loading" @touchmove.prevent @click.stop>
        <div class="menu-member-loading-dialog">
          <div class="menu-member-loading-spinner"></div>
        </div>
      </div>
    </div>

    <div v-if="memberRegisterVisible" class="menu-member-register-mask" @click="closeMemberRegister">
      <div class="menu-member-register-dialog" @click.stop>
        <div class="menu-member-register-title">{{ $lang[pickxb].l47 }}</div>
        <div class="menu-member-register-form">
          <div class="menu-member-register-input-item">
            <input v-model="memberRegisterForm.userName" type="text" :placeholder="$lang[pickxb].l72" class="menu-member-register-input" :disabled="memberRegisterLoading">
          </div>
          <div class="menu-member-register-input-item code">
            <input v-model="memberRegisterForm.email" type="text" :placeholder="$lang[pickxb].l73" class="menu-member-register-input" :disabled="memberRegisterLoading">
            <div
              class="menu-member-register-code-btn"
              :class="{ disabled: memberRegisterLoading || memberRegisterCodeSending || memberRegisterCodeSeconds > 0 }"
              @click="sendMemberRegisterCode"
            >
              {{ memberRegisterCodeSeconds > 0 ? (memberRegisterCodeSeconds + 's') : $lang[pickxb].l49 }}
            </div>
          </div>
          <div class="menu-member-register-input-item">
            <input v-model="memberRegisterForm.verifyCode" type="text" :placeholder="$lang[pickxb].l74" class="menu-member-register-input" :disabled="memberRegisterLoading">
          </div>
          <div class="menu-member-register-input-item">
            <input v-model="memberRegisterForm.password" type="password" :placeholder="$lang[pickxb].l75" class="menu-member-register-input" :disabled="memberRegisterLoading">
          </div>
          <div class="menu-member-register-actions">
            <div class="menu-member-register-btn register" :class="{ disabled: memberRegisterLoading || !isMemberRegisterReady() }" @click="handleRegisterSubmit">
              <span v-if="memberRegisterLoading" class="menu-member-login-btn-spinner"></span>
              <span v-else>{{ $lang[pickxb].l47 }}</span>
            </div>
            <div class="menu-member-register-btn cancel" :class="{ disabled: memberRegisterLoading }" @click="closeMemberRegister">{{ $lang[pickxb].l16 }}</div>
          </div>
        </div>
      </div>
      <div v-if="memberRegisterLoading" class="menu-member-loading" @touchmove.prevent @click.stop>
        <div class="menu-member-loading-dialog">
          <div class="menu-member-loading-spinner"></div>
        </div>
      </div>
    </div>

    <div v-if="setMealAlertVisible && !setMealVisible" class="menu-setmeal-alert-mask" @click="closeSetMealAlert">
      <div class="menu-setmeal-alert-dialog" @click.stop>
        <div class="menu-setmeal-alert-title">{{ setMealAlertTitle }}</div>
        <div class="menu-setmeal-alert-text">{{ setMealAlertText }}</div>
        <div class="menu-setmeal-alert-actions">
          <div class="menu-setmeal-alert-btn" @click="closeSetMealAlert">{{$lang[pickxb].l12}}</div>
        </div>
      </div>
    </div>

    <div v-if="memberLogoutVisible" class="menu-cart-del-mask" @click="closeMemberLogoutConfirm">
      <div class="menu-cart-del-dialog" @click.stop>
        <div class="menu-cart-del-title">{{ $lang[pickxb].l17 }}</div>
        <div class="menu-cart-del-text">{{ $lang[pickxb].l52 }}？</div>
        <div class="menu-cart-del-actions">
          <div class="menu-cart-del-btn cancel" @click="closeMemberLogoutConfirm">{{ $lang[pickxb].l16 }}</div>
          <div class="menu-cart-del-btn ok" @click="confirmMemberLogout">{{ $lang[pickxb].l15 }}</div>
        </div>
      </div>
    </div>

    <div v-if="cartVisible" class="menu-cart">
      <div class="menu-cart-top">
        <div class="menu-cart-top-left" @click="closeCart">
          <span class="menu-cart-back-arrow"></span>
          <span class="menu-cart-back-text">{{$lang[pickxb].l7}}</span>
        </div>
        <div class="menu-cart-top-title">{{$lang[pickxb].l18}}</div>
        <div class="menu-cart-top-right">
          <div class="menu-cart-del" @click="openCartDeleteConfirm"></div>
        </div>
      </div>

      <div v-if="cartDisplayList.length" class="menu-cart-body">
        <div
          v-for="(c, index) in cartDisplayList"
          :key="(c.id || '') + '_' + index"
          class="menu-cart-item"
        >
          <div class="menu-cart-check" :class="{ on: !!c.zt }" @click="toggleCartSelect(c)"></div>
          <div class="menu-cart-thumb">
            <img :src="getCartItemImage(c)" alt="goods">
          </div>
          <div class="menu-cart-main">
            <div class="menu-cart-main-top">
              <div class="menu-cart-name">{{ getCartItemName(c) }}</div>
              <div class="menu-cart-edit" v-if="ShopID=='202606181752'" @click.stop="openRemark(c)"></div>
            </div>
            <div class="menu-cart-remark" v-if="c && c.bz">
              <span class="menu-cart-remark-label">Note:</span>
              <span class="menu-cart-remark-text">{{ c.bz }}</span>
            </div>
            <div class="menu-cart-zuofa" v-if="getCartItemZuofa(c)">
              <span class="menu-cart-zuofa-label">{{$lang[pickxb].l13}}:</span>
              <span class="menu-cart-zuofa-text">{{ getCartItemZuofa(c) }}</span>
              <span class="menu-cart-zuofa-add" v-if="Number(c && c.addmomey ? c.addmomey : 0) > 0">+{{ MoneySymbol }}{{ formatCartMoney(c.addmomey) }}</span>
            </div>
            <div class="menu-cart-zuofa" v-else-if="Number(c && c.addmomey ? c.addmomey : 0) > 0">
              <span class="menu-cart-zuofa-label">{{$lang[pickxb].l14}}:</span>
              <span class="menu-cart-zuofa-add">{{ MoneySymbol }}{{ formatCartMoney(c.addmomey) }}</span>
            </div>
            <div class="menu-cart-setmeal" v-if="isCartSetMealRoot(c)">
              <div class="menu-cart-setmeal-title">
              </div>
              <div class="menu-cart-setmeal-list">
                <div
                  v-for="(ch, ci) in getCartSetMealChildren(c)"
                  :key="(ch.id || '') + '_' + ci"
                  class="menu-cart-setmeal-item"
                >
                  <span class="menu-cart-setmeal-item-name">{{ getCartItemName(ch) }}</span>
                  <span class="menu-cart-setmeal-item-qty">x{{ ch.sl }}</span>
                  <span class="menu-cart-setmeal-item-add" v-if="Number(ch.addmomey || 0) > 0">+{{ MoneySymbol }}{{ formatCartMoney(ch.addmomey) }}</span>
                </div>
              </div>
            </div>
            <div class="menu-cart-main-bottom">
              <div class="menu-cart-price">{{ MoneySymbol }}{{ formatCartMoney(getCartSetMealTotalPrice(c)) }}</div>
              <div class="menu-cart-stepper" v-if="isWeightGoods(c)">
                <input
                  type="number"
                  inputmode="decimal"
                  step="0.05"
                  min="0"
                  max="999"
                  class="menu-cart-weight-qty-input"
                  :value="String(c.sl || 0)"
                  @focus.stop="onWeightInputFocus(c)"
                  @blur.stop.prevent="onCartWeightInputBlur(c, $event)"
                  @keydown="onCartWeightInputKeydown(c, $event)"
                />
                <span class="menu-cart-weight-unit">kg</span>
              </div>
              <div class="menu-cart-stepper" v-else>
                <div class="menu-cart-step-btn minus" @click.stop="changeCartQty(c, -1)">-</div>
                <div class="menu-cart-step-qty">{{ c.sl }}</div>
                <div class="menu-cart-step-btn plus" @click.stop="changeCartQty(c, 1)">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="menu-cart-empty">{{$lang[pickxb].l22}}</div>

      <div v-if="DeskID === 'Food' && cartDisplayList.length" class="menu-food-form">
		<div class="menu-food-tabs" v-if="FoodState!=1&&FoodState!=2">
		  <div :class="{ active: foodzt === 0 }" @click="foodzt = 0">{{foodlist[pickxb].on1}}</div>
		  <div :class="{ active: foodzt === 1 }" @click="foodzt = 1">{{foodlist[pickxb].on2}}</div>
		</div>
        <div class="menu-food-inputs">
		  <div class="menu-food-time">
		    <span>{{ foodzt === 0 ? foodlist[pickxb].on7 : foodlist[pickxb].on8 }}</span>
		    <div class="menu-time-selects">
		      <select v-model="selectedDate" class="menu-time-date">
		        <option v-for="date in dateOptions" :key="date.value" :value="date.value">{{ date.label }}</option>
		      </select>
		      <select v-model="selectedTime" class="menu-time-time">
		        <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
		      </select>
		    </div>
		  </div>
		  <div class="sblw" v-if="ShopID=='2605261454'">
			  Onze openingstijden:<br/>
			  Maandag gesloten (m.u.v. feestdagen)<br/>
			  Dinsdag t/m zaterdag: 16:00 - 20:00 <br/>
			  Zondag: 12:00 - 20:00<br/>
			  info@kanpei.nl
		  </div>
          <div class="menu-food-input-item">
            <span class="menu-food-input-label">※</span>
            <input type="text" :placeholder="foodlist[pickxb].on3" v-model="foods.name" />
          </div>
          <div class="menu-food-input-item">
            <span class="menu-food-input-label">※</span>
            <input type="text" :placeholder="foodlist[pickxb].on4" v-model="foods.phone" />
          </div>
          <div v-if="foodzt === 1" class="menu-food-input-item">
            <span class="menu-food-input-label">★</span>
            <input type="text" :placeholder="foodlist[pickxb].on5" v-model="foods.youb" />
          </div>
          <div v-if="foodzt === 1" class="menu-food-input-item">
            <span class="menu-food-input-label">※</span>
            <input type="text" :placeholder="foodlist[pickxb].on6" v-model="foods.dizi" />
          </div>
          <div v-if="foodzt === 0 && isOnlinePayEnabled" class="menu-food-input-item">
            <span class="menu-food-input-label">※</span>
            <input type="text" :placeholder="foodlist[pickxb].on5" v-model="foods.youb" />
          </div>
          <div v-if="foodzt === 0 && isOnlinePayEnabled" class="menu-food-input-item">
            <span class="menu-food-input-label">❤</span>
            <input type="number" inputmode="decimal" :placeholder="foodlist[pickxb].on12" v-model="tipMoney" @blur="saveTipMoney" />
          </div>
          <div v-if="foodzt === 0 && isOnlinePayEnabled" class="menu-food-tip-quick">
            <span></span>
            <div class="menu-food-tip-quick-list">
              <div class="menu-food-tip-quick-item" @click="applyQuickTip(1)">{{MoneySymbol}}{{getQuickTipAmount(1).toFixed(2)}}</div>
              <div class="menu-food-tip-quick-item" @click="applyQuickTip(3)">{{MoneySymbol}}{{getQuickTipAmount(3).toFixed(2)}}</div>
              <div class="menu-food-tip-quick-item" @click="applyQuickTip(5)">{{MoneySymbol}}{{getQuickTipAmount(5).toFixed(2)}}</div>
              <div class="menu-food-tip-quick-item" @click="applyQuickTip(10)">{{MoneySymbol}}{{getQuickTipAmount(10).toFixed(2)}}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isOnlinePayEnabled && cartDisplayList.length" class="menu-food-fee-summary">
        <div v-if="DeskID === 'Food'" class="menu-food-fee-item">
          <span>{{foodlist[pickxb].on13}}({{pickn[pickxb].hs}})</span>
          <span>{{MoneySymbol}}{{cartTotal.toFixed(DecimalBit)}}</span>
        </div>
        <div v-if="DeskID === 'Food'" class="menu-food-fee-item">
          <span>{{foodlist[pickxb].on12}}</span>
          <span>{{MoneySymbol}}{{getTipAmount().toFixed(DecimalBit)}}</span>
        </div>
        <div v-if="DeskID === 'Food'" class="menu-food-fee-item">
          <span>{{foodlist[pickxb].on14}}</span>
          <span>{{MoneySymbol}}{{getServiceFee().toFixed(2)}}</span>
        </div>
        <div v-if="DeskID === 'Food'" class="menu-food-fee-item">
          <span>{{foodlist[pickxb].on15}}</span>
          <span>{{MoneySymbol}}{{getPackingFee().toFixed(2)}}</span>
        </div>
        <div class="menu-food-fee-item clickable" @click="openCouponDialog">
          <span>{{ $lang[pickxb].l67 }}</span>
          <span class="menu-food-fee-link">{{ getCouponEntryText() }}</span>
        </div>
        <div v-if="getCouponDiscount() > 0" class="menu-food-fee-item discount">
          <span>{{ $lang[pickxb].l68 }}</span>
          <span class="menu-food-fee-discount">-{{MoneySymbol}}{{getCouponDiscount().toFixed(DecimalBit)}}</span>
        </div>
      </div>

      <div class="menu-cart-bottom" v-if="cartDisplayList.length">
        <div class="menu-cart-bottom-left">
          <div class="menu-cart-selectall" @click="toggleSelectAll">
            <span class="menu-cart-check small" :class="{ on: cartAllSelected }"></span>
            <span class="menu-cart-selectall-text">{{$lang[pickxb].l19}}</span>
          </div>
          <div class="menu-cart-subtotal-value">{{ MoneySymbol }}{{ (isOnlinePayEnabled ? getOrderTotal() : cartTotal).toFixed(DecimalBit) }}</div>
        </div>
        <div class="menu-cart-checkout-btn" :class="{ disabled: orderSubmitting }" @click="openCartOrderConfirm">{{$lang[pickxb].l20}}</div>
      </div>

      <div v-if="couponDialogVisible" class="menu-cart-del-mask" @click="closeCouponDialog">
        <div class="menu-coupon-dialog" @click.stop>
          <div class="menu-coupon-title">{{ $lang[pickxb].l65 }}</div>
          <div class="menu-coupon-subtitle" v-if="getCouponLimitCount() > 0">{{ $lang[pickxb].l81 }}{{ getCouponLimitCount() }}</div>
          <div v-if="memberCouponList.length" class="menu-coupon-list">
            <div
              v-for="(coupon, index) in memberCouponList"
              :key="getCouponRowKey(coupon, index)"
              class="menu-coupon-item"
              :class="{ active: isCouponSelected(coupon, index), disabled: !isCouponAvailable(coupon, getOrderTotalBeforeCoupon()) }"
              @click="toggleCouponSelect(coupon, index)"
            >
              <div class="menu-coupon-item-main">
                <div class="menu-coupon-item-name">{{ getCouponRowName(coupon, index) }}</div>
                <div class="menu-coupon-item-desc">{{ getCouponStatusText(coupon) }}</div>
              </div>
              <div class="menu-coupon-item-side">
                <div class="menu-coupon-item-money">-{{MoneySymbol}}{{getCouponAmount(coupon).toFixed(DecimalBit)}}</div>
                <div class="menu-coupon-item-check">{{ isCouponSelected(coupon, index) ? $lang[pickxb].l76 : $lang[pickxb].l77 }}</div>
              </div>
            </div>
          </div>
          <div v-else class="menu-coupon-empty">{{ memberDisplayName ? $lang[pickxb].l62 : $lang[pickxb].l63 }}</div>
          <div class="menu-coupon-actions">
            <div class="menu-coupon-btn secondary" @click="clearCouponSelection">{{ $lang[pickxb].l64 }}</div>
            <div class="menu-coupon-btn primary" @click="closeCouponDialog">{{ $lang[pickxb].l69 }}</div>
          </div>
        </div>
      </div>

      <div v-if="remarkVisible" class="menu-cart-remark-mask" @click="closeRemark">
        <div class="menu-cart-remark-dialog" @click.stop>
          <div class="menu-cart-remark-title">{{$lang[pickxb].l13}}</div>
          <textarea v-model="remarkText" class="menu-cart-remark-input" :placeholder="$lang[pickxb].l13"></textarea>
          <div class="menu-cart-remark-actions">
            <div class="menu-cart-remark-btn menu-cart-remark-cancel" @click="closeRemark">{{$lang[pickxb].l16}}</div>
            <div class="menu-cart-remark-btn menu-cart-remark-ok" @click="saveRemark">{{$lang[pickxb].l15}}</div>
          </div>
        </div>
      </div>

      <div v-if="cartDeleteVisible" class="menu-cart-del-mask" @click="closeCartDeleteConfirm">
        <div class="menu-cart-del-dialog" @click.stop>
          <div class="menu-cart-del-title">{{$lang[pickxb].l17}}</div>
          <div class="menu-cart-del-text">{{$lang[pickxb].l21}}？</div>
          <div class="menu-cart-del-actions">
            <div class="menu-cart-del-btn cancel" @click="closeCartDeleteConfirm">{{$lang[pickxb].l16}}</div>
            <div class="menu-cart-del-btn ok" @click="confirmCartDelete">{{$lang[pickxb].l15}}</div>
          </div>
        </div>
      </div>

      <div v-if="cartOrderVisible" class="menu-cart-del-mask" @click="closeCartOrderConfirm">
        <div class="menu-cart-del-dialog" @click.stop>
          <div class="menu-cart-del-title">{{$lang[pickxb].l17}}</div>
          <div class="menu-cart-del-text">{{ cartOrderConfirmText }}</div>
          <div class="menu-cart-del-actions">
            <div v-if="!cartOrderTipMode" class="menu-cart-del-btn cancel" @click="closeCartOrderConfirm">{{$lang[pickxb].l16}}</div>
            <div class="menu-cart-del-btn ok" @click="confirmCartOrder">{{ cartOrderTipMode ? $lang[pickxb].l12 : $lang[pickxb].l15 }}</div>
          </div>
        </div>
      </div>

      <div v-if="orderLoadingVisible" class="menu-cart-order-loading">
        <div class="menu-cart-order-loading-dialog">
          <div class="menu-cart-order-loading-text">{{ orderLoadingText }}</div>
        </div>
      </div>

      <div v-if="payLoading" class="menu-pay-loading-mask" @touchmove.prevent>
        <div class="menu-pay-loading-panel">
          <div class="menu-pay-loading-spinner"></div>
          <div class="menu-pay-loading-text">Checking payment result...</div>
          <div class="menu-pay-loading-cancel" @click="cancelPay">{{$lang[pickxb].l16}}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Menu',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      ShopID: '',
      DeskID: '',
      shopName: 'Restaurant',
      deskName: 'A01',
      shopIntro: '',
      shopPhone: '',
      diningMinutes: 0,
      dineStartTime: '',
      dineEndTime: '',
      introVisible: true,
      introBannerSeed:0,
      pickxb: 0,
      pickindex: 0,
      pickData: [],
      WXLangGoodsxb: 0,
      WXLangGoods: {},
      searchText: '',
      logoSrc: '',
      bannerPics: [],
      bannerTimer: null,
      currentBannerIndex: 0,
      isMadeDepotEnabled: false,
      madeDepotList: [],
      activeMadeDepotId: '',
      searchRestoreCategoryId: '',
      searchRestoreMadeDepotId: '',
      searchAddToastVisible: false,
      searchAddToastText: '添加成功',
      searchAddToastTimer: null,
      menuTypes: [],
      goodsList: [],
      activeCategoryId: '',
      categoryImageErrorMap: {},
      goodsImageErrorMap: {},
      cartList: [],
      cartVisible: false,
      bodyOverflowBackup: null,
      MoneySymbol: '$',
	  IsNewGoodsRemark:false,
      IsBuffet: 0,
      IsBuffetzt: false,
      BuffetTypeID: '',
      Numberpoints: 0,
      DeskMin: '0',
      deskTimer: null,
      DecimalBit: 2,
      remarkVisible: false,
      remarkText: '',
      remarkTargetId: '',
      cartDeleteVisible: false,
      cartOrderVisible: false,
      cartOrderTipMode: false,
      cartOrderConfirmText: '',
      orderSubmitting: false,
      orderLoadingVisible: false,
      orderLoadingText: '',
      orderPollTimer: null,
      VipState:0,
      goodsViewMode: 1,
      flyBalls: [],
      scrollSyncRaf: 0,
      categoryScrollLockUntil: 0,
      flyBallSeed: 1,
      setMealVisible: false,
      setMealLoading: false,
      setMealKind: 'fixed',
      setMealGoods: null,
      setMealFixedList: [],
      setMealOptionalGroups: [],
      setMealRemarkList: [],
      setMealRemarkGroups: [],
      setMealUnitList: [],
      setMealUnitIndex: 0,
      weightQuickList: [0.25, 0.5, 0.75, 1, 1.5, 2],
      setMealQty: 1,
      setMealAlertVisible: false,
      setMealAlertTitle: '提示',
      setMealAlertText: '',
      topFixedHeight: 0,
      fallbackMenuTypes: [
        { typeId: 'f1', TypeName: 'Combo' },
        { typeId: 'f2', TypeName: 'Special' },
        { typeId: 'f3', TypeName: 'Snack' },
        { typeId: 'f4', TypeName: 'Drink' }
      ],
      swiperOption: {
        loop: false,
        observeParents: true,
        observer: true,
        on: {
          slideChangeTransitionEnd: () => {
            this.handleBannerChange()
          }
        }
      },
      swiperOptionIntro: {
        observeParents: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      },
      foodzt: 0,
      memberLoginVisible: false,
      memberRegisterVisible: false,
      memberLogoutVisible: false,
      memberLoginForm: {
        email: '',
        password: ''
      },
      memberRegisterForm: {
        userName: '',
        email: '',
        verifyCode: '',
        password: ''
      },
      memberRegisterCodeSeconds: 0,
      memberRegisterCodeTimer: null,
      memberRegisterCodeSending: false,
      memberLoginLoading: false,
      memberRegisterLoading: false,
      memberDisplayName: '',
      memberSN: '',
      memberBalance: 0,
      memberCouponList: [],
      memberCouponMaxQua: 0,
      selectedCouponKeys: [],
      couponDialogVisible: false,
      foods: {
        name: '',
        phone: '',
        youb: '',
        dizi: ''
      },
      data_f: '',
      dateOptions: [],
      timeOptions: [],
      selectedDate: '',
      selectedTime: '',
      PayState: '',
	  FoodState:'',
      tipMoney: '',
      payLoading: false,
      paydata: {},
      PAYSTATE_YABAND: '5',
      PAYSTATE_ALLINPAY: '7',
      PAYCHANNEL_YABAND: 'yabandpay',
      PAYCHANNEL_ALLINPAY: 'allinpay',
      PayChannel: 'yabandpay',
      allinpayCusid: '',
      allinpayAppid: '',
      allinpayBaseUrl: 'https://syb.allinpay.com/apiweb',
      _payToken: null,
      _payWindow: null,
      paygettime: null,
      paySubmitLockTradeId: '',
      foodlist: [
        {on1:"自取",on2:"外賣",on3:"姓名",on4:"电话",on5:"邮编",on6:"地址",on7:"取餐时间",on8:"到达时间",on9:"选项必选",on10:"固定套餐",on11:"可选套餐选项",on12:"小费",on13:"菜品价格",on14:"服务费",on15:"打包费"},
        {on1:"自取",on2:"外賣",on3:"姓名",on4:"電話",on5:"郵編",on6:"地址",on7:"取餐時間",on8:"送達時間",on9:"選項必選",on10:"固定選項",on11:"套餐可選選項",on12:"小费",on13:"菜品价格",on14:"服务费",on15:"打包费"},
        {on1:"Pick Up",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"e-mail",on6:"Address",on7:"Pick Up At:",on8:"ETA",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"الذاتي",on2:"توصيل",on3:"اسم",on4:"هاتف",on5:"الرمز البريدي",on6:"تبوك",on7:"حان الوقت للمتجر",on8:"وقت الوصول",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"إكرامية",on13:"سعر الطبق",on14:"رسوم الخدمة",on15:"رسوم التغليف"},
        {on1:"លើកឡើង",on2:"ការដឹកជញ្ជូន",on3:"ឈ្មោះ",on4:"ទូរស័ព្ទ",on5:"លេខកូដប្រៃសណីយ៍",on6:"អាសយដ្ឋាន",on7:"ពេលវេលាមកដល់",on8:"ពេលវេលានៃការមកដល់",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Comida para llevar con recogida propia",on2:"Comida al domicilio",on3:"Nombre",on4:"Telefono",on5:"Código postal",on6:"Dirección",on7:"Tiempo de llegada al restaurante",on8:"Hora de la llegada",on9:"Opción obligatoria",on10:"Paquete fijo",on11:"Opciones de paquete opcionales",on12:"Propina",on13:"Precio del plato",on14:"Tarifa de servicio",on15:"Tarifa de embalaje"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Afhaal",on2:"AFHALEN",on3:"Naam",on4:"Telefoonnummer",on5:"e-mail",on6:"Adres",on7:"Ophaaltijd",on8:"Aankomsttijd",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Fooi",on13:"Gerechtprijs",on14:"Servicekosten",on15:"Verpakkingskosten"},
        {on1:"Retrait en magasin",on2:"Livraison",on3:"Nom",on4:"Téléphone",on5:"Code postal",on6:"Adresse",on7:"Heure de retrait",on8:"Heure d'arrivée",on9:"Option obligatoire",on10:"Menu fixe",on11:"Options de menu",on12:"Pourboire",on13:"Prix du plat",on14:"Frais de service",on15:"Frais d'emballage"},
        {on1:"Ritiro ordine in negozio",on2:"Consegna a domicilio ",on3:"Nome",on4:"Cellulare",on5:"Codice postale",on6:"Indirizzo",on7:"Orario di ritiro",on8:"Ora di consegna",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Mancia",on13:"Prezzo piatto",on14:"Costo servizio",on15:"Costo imballaggio"},
        {on1:"テイクアウト",on2:"デリバリー",on3:"お名前",on4:"お電話番号",on5:"郵便番号",on6:"ご住所",on7:"到着時間",on8:"配達時間",on9:"選択必須",on10:"選択不可",on11:"お選びください",on12:"チップ",on13:"料理価格",on14:"サービス料",on15:"包装料"},
        {on1:"Retirada",on2:"Entrega",on3:"Nome",on4:"Telefone",on5:"CEP",on6:"Endereço",on7:"Horário de retirada",on8:"Horário de entrega",on9:"Opções obrigatórias",on10:"Combo fixo",on11:"Opções do combo",on12:"Gorjeta",on13:"Preço do prato",on14:"Taxa de serviço",on15:"Taxa de embalagem"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Selbstabholung",on2:"Lieferung",on3:"Name",on4:"Telefonnummer",on5:"Postleitzahl (PLZ)",on6:"Adresse",on7:"Ankunftszeit im Restaurant",on8:"Lieferzeit",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Trinkgeld",on13:"Gerichtpreis",on14:"Servicegebühr",on15:"Verpackungsgebühr"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Self mention",on2:"Delivery",on3:"Name",on4:"Telephone",on5:"Zip code",on6:"address",on7:"Arrival time in the store",on8:"Delivery time of takeout",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"pengambilan mandiri",on2:"pengiriman",on3:"nama",on4:"telepon",on5:"kode pos",on6:"alamat",on7:"waktu kedatangan",on8:"kedatangan waktu",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Harga makanan",on14:"Biaya layanan",on15:"Biaya kemasan"},
        {on1:"หยิบ",on2:"จัดส่ง",on3:"ชื่อ",on4:"โทรศัพท์",on5:"รหัสไปรษณีย์",on6:"ที่อยู่",on7:"เวลามาถึง",on8:"เวลามาถึง",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"ทิป",on13:"ราคาอาหาร",on14:"ค่าบริการ",on15:"ค่าบรรจุภัณฑ์"},
        {on1:"Σηκώνω",on2:"Διανομή",on3:"Ονομα",on4:"Τηλέφωνο",on5:"ταχυδρομικός κώδικας",on6:"διεύθυνση",on7:"Ώρα άφιξης",on8:"Ώρα άφιξης",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Φιλοδώρημα",on13:"Τιμή πιάτου",on14:"Χρέωση υπηρεσίας",on15:"Χρέωση συσκευασίας"},
        {on1:"Self-Pickup",on2:"Dostava",on3:"Ime in priimek",on4:"GSM",on5:"Poštna št.",on6:"Naslov",on7:"Čas prihoda",on8:"Čas dostave",on9:"选项必选",on10:"固定套餐",on11:"可选套餐选项",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Self-Pickup",on2:"Delivery",on3:"Name and Surname",on4:"Cell Phone",on5:"Postcode",on6:"Address",on7:"Arrival Time",on8:"Delivery Time",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Öz-özünə götürmə",on2:"Çatdırılma",on3:"",on4:"Ad",on5:"poçt kodu",on6:"ünvan",on7:"Gəliş vaxtı",on8:"Gəliş vaxtı",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Bəxşiş",on13:"Yemək qiyməti",on14:"Xidmət haqqı",on15:"Qablaşdırma haqqı"},
        {on1:"ကိုယ်တိုင်လာယူခြင်း",on2:"ပို့ဆောင်ခြင်း",on3:"အမည်",on4:"ဖုန်းနံပါတ်",on5:"ဇစ်ကုဒ်",on6:"လိပ်စာ",on7:"ရောက်ရှိချိန်",on8:"ရောက်ရှိချိန်",on9: "ရွေးချယ်စရာလိုအပ်ပါတယ်", on10: "ပုံမှန်အစီအစဉ်", on11: "ရွေးချယ်စရာအစီအစဉ်ရွေးချယ်စရာများ",on12:"Tip",on13:"Dish Price",on14:"Service Fee",on15:"Packing Fee"},
        {on1:"Kendin al",on2:"Teslimat",on3:"İsim",on4:"Telefon numarası",on5:"Posta kodu",on6:"Adres",on7:"Varış saati",on8:"Varış saati",on9: "Seçenekler zorunlu", on10: "Sabit paketler", on11: "İsteğe bağlı paketler",on12:"Bahşiş",on13:"Yemek fiyatı",on14:"Servis ücreti",on15:"Paket ücreti"},
        {on1:"Өөрөө авах",on2:"Хүргэлт",on3:"Нэр",on4:"Утас",on5:"шуудангийн код",on6:"Хаяг",on7:"Ирэх цаг",on8:"Ирэх цаг",on9:"Options must be selected",on10:"Fixed options",on11:"Optional Options",on12:"Гар цай",on13:"Хоолны үнэ",on14:"Үйлчилгээний төлбөр",on15:"Савлагааны төлбөр"}
      ],
      pickn: [
        {dw:"份起",qb:"全部",hs:"含税",qsr:"请输入",bzxx:"自定义备注",qsrbz:"请输入备注",bz:"备注",qx:"全选",hj:"合计",xd:"下单"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"請輸入",bzxx:"自定义备注",qsrbz:"請輸入備註",bz:"備註",qx:"全選",hj:"合計",xd:"下單"},
        {dw:"share",qb:"All",hs:"Tax",qsr:"Input",bzxx:"Note",qsrbz:"Special Instruction",bz:"note",qx:"Subtotal",hj:"Total",xd:"Place Order"},
        {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"تفضل",bzxx:"ملاحظة مخصصة",qsrbz:"الرجاء إدخال الملاحظات",bz:"ملاحظة",qx:"اختر الكل",hj:"المجموع",xd:"ترتيب"},
        {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"សូមបញ្ចូល",bzxx:"កំណត់ចំណាំផ្ទាល់ខ្លួន",qsrbz:"សូមបញ្ចូលកំណត់ចំណាំ",bz:"ចំណាំ",qx:"ជ្រើសរើស​ទាំងអស់",hj:"សរុប",xd:"ដាក់បញ្ជា"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Tecle por favor",bzxx:"Observación",qsrbz:"Tecle por favor Observación",bz:"Observación",qx:"Seleccionar todo",hj:"En total",xd:"Hacer el pedido"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"BTW ",qsr:"Invullen",bzxx:"aangepaste notities",qsrbz:"Voer een notitie in",bz:"Opmerking",qx:"Alles selecteren",hj:"Totaal",xd:"Bestelling plaatsen"},
        {dw:"Qua",qb:"Tout",hs:"Taxes incluses",qsr:"Veuillez saisir",bzxx:"Remarques personnalisées",qsrbz:"Veuillez saisir des remarques",bz:"Remarques",qx:"Sélectionner tout",hj:"Total",xd:"Passer commande"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"prego entra",bzxx:"Note",qsrbz:"Si prega di inserire una nota",bz:"Note",qx:"seleziona tutto",hj:"Totale",xd:"Conferma ordine"},
        {dw:"本~",qb:"すべて",hs:"税込",qsr:"商品名検索",bzxx:"備考",qsrbz:"備考",bz:"備考",qx:"全て選択",hj:"合計",xd:"送信"},
        {dw:"unidade",qb:"Todos",hs:"Taxa incluída",qsr:"Digite",bzxx:"Observação personalizada",qsrbz:"Digite uma observação",bz:"Observação",qx:"Selecionar tudo",hj:"Total",xd:"Fazer pedido"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Bitte eingeben",bzxx:"Benutzerdefinierte Notizen",qsrbz:"Bitte geben Sie einen Kommentar ein",bz:"Bemerkung",qx:"Alles ausw?hlen",hj:"Gesamt",xd:"Bestellen"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Prosz? wpisa?",bzxx:"Pe?na pojedyncza nuta",qsrbz:"Prosz? wpisa? notatk?",bz:"Uwaga",qx:"Zaznacz wszystko",hj:"Ca?kowity",xd:"Z?o?y? zamówienie"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter the",bzxx:"Note information",qsrbz:"Please enter remarks",bz:"note",qx:"select all",hj:"A combined",xd:"Place the order"},
        {dw:"份起",qb:"全部",hs:"含税",qsr: "Silakan masukkan", bzxx: "Keterangan yang disesuaikan", qsrbz: "Silakan masukkan keterangan", bz: "Keterangan", qx: "Pilih semua", hj: "Total", xd: "Lakukan pemesanan"},
        {bh:"税前",dw:"份起",qb:"全部",hs:"含税",qsr:"กรุณาเข้า",bzxx:"บันทึกที่กำหนดเอง",qsrbz:"กรุณาใส่ข้อสังเกต",bz:"หมายเหตุ",qx:"เลือกทั้งหมด",hj:"ทั้งหมด",xd:"สั่งซื้อ"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Παρακαλ? εισ?γετε",bzxx:"Προσαρμοσμ?νε? σημει?σει?",qsrbz:"Παρακαλ? εισ?γετε παρατηρ?σει?",bz:"Παρατ?ρηση",qx:"Επιλ?ξτε ?λα",hj:"σ?νολο",xd:"Κ?ντε μια παραγγελ?α"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Prosimo, vpi?ite ...",bzxx:"Opombe po meri",qsrbz:"Vnesite komentar",bz:"Opombe",qx:"Izberite Vse",hj:"Skupaj",xd:"Oddate naro?ilo"},
        {dw:"份起",qb:"全部",hs:"含税",qsr:"Please enter",bzxx:"Custom remarks",qsrbz:"Please enter remarks",bz:"Notes",qx:"Select All",hj:"Total",xd:"Place Your Order"},
        {dw:"~",qb:"all",hs:"tax",qsr:"Zəhmət olmasa daxil edin",bzxx:"Xüsusi ehtiyat nüsxəsi",qsrbz:"Zəhmət olmasa, qeyd daxil edin.",bz:"Qeyd",qx:"Hamısını Seçin",hj:"cəmi",xd:"Sifariş verin"},
        {dw:"စာရင်း",qb:"အားလုံး",hs:"အခွန်ပါဝင်",qsr:"ထည့်ပါ",bzxx: "စိတ်ကြိုက်မှတ်ချက်",qsrbz:"မှတ်ချက်ထည့်ပါ",bz:"မှတ်ချက်",qx:"အားလုံးရွေးချယ်ပါ",hj:"စုစုပေါင်း",xd:"စာရင်း"},
        {dw:"adetten itibaren",qb:"tümü",hs:"kdv dahil",qsr:"lütfen girin",bzxx:"özel not",qsrbz:"lütfen not girin",bz:"not",qx:"hepsini seç",hj:"toplam",xd:"sipariş verin"},
        {dw:"share",qb:"All",hs:"Tax",qsr:"Оруулна уу",bzxx:"Захиалгат тэмдэглэл",qsrbz:"Тэмдэглэл оруулна уу.",bz:"Тайлбар",qx:"Бүгдийг сонгох",hj:"нийт",xd:"Захиалга өгөх"}
      ]
    }
  },
  mounted() {
    this.ShopID = this.$route.query.ShopID || this.$route.query.Shopid || ''
    this.DeskID = this.$route.query.id || this.$route.query.DeskID || ''
    this.PayState = (this.$route.query.PayState !== undefined && this.$route.query.PayState !== null) ? String(this.$route.query.PayState) : ''
    this.FoodState = this.$route.query.FoodState || ''
    // 路由 PayState -> 对应 PayChannel：PayState=5 => YabandPay；PayState=7 => Allinpay
    const ps = String(this.PayState || '').trim()
    if (ps === String(this.PAYSTATE_ALLINPAY)) {
      this.PayChannel = this.PAYCHANNEL_ALLINPAY
    } else if (ps === String(this.PAYSTATE_YABAND)) {
      this.PayChannel = this.PAYCHANNEL_YABAND
    } else {
      this.PayChannel = this.PAYCHANNEL_YABAND
    }
    // 路由里如果显式传了 PayChannel 参数则覆盖（兜底兼容）
    const pc = this.$route.query.PayChannel
    if (pc && String(pc).trim().length) {
      const pcn = String(pc).trim().toLowerCase()
      if (pcn === this.PAYCHANNEL_ALLINPAY) this.PayChannel = this.PAYCHANNEL_ALLINPAY
      if (pcn === this.PAYCHANNEL_YABAND) this.PayChannel = this.PAYCHANNEL_YABAND
    }
    this.deskName = this.DeskID
    this.logoSrc = this.getAssetUrl('/Logo/logo.png')
    this.bannerPics = [1, 2, 3].map(index => this.getAssetUrl('/PicWeb/p' + index + '.jpg'))
	if(this.ShopID=='2605261454'){
	  this.goodsViewMode=3
	}
    this.restoreGoodsViewMode()
    this.refreshCartFromStorage()
    if (this.$route.query.skipIntro === '1') {
      this.introVisible = false
      try {
        this.$router.replace({ query: { ...this.$route.query, skipIntro: undefined } })
      } catch (e) {}
    }
    try {
      const storedIsBuffet = localStorage.getItem(this.ShopID + '_IsBuffet')
      const storedBuffetTypeID = localStorage.getItem(this.ShopID + '_BuffetTypeID')
      const storedNumberpoints = localStorage.getItem(this.ShopID + '_Numberpoints')
      if (storedIsBuffet !== null) {
        this.IsBuffet = Number(storedIsBuffet)
        this.IsBuffetzt = Number(storedIsBuffet)
      }
      if (storedBuffetTypeID !== null) {
        this.BuffetTypeID = storedBuffetTypeID
      }
      if (storedNumberpoints !== null) {
        this.Numberpoints = Number(storedNumberpoints)
      }
      const storedTipMoney = localStorage.getItem(this.ShopID + '_tipMoney')
      if (storedTipMoney !== null) {
        this.tipMoney = storedTipMoney
      }
    } catch (e) {}
    this.$nextTick(() => {
      this.updateTopFixedHeight()
    })
    setTimeout(() => {
      this.updateTopFixedHeight()
    }, 0)
    setTimeout(() => {
      this.updateTopFixedHeight()
    }, 200)
    window.addEventListener('resize', this.updateTopFixedHeight)
    window.addEventListener('scroll', this.onGoodsScroll, true)
    this.$nextTick(() => {
      this.initBannerAutoplay()
      this.onGoodsScroll()
    })
    setTimeout(() => {
      this.onGoodsScroll()
    }, 300)

    if (this.ShopID) {
      this.restoreMemberSessionCache()
      this.restoreMemberCouponData()
      this.loadLangConfig()
      this.loadShopInfo()
      this.loadMenuTypes()
    }
    if (this.ShopID && this.DeskID && this.DeskID !== 'Food') {
      this.loadDeskInfo()
    } else if (this.ShopID) {
      this.loadGoods()
    }
    this.initDateTimeOptions()
  },
  beforeDestroy() {
    this.clearBannerAutoplay()
    if (this.searchAddToastTimer) {
      clearTimeout(this.searchAddToastTimer)
      this.searchAddToastTimer = null
    }
    if (this.deskTimer) {
      clearInterval(this.deskTimer)
      this.deskTimer = null
    }
    if (this.memberRegisterCodeTimer) {
      clearInterval(this.memberRegisterCodeTimer)
      this.memberRegisterCodeTimer = null
    }
    window.removeEventListener('resize', this.updateTopFixedHeight)
    window.removeEventListener('scroll', this.onGoodsScroll, true)
    this.stopOrderPoll()
    this.cancelPay()
    this.lockBodyScroll(false)
  },
  computed: {
    resolvedOnlinePayChannel() {
      const ps = String(this.PayState || '').trim()
      if (ps === String(this.PAYSTATE_ALLINPAY)) return this.PAYCHANNEL_ALLINPAY
      if (ps === String(this.PAYSTATE_YABAND)) return this.PAYCHANNEL_YABAND
      const pc = String(this.PayChannel || '').trim()
      if (pc === this.PAYCHANNEL_ALLINPAY) return this.PAYCHANNEL_ALLINPAY
      return this.PAYCHANNEL_YABAND
    },
    isOnlinePayEnabled() {
      const ps = String(this.PayState || '').trim()
      return ps === String(this.PAYSTATE_YABAND) || ps === String(this.PAYSTATE_ALLINPAY)
    },
    introLangList() {
      if (Array.isArray(this.pickData) && this.pickData.length) {
        return this.pickData
      }
      return [
        { label: '简体中文', id: 1, index: 1 },
        { label: 'English', id: 3, index: 2 },
        { label: 'Other', id: 0, index: 3 }
      ]
    },
    displayBannerPics() {
      if (this.bannerPics.length > 1) {
        return [this.bannerPics[this.bannerPics.length - 1]].concat(this.bannerPics, this.bannerPics[0])
      }
      return this.bannerPics
    },
    displayMenuTypes() {
      if (!this.menuTypes.length) {
        return this.isMadeDepotEnabled ? [] : this.fallbackMenuTypes
      }
      let list = this.menuTypes
      if (!this.isMadeDepotEnabled) {
        if (this.IsBuffet) {
          const goodsList = Array.isArray(this.goodsList) ? this.goodsList : []
          const typeIdSet = {}
          for (let i = 0; i < goodsList.length; i++) {
            const item = goodsList[i]
            if (item && item.TypeID) {
              typeIdSet[String(item.TypeID)] = true
            }
          }
          list = list.filter(v => v && typeIdSet[String(v.TypeID || v.typeId)])
        }
        return list
      }
      if (!(this.madeDepotList && this.madeDepotList.length)) {
        if (this.IsBuffet) {
          const goodsList = Array.isArray(this.goodsList) ? this.goodsList : []
          const typeIdSet = {}
          for (let i = 0; i < goodsList.length; i++) {
            const item = goodsList[i]
            if (item && item.TypeID) {
              typeIdSet[String(item.TypeID)] = true
            }
          }
          list = list.filter(v => v && typeIdSet[String(v.TypeID || v.typeId)])
        }
        return list
      }
      const depotId = this.activeMadeDepotId
      if (depotId === undefined || depotId === null || String(depotId) === '') {
        if (this.IsBuffet) {
          const goodsList = Array.isArray(this.goodsList) ? this.goodsList : []
          const typeIdSet = {}
          for (let i = 0; i < goodsList.length; i++) {
            const item = goodsList[i]
            if (item && item.TypeID) {
              typeIdSet[String(item.TypeID)] = true
            }
          }
          list = list.filter(v => v && typeIdSet[String(v.TypeID || v.typeId)])
        }
        return list
      }
      let filtered = (Array.isArray(list) ? list : []).filter(v => v && String(v.MadeDepotID) === String(depotId))
      if (this.IsBuffet) {
        const goodsList = Array.isArray(this.goodsList) ? this.goodsList : []
        const typeIdSet = {}
        for (let i = 0; i < goodsList.length; i++) {
          const item = goodsList[i]
          if (item && item.TypeID) {
            typeIdSet[String(item.TypeID)] = true
          }
        }
        filtered = filtered.filter(v => v && typeIdSet[String(v.TypeID || v.typeId)])
      }
      return filtered
    },
    filteredGoods() {
      const keyword = (this.searchText || '').trim().toLowerCase()
      const useFlatMode = !this.isMadeDepotEnabled && !keyword
      const activeCat = this.activeCategoryId
      const types = Array.isArray(this.displayMenuTypes) ? this.displayMenuTypes : []
      const typeIdSet = {}
      if (!this.isMadeDepotEnabled) {
        for (let i = 0; i < types.length; i++) {
          const t = types[i]
          if (!t) {
            continue
          }
          const tid = String(t.TypeID !== undefined ? t.TypeID : (t.typeId !== undefined ? t.typeId : ''))
          if (tid) {
            typeIdSet[tid] = true
          }
        }
      }
      return (Array.isArray(this.goodsList) ? this.goodsList : []).filter(item => {
        if (!item) {
          return false
        }
        if (item.IsEmpty === true || item.IsEmpty === 'true' || item.IsEmpty === 1 || item.IsEmpty === '1') {
          return false
        }
        if (!this.isMadeDepotEnabled && typeIdSet) {
          const tid = String(item && item.TypeID != null ? item.TypeID : '')
          if (!tid || !typeIdSet[tid]) {
            return false
          }
        }
        if (!keyword) {
          if (!useFlatMode && activeCat && item.TypeID != activeCat) {
            return false
          }
          return true
        }
        const text = [item.Goods, item.TwoGoods, item.ThreeGoods].filter(Boolean).join(' ').toLowerCase()
        return text.indexOf(keyword) > -1
      })
    },
    useCategoryFlatMode() {
      if (this.isMadeDepotEnabled) {
        return false
      }
      const keyword = (this.searchText || '').trim().toLowerCase()
      if (keyword) {
        return false
      }
      return true
    },
    flatCategoryGroups() {
      if (!this.useCategoryFlatMode) {
        return []
      }
      const types = Array.isArray(this.displayMenuTypes) ? this.displayMenuTypes : []
      const goods = Array.isArray(this.filteredGoods) ? this.filteredGoods : []
      const map = {}
      const order = []
      for (let i = 0; i < types.length; i++) {
        const t = types[i]
        if (!t) {
          continue
        }
        const tid = String(t.TypeID !== undefined ? t.TypeID : (t.typeId !== undefined ? t.typeId : ''))
        if (!tid) {
          continue
        }
        if (map[tid]) {
          continue
        }
        const title = this.getCategoryName(t)
        map[tid] = { typeId: tid, title: title || '', items: [] }
        order.push(tid)
      }
      for (let i = 0; i < goods.length; i++) {
        const item = goods[i]
        const tid = String(item && item.TypeID != null ? item.TypeID : '')
        if (!tid) {
          continue
        }
        if (!map[tid]) {
          continue
        }
        map[tid].items.push(item)
      }
      const result = []
      for (let i = 0; i < order.length; i++) {
        const group = map[order[i]]
        if (group && group.items && group.items.length) {
          result.push(group)
        }
      }
      return result
    },
    fallbackBanner() {
      return 'https://fun.hlwxsys.com/Data/' + this.ShopID + '/PicWeb/p1.jpg'
    },
    cartDisplayList() {
      const list = Array.isArray(this.cartList) ? this.cartList : []
      return list.filter(v => v && !(v.IsChild === 1 || v.IsChild === '1'))
    },
    cartCount() {
      const list = this.cartDisplayList
      let sum = 0
      for (let i = 0; i < list.length; i++) {
        const sl = Number(list[i] && list[i].sl ? list[i].sl : 0)
        if ((list[i] && list[i].zt) && isFinite(sl)) {
          sum += sl
          sum = this.roundQty(sum)
        }
      }
      return this.roundQty(sum)
    },
    cartAllSelected() {
      const list = this.cartDisplayList
      if (!list.length) {
        return false
      }
      for (let i = 0; i < list.length; i++) {
        if (!(list[i] && list[i].zt)) {
          return false
        }
      }
      return true
    },
    goodsQtyMap() {
      const list = this.cartDisplayList
      const map = {}
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        const id = row && row.id
        if (!id) {
          continue
        }
        if (this.isWeightGoods(row)) {
          continue
        }
        const sl = Number(row.sl || 0)
        if (!isFinite(sl) || sl <= 0) {
          continue
        }
        map[id] = (map[id] || 0) + sl
      }
      return map
    },
    goodsWeightMap() {
      const list = this.cartDisplayList
      const map = {}
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        const id = row && row.id
        if (!id) continue
        if (!this.isWeightGoods(row)) continue
        const sl = Number(row.sl || 0)
        if (!isFinite(sl) || sl <= 0) continue
        map[id] = String(sl)
      }
      return map
    },
    cartTotal() {
      const list = Array.isArray(this.cartList) ? this.cartList : []
      const displayList = this.cartDisplayList
      const rootIds = new Set()
      for (let i = 0; i < displayList.length; i++) {
        const id = displayList[i] && displayList[i].id
        if (id) {
          rootIds.add(String(id))
        }
      }
      let sum = 0
      for (let i = 0; i < list.length; i++) {
        if (!(list[i] && list[i].zt)) {
          continue
        }
        const isChild = list[i] && (list[i].IsChild === 1 || list[i].IsChild === '1')
        if (!isChild && !rootIds.has(String(list[i].id))) {
          continue
        }
        const sl = Number(list[i] && list[i].sl ? list[i].sl : 0)
        const momey = Number(list[i] && list[i].momey ? list[i].momey : 0)
        const addmomey = Number(list[i] && list[i].addmomey ? list[i].addmomey : 0)
        if (isFinite(sl) && isFinite(momey) && isFinite(addmomey)) {
          const line = this.roundQty(this.roundMoney(momey + addmomey) * this.roundQty(sl))
          sum = this.roundMoney(sum + line)
        }
      }
      return this.roundMoney(sum)
    },
    activeCategoryTitle() {
      const list = this.displayMenuTypes || []
      const id = this.activeCategoryId
      if (!list || !list.length) {
        return ''
      }
      const matched = list.find(item => {
        const tid = item && (item.TypeID || item.typeId)
        return tid != null && id != null && tid == id
      })
      const item = matched || list[0]
      return item ? this.getCategoryName(item) : ''
    },
    introHasDiningTime() {
      return !!(this.dineStartTime || this.dineEndTime || (this.diningMinutes > 0))
    },
    introDiningTimeText() {
      if (this.dineStartTime && this.dineEndTime) {
        return this.dineStartTime + ' - ' + this.dineEndTime
      }
      if (this.dineStartTime) {
        return this.dineStartTime
      }
      if (this.dineEndTime) {
        return this.dineEndTime
      }
      if (this.diningMinutes > 0) {
        return this.diningMinutes + ' min'
      }
      return ''
    },
    data_s() {
      if (this.selectedDate && this.selectedTime) {
        return this.selectedDate + ' ' + this.selectedTime + ':00'
      }
      return ''
    }
  },
  watch: {
    searchText(newVal, oldVal) {
      const next = String(newVal || '').trim()
      const prev = String(oldVal || '').trim()
      if (next && !prev) {
        this.searchRestoreCategoryId = this.activeCategoryId || ''
        this.searchRestoreMadeDepotId = this.activeMadeDepotId || ''
        return
      }
      if (!next && prev) {
        this.searchRestoreCategoryId = ''
        this.searchRestoreMadeDepotId = ''
      }
    },
    cartTotal() {
      this.syncSelectedCoupons()
    },
    tipMoney() {
      this.syncSelectedCoupons()
    }
  },
  methods: {
    openMemberLogin() {
      this.memberLoginVisible = true
    },
    openMemberLogoutConfirm() {
      this.memberLogoutVisible = true
      this.syncBodyScrollLock()
    },
    closeMemberLogoutConfirm() {
      this.memberLogoutVisible = false
      this.syncBodyScrollLock()
    },
    clearMemberCache() {
      this.memberDisplayName = ''
      this.memberSN = ''
      this.memberBalance = 0
      this.memberCouponList = []
      this.memberCouponMaxQua = 0
      this.selectedCouponKeys = []
      this.couponDialogVisible = false
      try {
        localStorage.removeItem(this.ShopID + '_memberDisplayName')
        localStorage.removeItem(this.getMemberCouponCacheKey())
        localStorage.removeItem(this.getMemberSessionCacheKey())
        localStorage.removeItem('member_email')
        localStorage.removeItem('member_password')
      } catch (e) {}
    },
    confirmMemberLogout() {
      this.clearMemberCache()
      this.closeMemberLogoutConfirm()
    },
    closeMemberLogin() {
      this.memberLoginVisible = false
      try {
        localStorage.removeItem('member_email')
        localStorage.removeItem('member_password')
      } catch (e) {}
    },
    openMemberRegister() {
      this.memberRegisterVisible = true
    },
    closeMemberRegister() {
      this.memberRegisterVisible = false
      this.stopMemberRegisterCodeCountdown()
      this.memberRegisterCodeSending = false
      this.memberRegisterForm = {
        userName: '',
        email: '',
        verifyCode: '',
        password: ''
      }
    },
    saveMemberDisplayName(name) {
      const text = String(name || '').trim()
      this.memberDisplayName = text
      this.persistMemberSessionCache()
      try {
        if (text) {
          localStorage.setItem(this.ShopID + '_memberDisplayName', text)
        } else {
          localStorage.removeItem(this.ShopID + '_memberDisplayName')
          localStorage.removeItem(this.getMemberCouponCacheKey())
        }
      } catch (e) {}
    },
    getMemberCouponCacheKey() {
      return this.ShopID ? (this.ShopID + '_memberCouponData') : 'memberCouponData'
    },
    persistMemberCouponCache() {
      try {
        localStorage.setItem(this.getMemberCouponCacheKey(), JSON.stringify({
          memberCouponList: this.memberCouponList,
          memberCouponMaxQua: this.memberCouponMaxQua,
          memberSN: this.memberSN,
          memberBalance: this.memberBalance,
          selectedCouponKeys: this.selectedCouponKeys
        }))
      } catch (e) {}
    },
    restoreMemberCouponData() {
      try {
        const raw = localStorage.getItem(this.getMemberCouponCacheKey())
        if (!raw) {
          return
        }
        const cached = JSON.parse(raw)
        if (!cached || typeof cached !== 'object') {
          return
        }
        this.memberCouponList = Array.isArray(cached.memberCouponList) ? cached.memberCouponList : []
        const maxQua = Number(cached.memberCouponMaxQua)
        this.memberCouponMaxQua = isFinite(maxQua) && maxQua > 0 ? Math.floor(maxQua) : 0
        this.memberSN = String(cached.memberSN || '').trim()
        const balance = Number(cached.memberBalance)
        this.memberBalance = isFinite(balance) ? balance : 0
        this.selectedCouponKeys = Array.isArray(cached.selectedCouponKeys) ? cached.selectedCouponKeys : []
        this.syncSelectedCoupons()
      } catch (e) {}
    },
    extractMemberDisplayName(row) {
      const data = row && (row.data || row.Data) ? (row.data || row.Data) : row
      const candidates = [
        data && data.name,
        data && data.Name,
        data && data.userName,
        data && data.UserName,
        data && data.MemberName,
        data && data.NickName,
        row && row.name,
        row && row.Name,
        row && row.userName,
        row && row.UserName,
        row && row.MemberName,
        this.memberRegisterForm && this.memberRegisterForm.userName,
        this.memberLoginForm && this.memberLoginForm.email
      ]
      for (let i = 0; i < candidates.length; i++) {
        const val = String(candidates[i] || '').trim()
        if (val) {
          return val
        }
      }
      return ''
    },
    getMemberSessionCacheKey() {
      return this.ShopID ? (this.ShopID + '_memberSession') : 'memberSession'
    },
    persistMemberSessionCache(extra) {
      const ttl = 2 * 60 * 60 * 1000
      const payload = {
        _expireAt: Date.now() + ttl,
        memberDisplayName: String(this.memberDisplayName || '').trim(),
        memberSN: String(this.memberSN || '').trim(),
        memberBalance: isFinite(Number(this.memberBalance)) ? Number(this.memberBalance) : 0,
        loginEmail: String(((this.memberLoginForm && this.memberLoginForm.email) || (extra && extra.email) || '')).trim(),
        loginPassword: String(((this.memberLoginForm && this.memberLoginForm.password) || (extra && extra.password) || '')).trim()
      }
      try {
        localStorage.setItem(this.getMemberSessionCacheKey(), JSON.stringify(payload))
      } catch (e) {}
    },
    restoreMemberSessionCache() {
      try {
        const raw = localStorage.getItem(this.getMemberSessionCacheKey())
        if (!raw) {
          return false
        }
        const cached = JSON.parse(raw)
        if (!cached || typeof cached !== 'object') {
          localStorage.removeItem(this.getMemberSessionCacheKey())
          return false
        }
        const expireAt = Number(cached._expireAt)
        if (!isFinite(expireAt) || expireAt <= Date.now()) {
          localStorage.removeItem(this.getMemberSessionCacheKey())
          localStorage.removeItem(this.getMemberCouponCacheKey())
          return false
        }
        this.memberDisplayName = String(cached.memberDisplayName || '').trim()
        this.memberSN = String(cached.memberSN || '').trim()
        const balance = Number(cached.memberBalance)
        this.memberBalance = isFinite(balance) ? balance : 0
        if (this.memberLoginForm) {
          this.memberLoginForm.email = String(cached.loginEmail || '').trim()
          this.memberLoginForm.password = String(cached.loginPassword || '').trim()
        }
        return !!(this.memberSN || this.memberDisplayName)
      } catch (e) {
        try {
          localStorage.removeItem(this.getMemberSessionCacheKey())
        } catch (err) {}
        return false
      }
    },
    saveMemberCouponData(row) {
      const data = row && (row.data || row.Data) ? (row.data || row.Data) : row
      const couponSource = (
        (data && (data.couPonlist || data.CouPonlist || data.couponList || data.CouponList)) ||
        (row && (row.couPonlist || row.CouPonlist || row.couponList || row.CouponList)) ||
        []
      )
      let couponList = couponSource
      if (typeof couponList === 'string') {
        try {
          couponList = JSON.parse(couponList)
        } catch (e) {
          couponList = []
        }
      }
      this.memberCouponList = Array.isArray(couponList) ? couponList : []
      const maxQua = Number(
        (data && (data.conPonMaxQua || data.ConPonMaxQua || data.couponMaxQua || data.CouponMaxQua)) ||
        (row && (row.conPonMaxQua || row.ConPonMaxQua || row.couponMaxQua || row.CouponMaxQua)) ||
        0
      )
      this.memberCouponMaxQua = isFinite(maxQua) && maxQua > 0 ? Math.floor(maxQua) : 0
      this.memberSN = String(
        (data && (data.memberSN || data.MemberSN || data.memberSn || data.MemberSn)) ||
        (row && (row.memberSN || row.MemberSN || row.memberSn || row.MemberSn)) ||
        ''
      ).trim()
      const balance = Number(
        (data && (data.balance || data.Balance)) ||
        (row && (row.balance || row.Balance)) ||
        0
      )
      this.memberBalance = isFinite(balance) ? balance : 0
      this.selectedCouponKeys = []
      this.persistMemberCouponCache()
      this.persistMemberSessionCache()
      this.syncSelectedCoupons()
    },
    getCouponLimitCount() {
      if (!(Array.isArray(this.memberCouponList) && this.memberCouponList.length)) {
        return 0
      }
      const limit = Number(this.memberCouponMaxQua)
      return isFinite(limit) && limit > 0 ? Math.floor(limit) : 1
    },
    getCouponRowKey(item, index) {
      const source = item || {}
      const base = (
        source.couponID || source.CouponID || source.CouponId ||
        source.couponSN || source.CouponSN || source.couponSn ||
        source.id || source.ID || source.sn || source.SN || ''
      )
      const text = String(base || '').trim()
      return text ? (text + '_' + index) : ('coupon_' + index)
    },
    getCouponRowName(item, index) {
      const source = item || {}
      const candidates = [
        source.couponName,
        source.CouponName,
        source.couPonName,
        source.CouPonName,
        source.name,
        source.Name,
        source.title,
        source.Title
      ]
      for (let i = 0; i < candidates.length; i++) {
        const text = String(candidates[i] || '').trim()
        if (text) {
          return text
        }
      }
      return this.$lang[this.pickxb].l101 + (index + 1)
    },
    getCouponAmount(item) {
      const source = item || {}
      const amount = Number(
        source.couponMoney || source.CouponMoney ||
        source.money || source.Money ||
        source.amount || source.Amount || 0
      )
      return isFinite(amount) && amount > 0 ? amount : 0
    },
    getOrderTotalBeforeCoupon() {
      const base = Number(this.cartTotal) || 0
      const tip = Number(this.getTipAmount()) || 0
      const serviceFee = Number(this.getServiceFee()) || 0
      const packingFee = Number(this.getPackingFee()) || 0
      return this.roundMoney(this.roundMoney(base) + this.roundMoney(tip) + this.roundMoney(serviceFee) + this.roundMoney(packingFee))
    },
    isCouponAvailable(item, orderAmount) {
      const total = Number(orderAmount)
      const amount = this.getCouponAmount(item)
      if (!isFinite(total) || total <= 0 || amount <= 0) {
        return false
      }
      return total >= amount
    },
    getSelectedCouponList() {
      const list = Array.isArray(this.memberCouponList) ? this.memberCouponList : []
      const selected = Array.isArray(this.selectedCouponKeys) ? this.selectedCouponKeys : []
      const map = {}
      for (let i = 0; i < selected.length; i++) {
        map[selected[i]] = true
      }
      const result = []
      for (let i = 0; i < list.length; i++) {
        const key = this.getCouponRowKey(list[i], i)
        if (map[key]) {
          result.push(list[i])
        }
      }
      return result
    },
    getCouponDiscount() {
      const total = this.getOrderTotalBeforeCoupon()
      if (!(total > 0)) {
        return 0
      }
      const selected = this.getSelectedCouponList()
      let discount = 0
      for (let i = 0; i < selected.length; i++) {
        const amount = this.getCouponAmount(selected[i])
        if (!this.isCouponAvailable(selected[i], total) || amount <= 0) {
          continue
        }
        if (discount + amount > total) {
          break
        }
        discount += amount
      }
      return discount > total ? total : discount
    },
    getCouponEntryText() {
      if (!this.memberDisplayName) {
        return this.$lang[this.pickxb].l102
      }
      const total = Array.isArray(this.memberCouponList) ? this.memberCouponList.length : 0
      const selected = Array.isArray(this.selectedCouponKeys) ? this.selectedCouponKeys.length : 0
      if (selected > 0) {
        return this.$lang[this.pickxb].l103 + selected + this.$lang[this.pickxb].l104
      }
      return total > 0 ? (this.$lang[this.pickxb].l105 + total + this.$lang[this.pickxb].l104) : this.$lang[this.pickxb].l106
    },
    isCouponSelected(item, index) {
      const key = this.getCouponRowKey(item, index)
      return Array.isArray(this.selectedCouponKeys) && this.selectedCouponKeys.indexOf(key) > -1
    },
    getCouponStatusText(item) {
      const amount = this.getCouponAmount(item)
      if (!amount) {
        return this.$lang[this.pickxb].l107
      }
      if (this.isCouponAvailable(item, this.getOrderTotalBeforeCoupon())) {
        return this.$lang[this.pickxb].l108
      }
      return this.$lang[this.pickxb].l109 + this.MoneySymbol + amount.toFixed(this.DecimalBit) + this.$lang[this.pickxb].l110
    },
    clearCouponSelection() {
      this.selectedCouponKeys = []
      this.persistMemberCouponCache()
    },
    syncSelectedCoupons(showAlert) {
      const list = Array.isArray(this.memberCouponList) ? this.memberCouponList : []
      const limit = this.getCouponLimitCount()
      const current = Array.isArray(this.selectedCouponKeys) ? this.selectedCouponKeys.slice() : []
      if (!list.length || limit <= 0) {
        if (current.length) {
          this.selectedCouponKeys = []
          this.persistMemberCouponCache()
          if (showAlert) {
            this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l79)
          }
        }
        return
      }
      const orderTotal = this.getOrderTotalBeforeCoupon()
      let discount = 0
      const nextKeys = []
      for (let i = 0; i < current.length; i++) {
        const key = current[i]
        const item = list.find((coupon, index) => this.getCouponRowKey(coupon, index) === key)
        if (!item) {
          continue
        }
        const amount = this.getCouponAmount(item)
        if (!this.isCouponAvailable(item, orderTotal) || amount <= 0) {
          continue
        }
        if (nextKeys.length >= limit) {
          continue
        }
        if (discount + amount > orderTotal) {
          continue
        }
        nextKeys.push(key)
        discount += amount
      }
      if (nextKeys.join('|') !== current.join('|')) {
        this.selectedCouponKeys = nextKeys
        this.persistMemberCouponCache()
        if (showAlert && current.length) {
          this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l80)
        }
      }
    },
    openCouponDialog() {
      if (!this.isOnlinePayEnabled) {
        return
      }
      if (!this.memberDisplayName) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l63)
        this.openMemberLogin()
        return
      }
      this.syncSelectedCoupons()
      this.couponDialogVisible = true
      this.syncBodyScrollLock()
    },
    closeCouponDialog() {
      this.couponDialogVisible = false
      this.syncBodyScrollLock()
    },
    toggleCouponSelect(item, index) {
      const key = this.getCouponRowKey(item, index)
      if (this.isCouponSelected(item, index)) {
        this.selectedCouponKeys = this.selectedCouponKeys.filter(v => v !== key)
        this.persistMemberCouponCache()
        return
      }
      const limit = this.getCouponLimitCount()
      if (limit > 0 && this.selectedCouponKeys.length >= limit) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l81 + limit + this.$lang[this.pickxb].l82)
        return
      }
      const orderTotal = this.getOrderTotalBeforeCoupon()
      const amount = this.getCouponAmount(item)
      if (!this.isCouponAvailable(item, orderTotal)) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l83)
        return
      }
      if (this.getCouponDiscount() + amount > orderTotal) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l84)
        return
      }
      this.selectedCouponKeys = this.selectedCouponKeys.concat(key)
      this.persistMemberCouponCache()
    },
    padMemberDatePart(value) {
      const num = Number(value)
      if (!isFinite(num)) {
        return '00'
      }
      return String(num).padStart(2, '0')
    },
    formatMemberDateTime(value) {
      const raw = String(value || '').trim().replace('T', ' ')
      const match = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/)
      if (match) {
        return [
          match[1],
          this.padMemberDatePart(match[2]),
          this.padMemberDatePart(match[3])
        ].join('-') + 'T' + [
          this.padMemberDatePart(match[4]),
          this.padMemberDatePart(match[5]),
          this.padMemberDatePart(match[6] || 0)
        ].join(':')
      }
      return this.buildOpTime().replace(' ', 'T')
    },
    buildMemberConsumeItems(orderList, opTime) {
      const rows = Array.isArray(orderList) ? orderList : []
      const itemTime = this.formatMemberDateTime(opTime)
      return rows.map((item, index) => {
        const basePrice = Number(item && item.momey ? item.momey : 0)
        const addPrice = Number(item && item.addmomey ? item.addmomey : 0)
        const qty = Number(item && item.sl ? item.sl : 0)
        const safeBasePrice = isFinite(basePrice) ? basePrice : 0
        const safeAddPrice = isFinite(addPrice) ? addPrice : 0
        const safeQty = isFinite(qty) && qty > 0 ? qty : 1
        return {
          itemsID: String((item && (item.id || item.ItemsID || item.itemsID)) || (index + 1)),
          goodsID: String((item && (item.GoodsID || item.goodsID || item.id)) || ''),
          goods: item && item.Goods ? item.Goods : '',
          twoGoods: item && item.TwoGoods ? item.TwoGoods : '',
          threeGoods: item && item.ThreeGoods ? item.ThreeGoods : '',
          qua: safeQty,
          sellPrice: Number(safeBasePrice.toFixed(this.DecimalBit)),
          addPrice: Number(safeAddPrice.toFixed(this.DecimalBit)),
          money: Number(((safeBasePrice + safeAddPrice) * safeQty).toFixed(this.DecimalBit)),
          saleTaxRate: 0,
          saleTaxMoney: 0,
          unit: item && item.unit ? item.unit : '',
          opTime: itemTime,
          remarkItems: []
        }
      })
    },
    buildMemberConsumeCouponItems() {
      const list = this.getSelectedCouponList()
      return list.map((item, index) => ({
        SN: String((item && (item.couponSn)) || ''),
      }))
    },
    async uploadMemberConsumeOrder(sheet, row, selectedList, opTime) {
      if (!this.memberSN || !this.memberDisplayName) {
        return
      }
      const sheetID = String(
        (row && (row.SheetNumber || row.sheetNumber || row.SheetID || row.sheetID)) ||
        sheet ||
        ''
      ).trim()
      if (!sheetID) {
        throw new Error(this.$lang[this.pickxb].l88)
      }
      const headers = await this.buildMemberRequestHeaders()
      const actualMoney = Number(this.getOrderTotal() || 0)
      const receivableMoney = Number(this.getOrderTotalBeforeCoupon() || 0)
      const couponMoney = Number(this.getCouponDiscount() || 0)
      const payload = {
        sheetID: sheetID,
        shopID: String(this.ShopID || ''),
        memberSn: String(this.memberSN || ''),
        sumMoney: Number(actualMoney.toFixed(this.DecimalBit)),
        memberMoney: 0,
        reMoney: Number(receivableMoney.toFixed(this.DecimalBit)),
        subMoney: Number(couponMoney.toFixed(this.DecimalBit)),
        saleTaxMoney: 0,
        accTime: this.formatMemberDateTime((row && (row.AccTime || row.accTime || row.OpTime || row.opTime)) || this.buildOpTime()),
        orderState: 1,
        items: this.buildMemberConsumeItems(selectedList, opTime),
        couponItems: this.buildMemberConsumeCouponItems()
      }
	  console.log(payload)
      const res = await this.axios.post(this.$vipurl + '/api/Upload/Add_Order', payload, {
        timeout: 10000,
        headers
      })
      const result = res && res.data ? res.data : {}
	  console.log(result)
      const code = result && result.code !== undefined ? result.code : result.Code
      if (!(result.result || result.Result || Number(code) === 0)) {
        throw new Error(result.msg || result.Msg || this.$lang[this.pickxb].l89)
      }
    },
    finishMemberCouponConsume() {
      const keys = Array.isArray(this.selectedCouponKeys) ? this.selectedCouponKeys.slice() : []
      if (keys.length) {
        this.memberCouponList = (Array.isArray(this.memberCouponList) ? this.memberCouponList : []).filter((item, index) => {
          return keys.indexOf(this.getCouponRowKey(item, index)) === -1
        })
      }
      this.selectedCouponKeys = []
      this.persistMemberCouponCache()
    },
    redirectAfterOrderSuccess() {
      try {
        try { this.clearUserCart() } catch (e) {}
        if (this.DeskID === 'Food') {
          if (this.foods.phone) {
            try {
              localStorage.setItem(this.ShopID + '_foodPhone', this.foods.phone)
            } catch (e) {}
          }
          this.$router.push('/dd?Shopid=' + this.ShopID + '&id=' + this.DeskID + '&Phone=' + this.foods.phone + '&PayState=' + this.PayState)
        } else {
          this.$router.push('/MenuQx?ShopID=' + this.ShopID + '&DeskID=' + this.DeskID)
        }
      } catch (e) {}
    },
    async handleMemberLogin() {
      if (this.memberLoginLoading) {
        return
      }
      const email = String(this.memberLoginForm.email || '').trim()
      const password = String(this.memberLoginForm.password || '').trim()
      if (!email) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l50)
        return
      }
      if (!this.isValidMemberEmail(email)) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l53)
        return
      }
      if (!password) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l51)
        return
      }
      this.memberLoginForm.email = email
      this.memberLoginForm.password = password
	  var data={
		"ShopID":this.ShopID,
		"MemberID": "",
		"Email":email,
		"PassWord":password
	  }
      let headers = null
      this.memberLoginLoading = true
      this.syncBodyScrollLock()
      try {
        headers = await this.buildMemberRequestHeaders()
      } catch (e) {
        this.memberLoginLoading = false
        this.syncBodyScrollLock()
        this.showSetMealAlert(this.$lang[this.pickxb].l17, (e && e.message) ? e.message : this.$lang[this.pickxb].l85)
        return
      }
      this.axios
        .post(this.$vipurl + '/api/MemberWeb/FindMember', data, {
          headers
        })
        .then((res) => {
          console.log(res)
          const row = res && res.data ? res.data : {}
          if (row && (row.result || row.Result || row.code === 0 || row.Code === 0)) {
            this.saveMemberDisplayName(this.extractMemberDisplayName(row))
            this.saveMemberCouponData(row)
            this.memberLoginLoading = false
            this.syncBodyScrollLock()
            this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l86)
            this.closeMemberLogin()
            return
          }
		  if (row.code === 108) {
		    this.memberLoginLoading = false
		    this.syncBodyScrollLock()
		    this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l61)
		    return
		  }
          this.memberLoginLoading = false
          this.syncBodyScrollLock()
          this.showSetMealAlert(this.$lang[this.pickxb].l17, row.msg || row.Msg || this.$lang[this.pickxb].l87)
        })
        .catch(() => {
          this.memberLoginLoading = false
          this.syncBodyScrollLock()
          this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l87)
        })
    },
    getMemberAppKeyCacheKey() {
      return this.ShopID ? (this.ShopID + '_memberAppKey') : 'memberAppKey'
    },
    getMemberAppKeyTokenCacheKey() {
      return this.ShopID ? (this.ShopID + '_memberAppKeyToken') : 'memberAppKeyToken'
    },
    async getMemberAppKey(forceRefresh) {
      const shopId = String(this.ShopID || '')
      if (!shopId) {
        throw new Error(this.$lang[this.pickxb].l90)
      }
      const cacheKey = this.getMemberAppKeyCacheKey()
      if (!forceRefresh) {
        try {
          const cached = localStorage.getItem(cacheKey)
          if (cached) {
            return cached
          }
        } catch (e) {}
      }
      const res = await this.axios.get(this.$vipurl + '/api/MemberWeb/ShopKey', {
        params: {
          ShopID: shopId
        },
        timeout: 10000,
        headers: {
          lang: ''
        }
      })
      console.log(this.$lang[this.pickxb].l137, res)
      const row = res && res.data ? res.data : {}
      const code = row && row.code !== undefined ? row.code : row.Code
      if (Number(code) !== 0) {
        throw new Error(row.msg || row.Msg || this.$lang[this.pickxb].l85)
      }
      const encrypted = row.data || row.Data || ''
      if (!encrypted) {
        throw new Error(this.$lang[this.pickxb].l91)
      }
      const appKey = await this.decryptMemberAppKey(encrypted)
      console.log(this.$lang[this.pickxb].l138, appKey)
      if (!appKey) {
        throw new Error(this.$lang[this.pickxb].l92)
      }
      try {
        localStorage.setItem(this.getMemberAppKeyTokenCacheKey(), encrypted)
        localStorage.setItem(cacheKey, appKey)
      } catch (e) {}
      return appKey
    },
    async buildMemberRequestHeaders() {
      const shopId = String(this.ShopID || '')
      const appKey = await this.getMemberAppKey()
      const timestamp = String(Math.floor(Date.now() / 1000))
      return {
        ShopID: shopId,
        AppKey: appKey,
        TimeStamp: timestamp,
        Sign: this.sm3(shopId + appKey + timestamp)
      }
    },
    async decryptMemberAppKey(cipherText) {
      const encrypted = String(cipherText || '')
      if (!encrypted) {
        throw new Error(this.$lang[this.pickxb].l91)
      }
      const cryptoObj = window.crypto || window.msCrypto
      if (!cryptoObj || !cryptoObj.subtle) {
        throw new Error(this.$lang[this.pickxb].l93)
      }
      const keyText = '1234567890123456'
      const ivText = '1234567890123456'
      const keyBytes = this.textToUint8Array(keyText)
      const ivBytes = this.textToUint8Array(ivText)
      const cipherBytes = this.base64ToUint8Array(encrypted)
      const cryptoKey = await cryptoObj.subtle.importKey(
        'raw',
        keyBytes,
        { name: 'AES-CBC' },
        false,
        ['decrypt']
      )
      const plainBuffer = await cryptoObj.subtle.decrypt(
        { name: 'AES-CBC', iv: ivBytes },
        cryptoKey,
        cipherBytes
      )
      return this.uint8ArrayToText(new Uint8Array(plainBuffer)).replace(/\0+$/g, '').trim()
    },
    base64ToUint8Array(base64) {
      const str = atob(base64)
      const bytes = new Uint8Array(str.length)
      for (let i = 0; i < str.length; i++) {
        bytes[i] = str.charCodeAt(i)
      }
      return bytes
    },
    textToUint8Array(text) {
      if (typeof TextEncoder !== 'undefined') {
        return new TextEncoder().encode(text)
      }
      return new Uint8Array(this.sm3Utf8Bytes(String(text || '')))
    },
    uint8ArrayToText(bytes) {
      if (typeof TextDecoder !== 'undefined') {
        return new TextDecoder('utf-8').decode(bytes)
      }
      let result = ''
      for (let i = 0; i < bytes.length; i++) {
        result += String.fromCharCode(bytes[i])
      }
      try {
        return decodeURIComponent(escape(result))
      } catch (e) {
        return result
      }
    },
    sm3(input) {
      const bytes = this.sm3Utf8Bytes(String(input || ''))
      const bitLen = bytes.length * 8
      bytes.push(0x80)
      while ((bytes.length % 64) !== 56) {
        bytes.push(0)
      }
      const high = Math.floor(bitLen / 0x100000000)
      const low = bitLen >>> 0
      bytes.push((high >>> 24) & 0xff, (high >>> 16) & 0xff, (high >>> 8) & 0xff, high & 0xff)
      bytes.push((low >>> 24) & 0xff, (low >>> 16) & 0xff, (low >>> 8) & 0xff, low & 0xff)

      const iv = [
        0x7380166f, 0x4914b2b9, 0x172442d7, 0xda8a0600,
        0xa96f30bc, 0x163138aa, 0xe38dee4d, 0xb0fb0e4e
      ]

      for (let i = 0; i < bytes.length; i += 64) {
        const w = new Array(68)
        const w1 = new Array(64)
        for (let j = 0; j < 16; j++) {
          const idx = i + j * 4
          w[j] = (((bytes[idx] << 24) | (bytes[idx + 1] << 16) | (bytes[idx + 2] << 8) | bytes[idx + 3]) >>> 0)
        }
        for (let j = 16; j < 68; j++) {
          const x = (w[j - 16] ^ w[j - 9] ^ this.sm3Rotl(w[j - 3], 15)) >>> 0
          w[j] = (this.sm3P1(x) ^ this.sm3Rotl(w[j - 13], 7) ^ w[j - 6]) >>> 0
        }
        for (let j = 0; j < 64; j++) {
          w1[j] = (w[j] ^ w[j + 4]) >>> 0
        }

        let a = iv[0]
        let b = iv[1]
        let c = iv[2]
        let d = iv[3]
        let e = iv[4]
        let f = iv[5]
        let g = iv[6]
        let h = iv[7]

        for (let j = 0; j < 64; j++) {
          const tj = j <= 15 ? 0x79cc4519 : 0x7a879d8a
          const ss1 = this.sm3Rotl(((this.sm3Rotl(a, 12) + e + this.sm3Rotl(tj, j)) >>> 0), 7)
          const ss2 = (ss1 ^ this.sm3Rotl(a, 12)) >>> 0
          const tt1 = ((this.sm3FF(a, b, c, j) + d + ss2 + w1[j]) >>> 0)
          const tt2 = ((this.sm3GG(e, f, g, j) + h + ss1 + w[j]) >>> 0)
          d = c
          c = this.sm3Rotl(b, 9)
          b = a
          a = tt1
          h = g
          g = this.sm3Rotl(f, 19)
          f = e
          e = this.sm3P0(tt2)
        }

        iv[0] = (iv[0] ^ a) >>> 0
        iv[1] = (iv[1] ^ b) >>> 0
        iv[2] = (iv[2] ^ c) >>> 0
        iv[3] = (iv[3] ^ d) >>> 0
        iv[4] = (iv[4] ^ e) >>> 0
        iv[5] = (iv[5] ^ f) >>> 0
        iv[6] = (iv[6] ^ g) >>> 0
        iv[7] = (iv[7] ^ h) >>> 0
      }

      return iv.map(n => ('00000000' + (n >>> 0).toString(16)).slice(-8)).join('')
    },
    sm3Utf8Bytes(str) {
      const bytes = []
      for (let i = 0; i < str.length; i++) {
        let code = str.charCodeAt(i)
        if (code >= 0xd800 && code <= 0xdbff && i + 1 < str.length) {
          const next = str.charCodeAt(i + 1)
          if (next >= 0xdc00 && next <= 0xdfff) {
            code = 0x10000 + ((code - 0xd800) << 10) + (next - 0xdc00)
            i++
          }
        }
        if (code <= 0x7f) {
          bytes.push(code)
        } else if (code <= 0x7ff) {
          bytes.push(0xc0 | (code >>> 6), 0x80 | (code & 0x3f))
        } else if (code <= 0xffff) {
          bytes.push(0xe0 | (code >>> 12), 0x80 | ((code >>> 6) & 0x3f), 0x80 | (code & 0x3f))
        } else {
          bytes.push(0xf0 | (code >>> 18), 0x80 | ((code >>> 12) & 0x3f), 0x80 | ((code >>> 6) & 0x3f), 0x80 | (code & 0x3f))
        }
      }
      return bytes
    },
    sm3Rotl(x, n) {
      const s = n % 32
      return ((x << s) | (x >>> (32 - s))) >>> 0
    },
    sm3P0(x) {
      return (x ^ this.sm3Rotl(x, 9) ^ this.sm3Rotl(x, 17)) >>> 0
    },
    sm3P1(x) {
      return (x ^ this.sm3Rotl(x, 15) ^ this.sm3Rotl(x, 23)) >>> 0
    },
    sm3FF(x, y, z, j) {
      return (j <= 15 ? (x ^ y ^ z) : ((x & y) | (x & z) | (y & z))) >>> 0
    },
    sm3GG(x, y, z, j) {
      return (j <= 15 ? (x ^ y ^ z) : ((x & y) | ((~x) & z))) >>> 0
    },
    isValidMemberEmail(email) {
      const emailReg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      return emailReg.test(String(email || '').trim())
    },
    handleMemberRegister() {
      this.closeMemberLogin()
      this.openMemberRegister()
    },
    stopMemberRegisterCodeCountdown() {
      if (this.memberRegisterCodeTimer) {
        clearInterval(this.memberRegisterCodeTimer)
        this.memberRegisterCodeTimer = null
      }
      this.memberRegisterCodeSeconds = 0
    },
    startMemberRegisterCodeCountdown() {
      this.stopMemberRegisterCodeCountdown()
      this.memberRegisterCodeSeconds = 60
      this.memberRegisterCodeTimer = setInterval(() => {
        if (this.memberRegisterCodeSeconds <= 1) {
          this.stopMemberRegisterCodeCountdown()
          return
        }
        this.memberRegisterCodeSeconds -= 1
      }, 1000)
    },
    isMemberRegisterReady() {
      const form = this.memberRegisterForm || {}
      return !!(
        String(form.userName || '').trim() &&
        this.isValidMemberEmail(form.email) &&
        String(form.verifyCode || '').trim() &&
        String(form.password || '').trim()
      )
    },
    async sendMemberRegisterCode() {
      if (this.memberRegisterLoading || this.memberRegisterCodeSending || this.memberRegisterCodeSeconds > 0) {
        return
      }
      const email = String(this.memberRegisterForm.email || '').trim()
      if (!email) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l50)
        return
      }
      if (!this.isValidMemberEmail(email)) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l53)
        return
      }
      this.memberRegisterCodeSending = true
      try {
        const headers = await this.buildMemberRequestHeaders()
        const res = await this.axios.post(this.$vipurl + '/api/MemberWeb/EmailOTP', {
          email: email,
          shopID: this.ShopID
        }, {
          timeout: 10000,
          headers
        })
        const row = res && res.data ? res.data : {}
        const code = row && row.code !== undefined ? row.code : row.Code
        if (Number(code) === 0 || row.result || row.Result) {
          this.startMemberRegisterCodeCountdown()
          this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l56)
          return
        }
		if(Number(code) === 104){
		  this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l58)
		  return
		}
		if(Number(code) === 109){
		  this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l94)
		  return
		}
		console.log(row)
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l57)
      } catch (e) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, (e && e.message) ? e.message : this.$lang[this.pickxb].l57)
      } finally {
        this.memberRegisterCodeSending = false
      }
    },
    async handleRegisterSubmit() {
      if (this.memberRegisterLoading) {
        return
      }
      const userName = String(this.memberRegisterForm.userName || '').trim()
      const email = String(this.memberRegisterForm.email || '').trim()
      const verifyCode = String(this.memberRegisterForm.verifyCode || '').trim()
      const password = String(this.memberRegisterForm.password || '').trim()
      if (!userName) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l95)
        return
      }
      if (!email) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l50)
        return
      }
      if (!this.isValidMemberEmail(email)) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l53)
        return
      }
      if (!verifyCode) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l54)
        return
      }
      if (!password) {
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l51)
        return
      }
      if (!this.isMemberRegisterReady()) {
        return
      }
      this.memberRegisterForm.userName = userName
      this.memberRegisterForm.email = email
      this.memberRegisterForm.verifyCode = verifyCode
      this.memberRegisterForm.password = password
      this.memberRegisterLoading = true
      this.syncBodyScrollLock()
      try {
        const headers = await this.buildMemberRequestHeaders()
        const data = {
          email: email,
          PassWord: password,
          name: userName,
          Phone: email,
          shopID: this.ShopID,
          MemberID: '',
          opDate: new Date(),
          isUse: true,
          code: verifyCode
        }
        const res = await this.axios.post(this.$vipurl + '/api/MemberWeb/MemberRegister', data, {
          timeout: 10000,
          headers
        })
        this.memberRegisterLoading = false
        this.syncBodyScrollLock()
        const row = res && res.data ? res.data : {}
        const code = row && row.code !== undefined ? row.code : row.Code
        if (Number(code) === 0 || row.result || row.Result) {
          this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l55)
          this.memberLoginForm.email = email
          this.memberLoginForm.password = password
          this.closeMemberRegister()
          this.openMemberLogin()
          return
        }
		if (Number(code) === 117) {
		  this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l59)
		  return
		}
		console.log(row)
        this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l60)
      } catch (e) {
        this.memberRegisterLoading = false
        this.syncBodyScrollLock()
        this.showSetMealAlert(this.$lang[this.pickxb].l17, (e && e.message) ? e.message : this.$lang[this.pickxb].l60)
      }
    },
    initDateTimeOptions() {
      const today = new Date()
      const dateOptions = []
      const timeOptions = []
      const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      for (let i = 0; i <= 10; i++) {
        const d = new Date(today)
        d.setDate(today.getDate() + i)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        const weekDay = weekDays[d.getDay()]
        let label = ''
        if (i === 0) {
          label = 'Today ' + month + '-' + day + ' ' + weekDay
        } else if (i === 1) {
          label = 'Tomorrow ' + month + '-' + day + ' ' + weekDay
        } else {
          label = month + '-' + day + ' ' + weekDay
        }
        dateOptions.push({
          value: year + '-' + month + '-' + day,
          label: label
        })
      }
      this.dateOptions = dateOptions
      for (let h = 0; h < 24; h++) {
        for (let m = 0; m < 60; m += 15) {
          const hour = String(h).padStart(2, '0')
          const minute = String(m).padStart(2, '0')
          timeOptions.push(hour + ':' + minute)
        }
      }
      this.timeOptions = timeOptions
      const currentHour = String(today.getHours()).padStart(2, '0')
      const currentMinute = Math.ceil(today.getMinutes() / 15) * 15
      const roundedMinute = currentMinute >= 60 ? '00' : String(currentMinute).padStart(2, '0')
      this.selectedDate = dateOptions[0].value
      this.selectedTime = currentMinute >= 60 ? '00:00' : (currentHour + ':' + roundedMinute)
      if (currentMinute >= 60) {
        const nextHour = String((today.getHours() + 1) % 24).padStart(2, '0')
        this.selectedTime = nextHour + ':00'
      }
    },
    syncBodyScrollLock() {
      const locked = !!(this.cartVisible || this.remarkVisible || this.cartDeleteVisible || this.cartOrderVisible || this.orderLoadingVisible || this.setMealVisible || this.couponDialogVisible || this.memberLogoutVisible)
      this.lockBodyScroll(locked)
    },
    chooseIntroLang(idx) {
      const index = Number(idx)
      if (!isFinite(index) || index < 0) {
        return
      }
      const item = Array.isArray(this.introLangList) ? this.introLangList[index] : null
      if (!item) {
        return
      }
      this.pickindex = index
      const idNum = Number(item.id)
      this.pickxb = isFinite(idNum) && idNum > 0 ? (idNum - 1) : 0
      const which = Number(item.index) || (index + 1)
      if (which === 1) {
        this.WXLangGoodsxb = Number(this.WXLangGoods && this.WXLangGoods.WXGoodsNameOne) || 0
      } else if (which === 2) {
        this.WXLangGoodsxb = Number(this.WXLangGoods && this.WXLangGoods.WXGoodsNameTwo) || 0
      } else if (which === 3) {
        this.WXLangGoodsxb = Number(this.WXLangGoods && this.WXLangGoods.WXGoodsNameThree) || 0
      } else {
        this.WXLangGoodsxb = 0
      }
      try {
        if (this.ShopID) {
          localStorage.setItem(this.ShopID + 'pickxb', String(this.pickxb))
          localStorage.setItem(this.ShopID + 'WXLangGoodsxb', String(this.WXLangGoodsxb))
          localStorage.setItem(this.ShopID + 'pickindex', String(this.pickindex))
        }
      } catch (e) {}
    },
    getAllLangOptions() {
      return [
        { label: '简体中文', id: 1 },
        { label: '繁體中文', id: 2 },
        { label: 'English', id: 3 },
        { label: 'عربي ،', id: 4 },
        { label: 'ភាសាខ្មែរ', id: 5 },
        { label: 'Español', id: 6 },
        { label: 'Срб', id: 7 },
        { label: 'Nederlands', id: 8 },
        { label: 'Français', id: 9 },
        { label: 'Italiano', id: 10 },
        { label: '日本語', id: 11 },
        { label: 'Português', id: 12 },
        { label: 'ViệtName', id: 13 },
        { label: 'Deutsch', id: 14 },
        { label: '한국어', id: 15 },
        { label: 'ກະຣຸນາ', id: 16 },
        { label: 'русский язык ', id: 17 },
        { label: 'Norsk', id: 18 },
        { label: 'Polski', id: 19 },
        { label: 'Pilipino', id: 20 },
        { label: 'Indonesian', id: 21 },
        { label: 'ภาษาไทย', id: 22 },
        { label: 'Ελληνική γλώσσα', id: 23 },
        { label: 'Slovenščina', id: 24 },
        { label: 'English', id: 25 },
        { label: 'Azərbaycan', id: 26 },
        { label: 'Burmese', id: 27 },
        { label: 'Türkiye', id: 28 },
        { label: 'Монгол хэл', id: 29 }
      ]
    },
    loadLangConfig() {
      if (!this.ShopID) {
        return
      }
      this.axios
        .get(this.$lujin + '/api/Default/CXTMultilingual?ShopID=' + this.ShopID)
        .then((res) => {
          const row = res && res.data && res.data.data && res.data.data[0] ? res.data.data[0] : null
          const sz = this.getAllLangOptions()
          let list = []
          if (row) {
            const pushById = (langId) => {
              const idNum = Number(langId)
              if (!isFinite(idNum) || idNum <= 0) {
                return
              }
              const hit = sz.find(v => Number(v && v.id) === idNum)
              if (hit) {
                list.push({ label: hit.label, id: hit.id })
              }
            }
            pushById(row.WXLangOne)
            pushById(row.WXLangTwo)
            pushById(row.WXLangThree)
            if (!(row.WXLangOne || row.WXLangTwo || row.WXLangThree)) {
              list = sz.slice()
            }
            for (let i = 0; i < list.length; i++) {
              list[i].index = i + 1
            }
            this.WXLangGoods = row
          } else {
            list = sz.slice(0, 3).map((v, i) => ({ label: v.label, id: v.id, index: i + 1 }))
          }
          this.pickData = list

          let storedPickxb = null
          let storedWX = null
          let storedPickIndex = null
          try {
            storedPickxb = localStorage.getItem(this.ShopID + 'pickxb')
            storedWX = localStorage.getItem(this.ShopID + 'WXLangGoodsxb')
            storedPickIndex = localStorage.getItem(this.ShopID + 'pickindex')
          } catch (e) {}
          const hasStored = storedPickxb !== null && storedWX !== null && storedPickIndex !== null
          const pidx = Number(storedPickIndex)
          if (hasStored && isFinite(pidx) && pidx >= 0 && pidx < this.pickData.length) {
            const px = Number(storedPickxb)
            const wx = Number(storedWX)
            this.pickxb = isFinite(px) && px >= 0 ? px : 0
            this.WXLangGoodsxb = isFinite(wx) ? wx : 0
            this.pickindex = pidx
            return
          }

          const defaultLangId = row && Number(row.WXLangOne) > 0 ? Number(row.WXLangOne) : 1
          this.pickxb = defaultLangId - 1
          this.pickindex = 0
          this.WXLangGoodsxb = Number(row && row.WXGoodsNameOne) || 0
          try {
            localStorage.setItem(this.ShopID + 'pickxb', String(this.pickxb))
            localStorage.setItem(this.ShopID + 'WXLangGoodsxb', String(this.WXLangGoodsxb))
            localStorage.setItem(this.ShopID + 'pickindex', String(this.pickindex))
          } catch (e) {}
        })
        .catch(() => {})
    },
    startOrdering() {
      this.introVisible = false
      this.$nextTick(() => {
        try {
          window.scrollTo(0, 0)
        } catch (e) {}
        this.updateTopFixedHeight()
      })
    },
    goToMenuQx() {
	  if (this.DeskID === 'Food') {
	  	const phone = this.foods.phone || localStorage.getItem(this.ShopID + '_foodPhone') || ''
	  	this.$router.push('/dd?Shopid=' + this.ShopID + '&id=' + this.DeskID + '&Phone=' + phone)
	  } else {
	  	this.$router.push('/MenuQx?ShopID=' + this.ShopID + '&DeskID=' + this.DeskID)
	  }
    },
    goToQua() {
	  if(this.DeskID=="Food"){
		
	  }else{
        this.$router.push('/MenuQua?ShopID=' + this.ShopID + '&DeskID=' + this.DeskID) 
	  }
    },
    getTipAmount() {
      const n = parseFloat(this.tipMoney)
      if (!isFinite(n) || n <= 0) {
        return 0
      }
      return n
    },
    getPackingFee() {
	  if(this.ShopID=='10086'){
		  return 0
	  }
      return this.isOnlinePayEnabled && this.DeskID === 'Food' ? 0.25 : 0
    },
    getServiceFee() {
	  if(this.ShopID=='10086'){
	  		  return 0
	  }
      if (!this.isOnlinePayEnabled) {
        return 0
      }
      if (this.DeskID !== 'Food') {
        return 0
      }
      const base = Number(this.cartTotal) || 0
      const fee = base * 0.015
      return Math.round(fee * 100) / 100 + 0.25
    },
    getQuickTipBaseTotal() {
      const base = Number(this.cartTotal) || 0
      const serviceFee = Number(this.getServiceFee()) || 0
      const packingFee = Number(this.getPackingFee()) || 0
      return base + serviceFee + packingFee
    },
    getQuickTipTarget(extra) {
      const baseTotal = this.getQuickTipBaseTotal()
      return Math.ceil(baseTotal) + Number(extra || 0)
    },
    getQuickTipAmount(extra) {
      const baseTotal = this.getQuickTipBaseTotal()
      const target = this.getQuickTipTarget(extra)
      const tip = target - baseTotal
      return tip > 0 ? Math.round(tip * 100) / 100 : 0
    },
    applyQuickTip(extra) {
      const tip = this.getQuickTipAmount(extra)
      this.tipMoney = tip > 0 ? tip.toFixed(this.DecimalBit) : ''
      this.saveTipMoney()
    },
    saveTipMoney() {
      try {
        localStorage.setItem(this.ShopID + '_tipMoney', this.tipMoney || '')
      } catch (e) {}
    },
    prepareOnlinePay() {
      this.processOnlinePay()
    },
    topayurl_buildParamStr(param) {
      if (!param || typeof param !== 'object') return ''
      const keys = Object.keys(param).sort()
      const parts = []
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i]
        const v = param[k]
        if (v !== undefined && v !== null && String(v) !== '') {
          parts.push(String(k) + '=' + String(v))
        }
      }
      return parts.join('&')
    },
    topayurl_THFormatAmount(amount) {
      const num = Number(amount || 0)
      if (!isFinite(num) || num < 0) return '000000000000'
      const fen = Math.round(num * 100)
      return String(fen).replace(/[^\d]/g, '').padStart(12, '0').slice(-12)
    },
    topayurl_GetUUid() {
      const r1 = Math.floor(100 + Math.random() * 900)
      const r2 = Math.floor(100 + Math.random() * 900)
      const d = new Date()
      const yy = String(d.getFullYear()).slice(2)
      const MM = ('0' + (d.getMonth() + 1)).slice(-2)
      const dd = ('0' + d.getDate()).slice(-2)
      return String(r1) + yy + MM + dd + String(r1) + String(r2)
    },
    _topayurl_base64ToBytes(b64) {
      const bin = atob(String(b64 || '').replace(/\s+/g, ''))
      const len = bin.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i)
      return bytes
    },
    _topayurl_bytesToBase64(bytes) {
      let bin = ''
      for (let i = 0; i < bytes.byteLength; i++) bin += String.fromCharCode(bytes[i])
      return btoa(bin)
    },
    async topayurl_Sign(content, privateKeyBase64) {
      if (!window.crypto || !window.crypto.subtle) {
        throw new Error('当前浏览器不支持 Web Crypto，请使用后端签名')
      }
      const raw = this._topayurl_base64ToBytes(privateKeyBase64)
      const algo = { name: 'RSASSA-PKCS1-v1_5', hash: { name: 'SHA-1' } }
      const key = await window.crypto.subtle.importKey('pkcs8', raw.buffer, algo, false, ['sign'])
      const encoder = new TextEncoder()
      const data = encoder.encode(String(content || ''))
      const signature = await window.crypto.subtle.sign({ name: 'RSASSA-PKCS1-v1_5' }, key, data)
      const sigBytes = new Uint8Array(signature)
      return this._topayurl_bytesToBase64(sigBytes)
    },
    async topayurl() {
      const privateKey = 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDFWZD0V4ix3G0eyxPymPxU0D//HE8hTtSUvKYLYVPyptKNsS6gDcHr8e3uOkv4MAFQ0tPP45KtOQgGflq85SlTmGcKNlNHsYbELM6QFu+tGhXzUhaQ38Zz6KRrE7QH/U0G3uIRCbT4oTYvnAUHiNIOQKwsIw0JE4mVG67FPc3sQUmi0UEJtdBpNsDkbBchjJ2xaPUNZ3LbgOXHcyh3QIrdaSb5LfmiXRwBAhJvABxeKhzaWhu9kL5SB2/F9ygqjJb2O0JOycLTZkDpgmtsn2y5hWnu+TxEtFvbwPqUWm+Pzvbb53OuOEem4NpnYBCfYBBhbXXuDhKBENSmfMKLX7VNAgMBAAECggEAJYU91fa+enJaHLyncjw73TQqtqn/MWn3aL/lIczDVSL6bQ3+u1diQyWgAub6gpk95svukVvHC0AIkpN7VOaM0OPs0zg45SyPXsTWEPcLYnHPMo+s0qZ46JiWifUZCVvTRTci6/JYgdzEnJChNCmDJkqNcWbIl60rPzogJEf32q7JfdnSc/qhdUPH3ENiKVB6lSoESNURwigPi+ZnVrtxUAHQ3CZmAqHy9o8jnqsLEcmOxZ29vWvu/M5xpWs5IWUkDhKGoQa2BTxKKWiM1p9OScz5pXTVi9R8RLxsz9a9ya8j6RJCFKrVNw7b5VyPBYozml6aZdhkEWujWoiYeK8N0QKBgQDmsfdwDqTcMnmIKz6n8en/tL78esDA4F9EKHQZ7ijtTX4o3FYkd11/Z1OJrKQFQX9SrgJWYxn5itIqTcr3pOVtmbW+zGQMJ3ilrHh5EhOj17zQEOxmR8GquFWKgcS9uy7XWBbwO1UAKGRHg1XbzAlbW7OblaJJpRub3aSDn/u84wKBgQDa/z85UOzYmjy/F3T3REqE4yzGyypMlUTvXfMS3i06iwE/FDqniQRDa9zXNPNFcjTth2QckRTMUuPHEybgoKT+uX/pLc2x0uroIHc0MwNXnG+wvxkvD4/S4/XNWEj8CHbAltYejNa/sF7DSsJe3DB38txan7LVZV+3DiBCLjcMDwKBgH6pshDNiYj5Ea9JByLQ+UiTZdVcVJ7R0pyqlWxzTfdU9/LZX1awTx6Xjc9mgbv9BTpRHiluSiGwLcpaYhlsaSevIJG8ySW/OkfElXTsDuqDlkCrOhDCTzw774OX0nzV3FcSH64Q9Y+bncuB+c8vjOejRs8i7jL/O1Rt8ljuqxo/AoGBAJ65mY1lRgTH5Xdq/O+qo4glT3LWFdZj6g7DvUXTmlxwG3sookqDWH+1Ud75FckjuZDfLIQ38ycUfNrw2qC8TloBAOB0vj1AbdnIjh1bS/TYAWvNVedyE//6EVG/x0ZErC1yJccGtS9CGazaJn6ygL6vW16jmO5qBzGaH29YJ7WpAoGAPbKetB1G0V1SCuZ8/N+iu7u3eGRih0o++8ENi83ZoYNdU3Y/CCJ/GxJOsmdb4+EJkclzdjmY/RDcJi9mEqGLDDg00cQ+T1DBBq2ThIOl9RbVRcanSzZjRJNGdDY+GVTunYpLk6kvYkuireYO5G1ezh+wg4jhih+RN8D3LwOAwoI='
      const cusid = '56458105814C0Z8'
      const appid = '00356644'
      const reqsn = '337260908337125'
      const randomstr = '36426090844660'
      const trxamt = String(100).padStart(15, '0')
      const returl = 'https://www.baidu.com'
      const notify_url = ''
      const limit_pay = ''
      const paytype = ''
      const body = 'test'
      const remark = ''
      const subbranch = ''
      const map = {
        appid: appid,
        body: body,
        charset: 'UTF-8',
        cusid: cusid,
        randomstr: randomstr,
        reqsn: reqsn,
        returl: returl,
        signtype: 'RSA',
        trxamt: trxamt,
        version: '12'
      }
      if (notify_url && String(notify_url).length > 0) map.notify_url = notify_url
      if (limit_pay && String(limit_pay).length > 0) map.limit_pay = limit_pay
      if (paytype && String(paytype).length > 0) map.paytype = paytype
      if (remark && String(remark).length > 0) map.remark = remark
      if (subbranch && String(subbranch).length > 0) map.subbranch = subbranch
      console.warn('topayurl 当前收银台只显示【云闪付】= 因为商户号 appid=' + appid + ' 下尚未开通微信/支付宝产品权限。请立刻联系通联技术支持，为该商户号开通【微信支付(H5/公众号)】和【支付宝(H5/生活号)】支付方式权限；开通后无需改代码，通联合金台将自动显示微信/支付宝图标。当前limit_pay(禁止项)=空，paytype(强制指定方式)=空，会自动显示商户已开通的全部支付方式。')
      console.warn('topayurl 环境选择：当前appid=' + appid + '，如果通联返回「appid不存在」，95%概率是【环境用反了】—— 要么把appid/cusid换成通联单独发你的沙箱测试号（用于syb-test），要么把Url切正式生产环境syb.allinpay.com（用于正式号）。下面默认用生产环境，你可以在代码里改回test环境。')
      const envMode = 'prod'
      const envLabel = envMode === 'prod' ? '生产环境正式域名' : '沙箱测试域名'
      const urlBase = envMode === 'prod' ? 'https://syb.allinpay.com' : 'https://syb.allinpay.com'
      const Url = urlBase + '/apiweb/h5unionpay/unionorder'
      const hasValue = v => v !== undefined && v !== null && String(v).length > 0
      const signParamsOrdered = Object.keys(map).slice().sort()
      const buildArr = []
      signParamsOrdered.forEach(k => {
        if (k === 'returl') buildArr.push('returl=' + String(returl))
        else if (hasValue(map[k])) buildArr.push(k + '=' + String(map[k]))
      })
      if (!buildArr.some(s => s.startsWith('returl='))) buildArr.push('returl=' + String(returl))
      let buildStr = buildArr.join('&')
      console.log('topayurl buildStr=签名原始字符串=[' + envLabel + ']，内容如下，检查是否包含returl:')
      console.log(buildStr)
      if (buildStr.indexOf('returl=' + encodeURIComponent ? '' : '') === -1) {
        buildStr = buildStr + (buildStr.length ? '&' : '') + 'returl=' + String(returl)
        console.log('topayurl buildStr=强制补returl后的最终签名串=', buildStr)
      }
      const sign = await this.topayurl_Sign(buildStr, privateKey)
      map.sign = sign
      console.log('topayurl sign=', sign)
      const submitKeys = signParamsOrdered.concat(['sign'])
      const submitParams = {}
      submitKeys.forEach(k => {
        if (k === 'returl') submitParams.returl = String(returl)
        else if (k === 'sign') submitParams.sign = String(sign)
        else if (hasValue(map[k])) submitParams[k] = String(map[k])
      })
      if (!submitParams.returl || submitParams.returl.length === 0) submitParams.returl = String(returl)
      console.log('topayurl submitParams=（提交前，检查returl是否存在）', submitParams)
      console.log('topayurl submitParams.returl 当前值=', submitParams.returl, '，类型=', typeof submitParams.returl, '，长度=', String(submitParams.returl).length)
      console.log('topayurl 本次参数：环境=' + envLabel + '，returl=' + String(returl) + '，body=test(纯英文排除编码)，参数已最小化')
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = Url
      form.acceptCharset = 'UTF-8'
      form.target = '_self'
      Object.keys(submitParams).forEach(k => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = k
        input.value = submitParams[k]
        form.appendChild(input)
      })
      const forceReturlInput = document.createElement('input')
      forceReturlInput.type = 'hidden'
      forceReturlInput.name = 'returl'
      forceReturlInput.value = String(returl)
      form.appendChild(forceReturlInput)
      const forceAppidInput = document.createElement('input')
      forceAppidInput.type = 'hidden'
      forceAppidInput.name = 'appid'
      forceAppidInput.value = String(appid)
      form.appendChild(forceAppidInput)
      const forceCusidInput = document.createElement('input')
      forceCusidInput.type = 'hidden'
      forceCusidInput.name = 'cusid'
      forceCusidInput.value = String(cusid)
      form.appendChild(forceCusidInput)
      form.style.display = 'none'
      document.body.appendChild(form)
      console.log('topayurl FORM outerHTML=（提交前，检查是否有returl字段和值）=')
      console.log(form.outerHTML)
      console.log('topayurl FORM已创建, 即将submit -> action=', Url)
      let previewHtml = ''
      let previewErr = ''
      let willJumpAnyway = false
      const uspPreview = new URLSearchParams()
      Object.keys(submitParams).forEach(k => uspPreview.append(k, submitParams[k]))
      uspPreview.append('returl', String(returl))
      uspPreview.append('appid', String(appid))
      uspPreview.append('cusid', String(cusid))
      console.log('topayurl uspPreview 请求体（含强制追加returl）=', uspPreview.toString())
      try {
        const resp = await fetch(Url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: uspPreview.toString()
        })
        previewHtml = await resp.text()
        const m = previewHtml && previewHtml.match(/id="dd_msg"[^>]*>([^<]*)<\//i)
        const htmlMsg = m ? m[1] : ''
        if (htmlMsg) {
          previewErr = '预检查提示：通联返回错误页 dd_msg=' + htmlMsg + '。但仍将强制FORM跳转，以便通联后台能看到真实跳转记录后查日志。'
          console.warn('topayurl ' + previewErr, 'raw html=', previewHtml)
          alert(previewErr)
        } else {
          console.log('topayurl 预检查：通联未返回错误页（dd_msg 不存在），说明参数大概率可通过')
        }
        willJumpAnyway = true
      } catch (e) {
        previewErr = '预检查 fetch 失败（通常CORS，完全不影响FORM主窗口提交跳转）: ' + String(e && e.message ? e.message : e)
        console.warn('topayurl ' + previewErr)
        willJumpAnyway = true
      }
      if (willJumpAnyway) {
        const tip = previewErr
          ? (previewErr + '\n\n接下来浏览器将整页FORM提交到通联合金台（后台会有跳转记录）。如果跳过去仍然是"未知错误"，请把你浏览器地址栏此时的完整 URL + 时间点 截图发给通联的人，让他们查服务器端具体报错原因。确定现在跳转吗？')
          : '预检查未发现错误，即将FORM方式提交浏览器整页跳转到通联合金台。确定跳转？'
        if (confirm(tip)) {
          console.log('topayurl 用户确定跳转 → 调用 form.submit()，主窗口即将离开localhost')
          setTimeout(() => form.submit(), 50)
          return { ok: true, msg: '已FORM提交跳转通联（后台有记录）' }
        } else {
          document.body.removeChild(form)
          return { ok: false, msg: '用户取消跳转' }
        }
      }
      document.body.removeChild(form)
      return { ok: false, msg: '未知' }
    },
    openPayUrl(payUrl) {
      if (payUrl) {
        window.location.href = payUrl
      }
    },
    submitAllinpayForm(formData, action) {
      const actionUrl = String(action || '')
      const params = formData && typeof formData === 'object' ? formData : {}
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = actionUrl
      form.acceptCharset = 'UTF-8'
      form.target = '_self'
      form.style.display = 'none'
      Object.keys(params).forEach(k => {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = k
        input.value = String(params[k])
        form.appendChild(input)
      })
      document.body.appendChild(form)
      try {
        setTimeout(() => { try { form.submit() } catch (e) { if (actionUrl) window.location.href = actionUrl } }, 0)
      } catch (e) {
        if (actionUrl) window.location.href = actionUrl
      }
      try { setTimeout(() => { try { if (form && form.parentNode) form.parentNode.removeChild(form) } catch (e) {} }, 3000) } catch (e) {}
    },
    closePayWindow() {
      this._payWindow = null
    },
    cancelPay() {
      this.payLoading = false
      this._payToken = null
      if (this.paygettime) {
        clearInterval(this.paygettime)
        this.paygettime = null
      }
      this.closePayWindow()
      try {
        if (this.ShopID) {
          localStorage.removeItem(this.ShopID + '_pendingPayUrl')
          localStorage.removeItem(this.ShopID + '_pendingPayToken')
          localStorage.removeItem(this.ShopID + '_pendingPayTradeId')
          localStorage.removeItem(this.ShopID + '_pendingPayAmount')
          localStorage.removeItem(this.ShopID + '_pendingPayAccount')
          localStorage.removeItem(this.ShopID + '_pendingPaySheetID')
          localStorage.removeItem(this.ShopID + '_pendingPayChannel')
          localStorage.removeItem(this.ShopID + '_pendingPayChannelState')
        }
      } catch (e) {}
      this.releasePaySubmitLock()
    },
    stopPayPollingOnly() {
      this.payLoading = false
      this._payToken = null
      if (this.paygettime) {
        clearInterval(this.paygettime)
        this.paygettime = null
      }
      this.closePayWindow()
    },
    getPendingPaySheetKey() {
      return this.ShopID ? (this.ShopID + '_pendingPaySheetID') : ''
    },
    getPendingMemberConsumeCacheKey() {
      return this.ShopID ? (this.ShopID + '_pendingMemberConsumeOrder') : 'pendingMemberConsumeOrder'
    },
    clearPendingMemberConsumeOrder() {
      try {
        const key = this.getPendingMemberConsumeCacheKey()
        if (key) {
          localStorage.removeItem(key)
        }
      } catch (e) {}
    },
    buildDdRouteLocation(sheetId) {
      return this.buildDdRouteUrl(sheetId)
    },
    buildDdRouteUrl(sheetId) {
      const routePath = this.DeskID === 'Food' ? '/dd' : '/MenuQx'
      let deskId = String(this.DeskID || '').trim()
      let phone = String((this.foods && this.foods.phone) || '').trim()
      let payState = String(this.PayState || '').trim()
      try {
        if (!deskId && this.ShopID) {
          deskId = String(localStorage.getItem(this.ShopID + '_pendingPayDeskID') || '').trim()
        }
        if (!phone && this.ShopID) {
          phone = String(localStorage.getItem(this.ShopID + '_foodPhone') || '').trim()
        }
      } catch (e) {}
      if (!deskId && this.$route && this.$route.query) {
        deskId = String(this.$route.query.id || this.$route.query.DeskID || '').trim()
      }
      if (!phone && this.$route && this.$route.query) {
        phone = String(this.$route.query.Phone || '').trim()
      }
      if (!payState && this.$route && this.$route.query) {
        payState = String(this.$route.query.PayState || '').trim()
      }
      const params = []
      params.push('Shopid=' + encodeURIComponent(String(this.ShopID || '').trim()))
      if (deskId) {
        params.push('id=' + encodeURIComponent(deskId))
      }
      if (phone) {
        params.push('Phone=' + encodeURIComponent(phone))
      }
      if (payState) {
        params.push('PayState=' + encodeURIComponent(payState))
      }
      const sheet = String(sheetId || '').trim()
      if (sheet) {
        params.push('SheetID=' + encodeURIComponent(sheet))
      }
      const number = this.$route && this.$route.query ? String(this.$route.query.Number || '').trim() : ''
      if (number) {
        params.push('Number=' + encodeURIComponent(number))
      }
      return routePath + '?' + params.join('&')
    },
    buildDdCallbackUrl(sheetId) {
      const href = this.buildDdRouteUrl(sheetId)
      const returnUrl = window.location.origin + href
      const ch = this.resolvedOnlinePayChannel
      return this.$lujin + '/api/YabandPay/PayCallback?return_url=' + encodeURIComponent(encodeURIComponent(returnUrl))
    },
    allinpayFormatAmountYuanToFen12(amountYuan) {
      const num = Number(amountYuan || 0)
      if (!isFinite(num) || num < 0) {
        return '000000000000'
      }
      const fen = Math.round(num * 100)
      return String(fen).replace(/[^\d]/g, '').padStart(12, '0').slice(-12)
    },
    allinpayBuildReqsn() {
      const r1 = Math.floor(100 + Math.random() * 900)
      const r2 = Math.floor(100 + Math.random() * 900)
      const d = new Date()
      const yymmdd =
        String(d.getFullYear()).slice(2) +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2)
      return String(r1) + yymmdd + String(r1) + String(r2)
    },
    allinpayRandomStr() {
      const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let s = ''
      for (let i = 0; i < 16; i++) {
        s += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return s
    },
    allinpayBuildParamStr(map) {
      if (!map || typeof map !== 'object') return ''
      const keys = Object.keys(map).filter(k => (
        map[k] !== undefined && map[k] !== null && String(map[k]) !== ''
      )).sort()
      return keys.map(k => String(k) + '=' + String(map[k])).join('&')
    },
    async allinpayImportPrivateKeyPkcs8(privateKeyBase64) {
      if (!window.crypto || !window.crypto.subtle) {
        throw new Error('当前浏览器不支持 Web Crypto，请使用后端中转签名')
      }
      const b64 = String(privateKeyBase64 || '').replace(/\s+/g, '')
      const raw = this._base64ToBytes(b64)
      const algo = { name: 'RSASSA-PKCS1-v1_5', hash: { name: 'SHA-1' } }
      const extractable = false
      const usages = ['sign']
      return window.crypto.subtle.importKey('pkcs8', raw.buffer, algo, extractable, usages)
    },
    _base64ToBytes(b64) {
      const bin = atob(b64)
      const len = bin.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i)
      return bytes
    },
    async allinpaySign(content, privateKeyBase64) {
      const key = await this.allinpayImportPrivateKeyPkcs8(privateKeyBase64)
      const encoder = new TextEncoder()
      const data = encoder.encode(String(content || ''))
      const signature = await window.crypto.subtle.sign({ name: 'RSASSA-PKCS1-v1_5' }, key, data)
      const sigBytes = new Uint8Array(signature)
      let binary = ''
      for (let i = 0; i < sigBytes.byteLength; i++) binary += String.fromCharCode(sigBytes[i])
      return btoa(binary)
    },
    getAllinpayPrivateKeyDevOnly() {
      const fromWin = typeof window !== 'undefined' && window.__DEV_ALLINPAY_PK ? String(window.__DEV_ALLINPAY_PK || '') : ''
      if (fromWin) return fromWin
      try {
        const raw = localStorage.getItem('__DEV_ALLINPAY_PK') || ''
        return raw || ''
      } catch (e) { return '' }
    },
    async fetchAllinpayInfo(shopId) {
      const sid = String(shopId || this.ShopID || '')
      if (!sid) return null
      const cacheKey = 'allinpay_info_' + sid
      try {
        const cached = sessionStorage.getItem(cacheKey)
        if (cached) {
          const info = JSON.parse(cached)
          if (info && info.CusID && info.AppID && info.PrivateKey) return info
        }
      } catch (e) {}
      try {
        const res = await this.axios.post(this.$lujin + '/api/YabandPay/AllinPayInfo', { ShopID: sid })
        const data = res && res.data ? res.data : res
        const d = data && data.Data ? data.Data : data
        if (d && d.CusID && d.AppID && d.PrivateKey) {
          const info = { CusID: String(d.CusID), AppID: String(d.AppID), PrivateKey: String(d.PrivateKey) }
          try { sessionStorage.setItem(cacheKey, JSON.stringify(info)) } catch (e) {}
          return info
        }
      } catch (e) {}
      return null
    },
    async callPayUrl(channel, params) {
      const ch = String(channel || this.resolvedOnlinePayChannel || this.PayChannel || this.PAYCHANNEL_YABAND).trim().toLowerCase()
      if (ch === this.PAYCHANNEL_ALLINPAY) {
        const ShopID = String(params && params.ShopID ? params.ShopID : (this.ShopID || ''))
        const AmountYuan = String(params && params.Amount !== undefined ? params.Amount : '0')
        const tradeId = String(params && params.trade_id || this.createPayTradeId())
        const body = 'scan&order'
        const payInfo = await this.fetchAllinpayInfo(ShopID)
        if (!payInfo || !payInfo.PrivateKey || !payInfo.CusID || !payInfo.AppID) {
          return { State: false, Message: '通联支付参数获取失败' }
        }
        const useDevDirect = payInfo.PrivateKey
        this.allinpayCusid = payInfo.CusID
        this.allinpayAppid = payInfo.AppID
        const useBackendByDirectSigning = !!useDevDirect && !!this.allinpayCusid && !!this.allinpayAppid
        console.log(useBackendByDirectSigning)
        if (useBackendByDirectSigning) {
          const cusid = this.allinpayCusid
          const appid = this.allinpayAppid
          const reqsn = this.allinpayBuildReqsn()
          const randomstr = this.allinpayRandomStr()
          const amountFen = Math.max(1, Math.round((Number(AmountYuan) || 0) * 100))
          const trxamt = String(amountFen).padStart(15, '0')
          // 支付完成后通联重定向地址，与 yabandpay 一样走回调地址跳回订单页
          const returl = this.$lujin+"/MenuQx?Shopid="+this.ShopID+"&id="+this.DeskID+"&PayState=7"
          const map = {
            appid,
            body,
            charset: 'UTF-8',
            cusid,
            randomstr,
            reqsn,
            returl,
            signtype: 'RSA',
            trxamt,
            version: '12',
          }
          const hasValue = v => v !== undefined && v !== null && String(v).length > 0
          const signParamsOrdered = Object.keys(map).slice().sort()
          const buildArr = []
          signParamsOrdered.forEach(k => {
            if (k === 'returl') buildArr.push('returl=' + String(returl))
            else if (hasValue(map[k])) buildArr.push(k + '=' + String(map[k]))
          })
          if (!buildArr.some(s => s.startsWith('returl='))) buildArr.push('returl=' + String(returl))
          let buildStr = buildArr.join('&')
          if (buildStr.indexOf('returl=') === -1) {
            buildStr = buildStr + (buildStr.length ? '&' : '') + 'returl=' + String(returl)
          }
          console.log('callPayUrl allinpay signBase=', buildStr)
          const sign = await this.topayurl_Sign(buildStr, useDevDirect)
          map.sign = sign
          console.log('callPayUrl allinpay sign=', sign)
          const submitKeys = signParamsOrdered.concat(['sign'])
          const submitParams = {}
          submitKeys.forEach(k => {
            if (k === 'returl') submitParams.returl = String(returl)
            else if (k === 'sign') submitParams.sign = String(sign)
            else if (hasValue(map[k])) submitParams[k] = String(map[k])
          })
          if (!submitParams.returl || submitParams.returl.length === 0) submitParams.returl = String(returl)
          const envMode = 'prod'
          const urlBase = envMode === 'prod' ? 'https://syb.allinpay.com' : 'https://syb-test.allinpay.com'
          const Url = urlBase + '/apiweb/h5unionpay/unionorder'
          console.log('callPayUrl allinpay Url=', Url, 'submitParams=', submitParams)
          // 不在此处立即跳转，等 PlaceOrder_ThirdPayV2 下单成功后再提交表单跳转
          return { State: true, Data: { Trade_id: tradeId, PayUrl: Url, Reqsn: reqsn, DirectForm: true, formData: submitParams, formAction: Url } }
        }
      }
      const body = {
        ShopID: params.ShopID,
        Amount: params.Amount,
        trade_id: params.trade_id,
        account: params.account,
        CallBackUrl: params.CallBackUrl,
      }
      return this.axios.post(this.$lujin + '/api/YabandPay/PayUrl', body).then(r => r && r.data ? r.data : { State: false })
    },
    async callPayQuery(channel, params) {
      const ch = String(channel || this.resolvedOnlinePayChannel || this.PayChannel || this.PAYCHANNEL_YABAND).trim().toLowerCase()
      if (ch === this.PAYCHANNEL_ALLINPAY) {
        const tradeId = String(params && params.trade_id ? params.trade_id : '')
        const amount = String(params && params.Amount ? params.Amount : '')
        const useDevDirect = this.getAllinpayPrivateKeyDevOnly()
        const useDev = !!useDevDirect && !!this.allinpayCusid && !!this.allinpayAppid
        if (useDev) {
          const cusid = this.allinpayCusid
          const appid = this.allinpayAppid
          const reqsn = this.allinpayBuildReqsn()
          const randomstr = this.allinpayRandomStr()
          const trxamt = this.allinpayFormatAmountYuanToFen12(amount)
          const map = { cusid, appid, version: '12', trxamt, reqsn, oldreqsn: '', trxid: tradeId, randomstr, signtype: 'RSA', charset: 'UTF-8' }
          const signBase = this.allinpayBuildParamStr(map)
          const sign = await this.allinpaySign(signBase, useDevDirect)
          const fd = new FormData()
          Object.keys(map).forEach(k => fd.append(k, String(map[k])))
          fd.append('sign', String(sign))
          const url = String(this.allinpayBaseUrl || '').replace(/\/$/, '') + '/query'
          try {
            const resp = await fetch(url, { method: 'POST', body: fd })
            const text = await resp.text()
            let json = null
            try { json = typeof text === 'string' ? JSON.parse(text) : text } catch (e) { json = { raw: text } }
            const trxstatus = String(json && json.trxstatus ? json.trxstatus : '')
            if (trxstatus === '0000') return { Info: 'paid' }
            const retcode = String(json && json.retcode ? json.retcode : '')
            if (retcode === 'SUCCESS') return { Info: 'notpaid' }
            return { Info: 'pending' }
          } catch (e) {
            return { Info: 'pending' }
          }
        }
        const body2 = { ShopID: params.ShopID, Amount: amount, trade_id: tradeId, account: params.account }
        return this.axios.post(this.$lujin + '/api/Allinpay/PayQuery', body2).then(r => r && r.data ? r.data : { Info: 'pending' })
      }
      return this.axios.post(this.$lujin + '/api/YabandPay/PayQuery', params).then(r => r && r.data ? r.data : { Info: 'pending' })
    },
    redirectToDdWithSheet(sheetId) {
      const href = this.buildDdRouteUrl(sheetId)
      try { this.clearUserCart() } catch (e) {}
      this.$router.push(href)
    },
    createPayTradeId() {
      const cryptoObj = window.crypto || window.msCrypto
      if (!cryptoObj || !cryptoObj.getRandomValues) {
        return String(Date.now()) + '_' + String(Math.floor(Math.random() * 1000000000))
      }
      const bytes = new Uint8Array(16)
      cryptoObj.getRandomValues(bytes)
      bytes[6] = (bytes[6] & 0x0f) | 0x40
      bytes[8] = (bytes[8] & 0x3f) | 0x80
      const hex = Array.from(bytes).map(b => ('00' + b.toString(16)).slice(-2))
      return [
        hex.slice(0, 4).join(''),
        hex.slice(4, 6).join(''),
        hex.slice(6, 8).join(''),
        hex.slice(8, 10).join(''),
        hex.slice(10, 16).join('')
      ].join('-')
    },
    async cachePendingMemberConsumeOrder(sheetId, selectedList, opTime) {
      if (!this.memberSN || !this.memberDisplayName) {
        this.clearPendingMemberConsumeOrder()
        return
      }
      const sheet = String(sheetId || '').trim()
      if (!sheet) {
        this.clearPendingMemberConsumeOrder()
        return
      }
      let appKey = ''
      try {
        appKey = localStorage.getItem(this.getMemberAppKeyCacheKey()) || ''
      } catch (e) {}
      if (!appKey) {
        appKey = await this.getMemberAppKey()
      }
      const payload = {
        sheetID: sheet,
        shopID: String(this.ShopID || ''),
        memberSn: String(this.memberSN || ''),
        sumMoney: Number((this.getOrderTotal() || 0).toFixed(this.DecimalBit)),
        memberMoney: 0,
        reMoney: Number((this.getOrderTotalBeforeCoupon() || 0).toFixed(this.DecimalBit)),
        subMoney: Number((this.getCouponDiscount() || 0).toFixed(this.DecimalBit)),
        saleTaxMoney: 0,
        accTime: this.formatMemberDateTime(opTime || this.buildOpTime()),
        orderState: 1,
        items: this.buildMemberConsumeItems(selectedList, opTime),
        couponItems: this.buildMemberConsumeCouponItems()
      }
      try {
        localStorage.setItem(this.getPendingMemberConsumeCacheKey(), JSON.stringify({
          appKey,
          selectedCouponKeys: Array.isArray(this.selectedCouponKeys) ? this.selectedCouponKeys.slice() : [],
          payload
        }))
      } catch (e) {}
    },
    getPaySubmitLockKey() {
      return this.ShopID ? (this.ShopID + '_pendingPaySubmitLock') : ''
    },
    getPayPlacedTradeKey() {
      return this.ShopID ? (this.ShopID + '_pendingPayPlacedTradeId') : ''
    },
    isPayTradePlaced(tradeId) {
      const id = String(tradeId || '')
      if (!id) {
        return false
      }
      try {
        const placedKey = this.getPayPlacedTradeKey()
        if (!placedKey) {
          return false
        }
        const placedTradeId = localStorage.getItem(placedKey)
        return !!placedTradeId && String(placedTradeId) === id
      } catch (e) {}
      return false
    },
    clearPaySubmitState() {
      this.paySubmitLockTradeId = ''
      try {
        const lockKey = this.getPaySubmitLockKey()
        const placedKey = this.getPayPlacedTradeKey()
        if (lockKey) {
          localStorage.removeItem(lockKey)
        }
        if (placedKey) {
          localStorage.removeItem(placedKey)
        }
      } catch (e) {}
    },
    isPayTradeHandled(tradeId) {
      const id = String(tradeId || '')
      if (!id) {
        return false
      }
      if (this.paySubmitLockTradeId === id) {
        return true
      }
      try {
        const placedKey = this.getPayPlacedTradeKey()
        if (placedKey) {
          const placedTradeId = localStorage.getItem(placedKey)
          if (placedTradeId && String(placedTradeId) === id) {
            return true
          }
        }
        const lockKey = this.getPaySubmitLockKey()
        if (lockKey) {
          const raw = localStorage.getItem(lockKey)
          if (raw) {
            let lock = null
            try {
              lock = JSON.parse(raw)
            } catch (e) {
              lock = { tradeId: raw, time: Date.now() }
            }
            if (lock && String(lock.tradeId || '') === id && Date.now() - Number(lock.time || 0) < 30000) {
              return true
            }
          }
        }
      } catch (e) {}
      return false
    },
    acquirePaySubmitLock(tradeId) {
      const id = String(tradeId || '')
      if (!id) {
        return false
      }
      if (this.isPayTradeHandled(id)) {
        return false
      }
      this.paySubmitLockTradeId = id
      try {
        const lockKey = this.getPaySubmitLockKey()
        if (lockKey) {
          localStorage.setItem(lockKey, JSON.stringify({
            tradeId: id,
            time: Date.now()
          }))
        }
      } catch (e) {}
      return true
    },
    releasePaySubmitLock(tradeId) {
      const id = String(tradeId || this.paySubmitLockTradeId || '')
      if (id && this.paySubmitLockTradeId && this.paySubmitLockTradeId !== id) {
        return
      }
      this.paySubmitLockTradeId = ''
      try {
        const lockKey = this.getPaySubmitLockKey()
        if (lockKey) {
          const raw = localStorage.getItem(lockKey)
          if (!raw) {
            return
          }
          let lock = null
          try {
            lock = JSON.parse(raw)
          } catch (e) {
            lock = { tradeId: raw }
          }
          if (!id || !lock || !lock.tradeId || String(lock.tradeId) === id) {
            localStorage.removeItem(lockKey)
          }
        }
      } catch (e) {}
    },
    markPayTradePlaced(tradeId) {
      const id = String(tradeId || '')
      if (!id) {
        return
      }
      this.paySubmitLockTradeId = id
      try {
        const placedKey = this.getPayPlacedTradeKey()
        const lockKey = this.getPaySubmitLockKey()
        if (placedKey) {
          localStorage.setItem(placedKey, id)
        }
        if (lockKey) {
          localStorage.removeItem(lockKey)
        }
      } catch (e) {}
    },
    buildOnlinePendingOrderPayload(selected) {
      const list = Array.isArray(selected) ? selected : []
      const sj = this.data_s || this.buildOpTime()
      const payStateNum = this.resolvedOnlinePayChannel === this.PAYCHANNEL_ALLINPAY ? Number(this.PAYSTATE_ALLINPAY) : Number(this.PAYSTATE_YABAND)
      return {
        bz: '',
        zhuoid: this.DeskID,
        ShopID: this.ShopID,
        list: list.map(v => this.normalizeOrderRow(v)),
        OrderMen: this.foods.name || '',
        OrderPhone: this.foods.phone || '',
        OrderAddress: this.foodzt === 1 ? (this.foods.dizi || '') : '',
        PostCode:this.foods.youb,
        OpTime: this.buildOpTime(),
        CompleteTime: this.DeskID === 'Food' && this.foodzt === 1 ? sj : '1900-01-01 00:00:00',
        ToshopTime: this.DeskID === 'Food' && this.foodzt === 0 ? sj : '1900-01-01 00:00:00',
        ServerMoney: this.getServiceFee(),
        PackMoney: this.getPackingFee(),
        TipMoney: this.getTipAmount(),
        SheetState: this.DeskID === 'Food' && this.foodzt === 0 ? 4 : (this.DeskID === 'Food' && this.foodzt === 1 ? 3 : 0),
        PayState: payStateNum,
        IsPay: 0,
        UserAgent: navigator.userAgent,
        IsOnlinePay: true,
        trad_id: ''
      }
    },
    processOnlinePay() {
	  //在线支付
      const payToken = Date.now()
      const generatedTradeId = this.createPayTradeId()
      this._payToken = payToken
      this.orderSubmitting = true
      this.orderLoadingVisible = true
      this.orderLoadingText = this.$lang[this.pickxb].l28
      this.syncBodyScrollLock()
      this.clearPaySubmitState()
      const list = this.readCartFromStorage()
      const selected = this.getSelectedOrderList(list)
      const payAmount = this.getOrderTotal().toFixed(this.DecimalBit)
      const channel = this.resolvedOnlinePayChannel

      const payUrlData = {
        ShopID: this.ShopID,
        Amount: payAmount,
        trade_id: generatedTradeId,
        account: this.foods.phone || '',
        CallBackUrl: this.buildDdCallbackUrl('')
      }
      console.log(payUrlData)
      console.log(channel)
      console.log(payAmount)
      this.callPayUrl(channel, payUrlData)
        .then(payResRaw => {
		  console.log(payResRaw)
          const payRes = payResRaw && payResRaw.State !== undefined ? payResRaw : (payResRaw && payResRaw.data ? payResRaw.data : payResRaw)
          const data = payRes && payRes.Data ? payRes.Data : null
          if (data && (data.Trade_id || data.trade_id || data.tradeId || data.TradeID)) {
            if (!data.PayUrl && payRes && payRes.PayUrl) data.PayUrl = payRes.PayUrl
          }
          const payData = data ? data : (payRes || {})
          console.log(payData)
          console.log(payData && (payData.Trade_id || payData.trade_id))
          if (this._payToken !== payToken) {
            return
          }
          if (!(payRes && payRes.State) || !payData) {
            this.orderSubmitting = false
            this.orderLoadingVisible = false
            this.orderLoadingText = ''
            this.syncBodyScrollLock()
            this.payLoading = false
            const msg = payRes && payRes.Message ? String(payRes.Message) : this.$lang[this.pickxb].l96
            this.showSetMealAlert(this.$lang[this.pickxb].l17, msg)
            return
          }
          this.paydata = payData
          const returnedTradeId = payData ? (payData.Trade_id || payData.trade_id || payData.TradeID || payData.tradeId) : ''
          const tradeId = String(returnedTradeId || generatedTradeId || '').trim()
          if (!tradeId) {
            this.orderSubmitting = false
            this.orderLoadingVisible = false
            this.orderLoadingText = ''
            this.syncBodyScrollLock()
            this.payLoading = false
            this.showSetMealAlert(this.$lang[this.pickxb].l17, this.$lang[this.pickxb].l96)
            return
          }

          const pendingPayload = this.buildOnlinePendingOrderPayload(selected)
          pendingPayload.trad_id = tradeId

          const isAllinpay = channel === this.PAYCHANNEL_ALLINPAY
          const placeOrderUrl = this.$lujin + (isAllinpay ? '/api/Default/PlaceOrder_ThirdPayV2' : '/api/Default/PlaceOrder_ThirdPay')
          if (isAllinpay) {
            pendingPayload.cusid = this.allinpayCusid
            pendingPayload.appid = this.allinpayAppid
            pendingPayload.reqsn = payData.Reqsn || ''
          }

          this.axios.post(placeOrderUrl, pendingPayload)
            .then(res => {
              console.log("普通餐楼支付", res)
              if (this._payToken !== payToken) {
                return
              }
              const ok = !!(res && res.data && res.data.state)
              const sheet = res && res.data ? (res.data.sheet || '') : ''
              if (!ok || !sheet) {
                this.orderSubmitting = false
                this.orderLoadingVisible = false
                this.orderLoadingText = ''
                this.syncBodyScrollLock()
                this.payLoading = false
                this.showOrderTip(this.$lang[this.pickxb].l29)
                return
              }
              Promise.resolve(this.cachePendingMemberConsumeOrder(sheet, selected, pendingPayload.OpTime))
                .catch(() => {})
                .finally(() => {
                  this.orderSubmitting = false
                  this.orderLoadingVisible = false
                  this.orderLoadingText = ''
                  this.syncBodyScrollLock()
                  this.payLoading = true
                  try {
                    if (this.ShopID) {
                      localStorage.setItem(this.ShopID + '_pendingPayShopID', this.ShopID)
                      localStorage.setItem(this.ShopID + '_pendingPayDeskID', this.DeskID)
                      localStorage.setItem(this.ShopID + '_pendingPayFoodState', this.foodzt)
                      localStorage.setItem(this.ShopID + '_pendingPayFoods', JSON.stringify(this.foods))
                      localStorage.setItem(this.getPendingPaySheetKey(), String(sheet))
                      localStorage.setItem(this.ShopID + '_pendingPayTradeId', tradeId)
                      localStorage.setItem(this.ShopID + '_pendingPayChannel', String(channel || this.resolvedOnlinePayChannel || this.PAYCHANNEL_YABAND))
                      localStorage.setItem(this.ShopID + '_pendingPayChannelState', String(this.PayState || ''))
                    }
                  } catch (e) {}
                  if (this.paygettime) {
                    clearInterval(this.paygettime)
                  }
                  const queryData = {
                    ShopID: this.ShopID,
                    Amount: payAmount,
                    trade_id: tradeId,
                    account: this.foods.phone
                  }
                  this.paygettime = setInterval(() => {
                    this.callPayQuery(channel, queryData)
                      .then(ressRaw => {
                        const ress = ressRaw && ressRaw.Info !== undefined ? ressRaw : (ressRaw && ressRaw.data ? ressRaw.data : ressRaw)
                        if (ress && ress.Info === 'paid') {
                          try { this.clearUserCart() } catch (e) {}
                          this.stopPayPollingOnly()
                          this.redirectToDdWithSheet(sheet)
                        }
                      })
                      .catch(() => {})
                  }, 3000)
                  if (this.isOnlinePayEnabled) {
                    try { this.clearUserCart() } catch (e) {}
                  }
                  if (payData && payData.DirectForm && payData.formData && payData.formAction) {
                    this.submitAllinpayForm(payData.formData, payData.formAction)
                  } else {
                    this.openPayUrl(payData.PayUrl)
                  }
                })
            })
            .catch(() => {
              this.orderSubmitting = false
              this.orderLoadingVisible = false
              this.orderLoadingText = ''
              this.syncBodyScrollLock()
              this.payLoading = false
              this.showOrderTip(this.$lang[this.pickxb].l29)
            })
        })
        .catch(err => {
          const msg = err && err.message ? String(err.message) : ''
          this.orderSubmitting = false
          this.orderLoadingVisible = false
          this.orderLoadingText = ''
          this.syncBodyScrollLock()
          this.payLoading = false
          this.showSetMealAlert(this.$lang[this.pickxb].l17, msg || this.$lang[this.pickxb].l96)
        })
    },
    buildOnlinePaidOrderPayload(selected, tradeId) {
      const list = Array.isArray(selected) ? selected : []
      const sj = this.data_s || this.buildOpTime()
      const payStateNum = this.resolvedOnlinePayChannel === this.PAYCHANNEL_ALLINPAY ? Number(this.PAYSTATE_ALLINPAY) : Number(this.PAYSTATE_YABAND)
      return {
        bz: '',
        zhuoid: this.DeskID,
        ShopID: this.ShopID,
        list: list.map(v => this.normalizeOrderRow(v)),
        OrderMen: this.foods.name || '',
        OrderPhone: this.foods.phone || '',
        OrderAddress: this.foodzt === 1 ? (this.foods.dizi || '') : '',
        PostCode:this.foods.youb,
        OpTime: this.buildOpTime(),
        CompleteTime: this.DeskID === 'Food' && this.foodzt === 1 ? sj : '1900-01-01 00:00:00',
        ToshopTime: this.DeskID === 'Food' && this.foodzt === 0 ? sj : '1900-01-01 00:00:00',
        ServerMoney: this.getServiceFee(),
        PackMoney:this.getPackingFee(),
        TipMoney:this.getTipAmount(),
        SheetState: this.DeskID === 'Food' && this.foodzt === 0 ? 4 : (this.DeskID === 'Food' && this.foodzt === 1 ? 3 : 0),
        PayState: payStateNum,
        IsPay: 1,
        UserAgent: navigator.userAgent,
        IsOnlinePay: true,
        trad_id: String(tradeId || '')
      }
    },
    submitZeroAmountOnlineOrder() {
      const list = this.readCartFromStorage()
      const selected = this.getSelectedOrderList(list)
      const payload = this.buildOnlinePaidOrderPayload(selected, '')
      this.orderSubmitting = true
      this.orderLoadingVisible = true
      this.orderLoadingText = this.$lang[this.pickxb].l28
      this.syncBodyScrollLock()
          console.log(payload)
      this.axios
        .post(this.$lujin + '/api/Default/Place_the_order', payload)
        .then((res) => {
		  console.log("0元下单支付",res)
          const ok = !!(res && res.data && res.data.state)
          const sheet = res && res.data ? (res.data.sheet || '') : ''
          if (!ok || !sheet) {
            this.orderSubmitting = false
            this.orderLoadingVisible = false
            this.orderLoadingText = ''
            this.syncBodyScrollLock()
            this.showOrderTip(this.$lang[this.pickxb].l29)
            return
          }
          this.clearUserCart()
          this.startOrderPoll(sheet)
        })
        .catch(() => {
          this.orderSubmitting = false
          this.orderLoadingVisible = false
          this.orderLoadingText = ''
          this.syncBodyScrollLock()
          this.showOrderTip(this.$lang[this.pickxb].l29)
        })
    },
    getOrderTotal() {
      const total = this.roundMoney(this.getOrderTotalBeforeCoupon()) - this.roundMoney(this.getCouponDiscount())
      return total > 0 ? this.roundMoney(total) : 0
    },
    restoreGoodsViewMode() {
      try {
        const raw = localStorage.getItem('menu_goods_view_mode')
        const val = Number(raw)
        if (val === 1 || val === 2 || val === 3) {
          this.goodsViewMode = val
        }
      } catch (e) {}
    },
    toggleGoodsView() {
      const next = this.goodsViewMode === 3 ? 1 : this.goodsViewMode + 1
      this.goodsViewMode = next
      try {
        localStorage.setItem('menu_goods_view_mode', String(next))
      } catch (e) {}
    },
    updateTopFixedHeight() {
      const el = this.$refs.topSticky
      if (!el || !el.getBoundingClientRect) {
        if (this.topFixedHeight !== 0) {
          this.topFixedHeight = 0
        }
        return
      }
      const rect = el.getBoundingClientRect()
      const nextHeight = Math.ceil(rect.height || 0)
      if (nextHeight !== this.topFixedHeight) {
        this.topFixedHeight = nextHeight
      }
    },
    initBannerAutoplay() {
      this.clearBannerAutoplay()
      this.$nextTick(() => {
        const swiperInstance = this.$refs.menuSwiper && this.$refs.menuSwiper.swiper
        if (!swiperInstance || this.bannerPics.length <= 1) {
          return
        }
        swiperInstance.slideTo(1, 0, false)
        this.bannerTimer = setInterval(() => {
          const currentIndex = swiperInstance.activeIndex || 0
          const nextIndex = currentIndex >= this.displayBannerPics.length - 1 ? 1 : currentIndex + 1
          swiperInstance.slideTo(nextIndex, 300, false)
        }, 3000)
      })
    },
    clearBannerAutoplay() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer)
        this.bannerTimer = null
      }
    },
    handleBannerChange() {
      const swiperInstance = this.$refs.menuSwiper && this.$refs.menuSwiper.swiper
      if (!swiperInstance || !this.bannerPics.length) {
        return
      }
      const lastRealIndex = this.bannerPics.length - 1
      const lastDisplayIndex = this.displayBannerPics.length - 1
      const activeIndex = swiperInstance.activeIndex || 0
      if (activeIndex <= 0) {
        this.currentBannerIndex = lastRealIndex
        swiperInstance.slideTo(lastRealIndex + 1, 0, false)
        return
      }
      if (activeIndex >= lastDisplayIndex) {
        this.currentBannerIndex = 0
        swiperInstance.slideTo(1, 0, false)
        return
      }
      this.currentBannerIndex = activeIndex - 1
    },
    getAssetUrl(suffix) {
      if (!this.ShopID) {
        return ''
      }
      return this.$lujin + '/Data/' + this.ShopID + suffix + '?t=' + Date.now()
    },
    formatClockFromDateTime(val) {
      const raw = String(val || '').trim()
      if (!raw) {
        return ''
      }
      const m = raw.match(/T(\d{2}):(\d{2})(?::\d{2})?/) || raw.match(/(\d{2}):(\d{2})(?::\d{2})?/)
      if (!m) {
        return ''
      }
      return m[1] + ':' + m[2]
    },
    loadShopInfo() {
      this.axios
        .post(this.$lujin + '/api/Default/Parameter?ShopID=' + this.ShopID)
        .then((res) => {
		  console.log(res)
          if (res.data && res.data.data && res.data.data[0] && res.data.data[0].Shop) {
            this.shopName = res.data.data[0].Shop
          }
		  if (res.data && res.data.data && res.data.data[0] && res.data.data[0].VipState) {
		    this.VipState = res.data.data[0].VipState
		  }
          if (res.data && res.data.data && res.data.data[0]) {
            const row = res.data.data[0]
            if (row.Address) {
              this.shopIntro = row.Address
            } else if (row.SeverWeb) {
              this.shopIntro = row.SeverWeb
            }
            const phoneCandidates = [
              row.Phone,
              row.Tel,
              row.Telephone,
              row.TelPhone,
              row.Telphone,
              row.Mobile,
              row.ShopPhone,
              row.ShopTel,
              row.ContactPhone,
              row.ContactTel
            ]
            const phone = phoneCandidates.find(v => String(v || '').trim())
            this.shopPhone = phone ? String(phone).trim() : ''
            this.dineStartTime = this.formatClockFromDateTime(row.InDineSatrtTime || row.InDineStartTime)
            this.dineEndTime = this.formatClockFromDateTime(row.InDineEndTime)
            const madeDepotFlag = Number(row.IsMadeDepot)
            const nextMadeDepotEnabled = madeDepotFlag === 1
            if (nextMadeDepotEnabled !== this.isMadeDepotEnabled) {
              this.isMadeDepotEnabled = nextMadeDepotEnabled
            }
            if (!this.isMadeDepotEnabled) {
              this.madeDepotList = []
              this.activeMadeDepotId = ''
            } else {
              this.loadMadeDepotList()
            }
            if (row.DeskMin !== undefined && !(this.diningMinutes > 0)) {
              const v = Number(row.DeskMin || 0)
              this.diningMinutes = isFinite(v) ? v : 0
            }
          }
          if (res.data && res.data.data && res.data.data[0] && res.data.data[0].MoneySymbol) {
            this.MoneySymbol = res.data.data[0].MoneySymbol
          }
          if (res.data && res.data.data && res.data.data[0] && res.data.data[0].DecimalBit !== undefined) {
            const bit = Number(res.data.data[0].DecimalBit)
            this.DecimalBit = isFinite(bit) ? bit : 2
          }
		  if (res.data && res.data.data && res.data.data[0] && res.data.data[0].IsNewGoodsRemark !== undefined) {
		    const bit = Number(res.data.data[0].DecimalBit)
		    this.IsNewGoodsRemark = res.data.data[0].IsNewGoodsRemark
		  }
        })
        .catch(() => {})
    },
    loadDeskInfo() {
      this.axios
        .get(this.$lujin + '/api/Default/cha_zuo?ShopID=' + this.ShopID + '&DeskID=' + this.DeskID)
        .then((res) => {
          if (res.data && res.data.data && res.data.data[0] && res.data.data[0].Desk) {
            this.deskName = res.data.data[0].Desk
          }
          if (res.data && res.data.data && res.data.data[0] && res.data.data[0].DeskMin !== undefined) {
            const v = Number(res.data.data[0].DeskMin || 0)
            this.diningMinutes = isFinite(v) ? v : 0
          }
        })
        .catch(() => {})

      this.axios
        .post(this.$lujin + '/api/default/TDeskzt?ShopID=' + this.ShopID + '&DeskID=' + this.DeskID)
        .then((res) => {
          if (res.data && res.data[0]) {
            this.IsBuffet = res.data[0].IsBuffet
            this.IsBuffetzt = res.data[0].IsBuffet
            this.BuffetTypeID = res.data[0].BuffetTypeID
            this.Numberpoints = res.data[0].Numberpoints
            try {
              localStorage.setItem(this.ShopID + '_IsBuffet', String(this.IsBuffet))
              localStorage.setItem(this.ShopID + '_BuffetTypeID', String(this.BuffetTypeID))
              localStorage.setItem(this.ShopID + '_Numberpoints', String(this.Numberpoints))
            } catch (e) {}
            if (res.data[0].TableTime !== undefined) {
              const tableTime = Number(res.data[0].TableTime)
              const now = parseInt(Date.now() / 1000)
              if (tableTime < now) {
                this.DeskMin = '0'
                this.IsBuffet = 0
              } else {
                this.DeskMin = String(parseInt((tableTime - now) / 60))
              }
            }
            this.loadMenuTypes()
            this.loadGoods()
          }
        })
        .catch(() => {})

      this.deskTimer = setInterval(() => {
        this.axios
          .post(this.$lujin + '/api/default/TDeskzt?ShopID=' + this.ShopID + '&DeskID=' + this.DeskID)
          .then((res) => {
            if (res.data && res.data[0] && res.data[0].TableTime !== undefined) {
              const tableTime = Number(res.data[0].TableTime)
              const now = parseInt(Date.now() / 1000)
              if (tableTime < now) {
                this.DeskMin = '0'
                this.IsBuffet = 0
              } else {
                this.DeskMin = String(parseInt((tableTime - now) / 60))
              }
            }
          })
      }, 60000)
    },
    loadMenuTypes() {
      this.axios
        .get(this.$lujin + '/api/Default/MenuType?ShopID=' + this.ShopID)
        .then((res) => {
          let list = res.data
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.Table)) {
            list = list.Table
          } else if (list && list.data && Array.isArray(list.data)) {
            list = list.data
          } else if (list && list.data && Array.isArray(list.data.Table)) {
            list = list.data.Table
          }
          let menuTypes = Array.isArray(list) ? list : []
          if (this.IsBuffet && this.BuffetTypeID) {
            for (let hj = 0; hj < menuTypes.length; hj++) {
              const MaxMoney = String(menuTypes[hj].BuffetMaxMoney || '').split(',')
              const MaxQua = String(menuTypes[hj].BuffetMaxQua || '').split(',')
              const MaxType = String(menuTypes[hj].BuffetChooseType || '').split(',')
              for (let mon = 0; mon < MaxMoney.length; mon++) {
                const Moneys = MaxMoney[mon].split(':')
                if (Moneys[0] === this.BuffetTypeID) {
                  menuTypes[hj].Moneys = parseFloat(Moneys[1]) || 0
                }
              }
              for (let mon = 0; mon < MaxQua.length; mon++) {
                const quas = MaxQua[mon].split(':')
                if (quas[0] === this.BuffetTypeID) {
                  menuTypes[hj].MaxQua = quas[1] || ''
                }
              }
              for (let mon = 0; mon < MaxType.length; mon++) {
                const quas = MaxType[mon].split(':')
                if (quas[0] === this.BuffetTypeID) {
                  menuTypes[hj].MaxType = quas[1] || ''
                }
              }
            }
          }
          this.menuTypes = menuTypes
          this.ensureActiveCategoryIdValid()
          this.$nextTick(() => {
            this.updateTopFixedHeight()
          })
        })
        .catch(() => {})
    },
    loadMadeDepotList() {
      if (!this.ShopID) {
        return
      }
      this.axios
        .get(this.$lujin + '/api/Default/MadeDepot?ShopID=' + this.ShopID)
        .then((res) => {
          let list = res.data
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          } else if (list && Array.isArray(list.Data)) {
            list = list.Data
          } else if (list && Array.isArray(list.Table)) {
            list = list.Table
          }
          this.madeDepotList = Array.isArray(list) ? list : []
          if (this.madeDepotList.length) {
            const currentId = this.activeMadeDepotId
            const found = this.madeDepotList.some(v => v && String(v.MadeDepotID || v.id) === String(currentId))
            if (!found) {
              this.activeMadeDepotId = this.madeDepotList[0].MadeDepotID || this.madeDepotList[0].id || ''
            }
          } else {
            this.activeMadeDepotId = ''
          }
          this.ensureActiveCategoryIdValid()
          this.$nextTick(() => {
            this.updateTopFixedHeight()
          })
        })
        .catch(() => {})
    },
    onMadeDepotClick(item) {
      const id = item && (item.MadeDepotID || item.id)
      if (id === undefined || id === null || String(id) === '') {
        return
      }
      if (String(this.activeMadeDepotId) === String(id)) {
        this.$nextTick(() => {
          this.ensureCategoryInView()
        })
        return
      }
      this.activeMadeDepotId = id
      this.ensureActiveCategoryIdValid()
    },
    ensureActiveCategoryIdValid() {
      const list = this.displayMenuTypes || []
      if (!list.length) {
        if (this.activeCategoryId) {
          this.activeCategoryId = ''
        }
        return
      }
      const current = this.activeCategoryId
      const found = list.some(item => {
        const id = item && (item.TypeID || item.typeId)
        return id != null && current != null && String(id) === String(current)
      })
      if (!found) {
        const first = list[0]
        this.activeCategoryId = first && (first.TypeID || first.typeId) ? (first.TypeID || first.typeId) : ''
      }
      this.$nextTick(() => {
        this.ensureCategoryInView()
      })
    },
    findActiveCategoryEl() {
      try {
        const barEl = this.$refs && this.$refs.categoriesBar
        if (!barEl || !barEl.querySelectorAll) {
          return null
        }
        const tid = String(this.activeCategoryId || '')
        if (!tid) {
          return null
        }
        const list = Array.prototype.slice.call(barEl.querySelectorAll('.menu-category-item'))
        for (let i = 0; i < list.length; i++) {
          const el = list[i]
          if (!el || !el.getAttribute) {
            continue
          }
          const typeList = this.displayMenuTypes || []
          const matched = typeList[i]
          const mtid = String(matched && (matched.TypeID || matched.typeId) != null ? (matched.TypeID || matched.typeId) : '')
          if (mtid && mtid === tid) {
            return el
          }
        }
        return null
      } catch (e) {
        return null
      }
    },
    findActiveMadeDepotEl() {
      try {
        const barEl = this.$refs && this.$refs.depotBar
        if (!barEl || !barEl.querySelectorAll) {
          return null
        }
        const tid = String(this.activeMadeDepotId || '')
        if (!tid) {
          return null
        }
        const list = Array.prototype.slice.call(barEl.querySelectorAll('.menu-category-item'))
        const typeList = this.madeDepotList || []
        for (let i = 0; i < list.length; i++) {
          const el = list[i]
          const matched = typeList[i]
          const mtid = String(matched && (matched.MadeDepotID || matched.id) != null ? (matched.MadeDepotID || matched.id) : '')
          if (mtid && mtid === tid) {
            return el
          }
        }
        return null
      } catch (e) {
        return null
      }
    },
    ensureScrollElInView(scrollEl, targetEl) {
      if (!scrollEl || !targetEl || !scrollEl.getBoundingClientRect || !targetEl.getBoundingClientRect) {
        return
      }
      const containerRect = scrollEl.getBoundingClientRect()
      const itemRect = targetEl.getBoundingClientRect()
      if (!containerRect || !itemRect) {
        return
      }
      const cw = Number(containerRect.width) || 0
      const iw = Number(itemRect.width) || 0
      const localLeft = Number(itemRect.left) - Number(containerRect.left)
      const localRight = localLeft + iw
      const currentLeft = Number(scrollEl.scrollLeft) || 0
      let nextLeft = currentLeft
      const padding = 0.24 * (window.innerWidth ? (window.innerWidth / 7.5) : 1)
      if (localLeft < padding) {
        nextLeft = Math.max(0, currentLeft + localLeft - padding)
      } else if (localRight > cw - padding) {
        nextLeft = currentLeft + (localRight - cw) + padding
      } else {
        const targetLeft = currentLeft + (localLeft + iw / 2) - (cw / 2)
        nextLeft = Math.max(0, targetLeft)
      }
      if (Math.abs(nextLeft - currentLeft) < 0.5) {
        return
      }
      try {
        if (typeof scrollEl.scrollTo === 'function') {
          scrollEl.scrollTo({ left: nextLeft, top: 0, behavior: 'smooth' })
        } else {
          scrollEl.scrollLeft = nextLeft
        }
      } catch (e) {
        try {
          scrollEl.scrollLeft = nextLeft
        } catch (err) {}
      }
    },
    ensureCategoryInView() {
      try {
        const barEl = this.$refs && this.$refs.categoriesBar
        const itemEl = this.findActiveCategoryEl()
        if (barEl && itemEl) {
          this.ensureScrollElInView(barEl, itemEl)
        }
        const depotBarEl = this.$refs && this.$refs.depotBar
        const depotItemEl = this.findActiveMadeDepotEl()
        if (depotBarEl && depotItemEl) {
          this.ensureScrollElInView(depotBarEl, depotItemEl)
        }
      } catch (e) {}
    },
    getMadeDepotName(item) {
      if (!item) {
        return ''
      }
      if (this.WXLangGoodsxb === 1) {
        return item.TwoMadeDepot || item.MadeDepot || item.ThreeMadeDepot || ''
      }
      if (this.WXLangGoodsxb === 2) {
        return item.ThreeMadeDepot || item.MadeDepot || item.TwoMadeDepot || ''
      }
      return item.MadeDepot || item.TwoMadeDepot || item.ThreeMadeDepot || ''
    },
    getMadeDepotInitial(item) {
      const text = this.getMadeDepotName(item)
      return text ? text.slice(0, 1) : 'D'
    },
    loadGoods() {
      const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const now = new Date()
      const Week = weekDays[now.getDay()]
      const WeekQua = now.getDay() === 0 ? 7 : now.getDay()
      const hh = now.getHours()
      const mm = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
      const ss = now.getSeconds() < 10 ? '0' + now.getSeconds() : now.getSeconds()
      const time = hh + ':' + mm + ':' + ss
      this.axios
        .get(this.$lujin + '/api/Default/Goods?ShopID=' + this.ShopID + '&Week=' + Week + '&Time=' + time + '&WeekQua=' + WeekQua)
        .then((res) => {
		  console.log(res)
          let list = res.data
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          } else if (list && Array.isArray(list.Data)) {
            list = list.Data
          } else if (list && Array.isArray(list.Table)) {
            list = list.Table
          }
          let goodsList = Array.isArray(list) ? list : []
          if (this.IsBuffet) {
            const jsonsz = []
            for (let j = 0; j < goodsList.length; j++) {
              const item = goodsList[j]
              if (!item) continue
              const busz = String(item.BuffetTypeID || '').split(',')
              const busz2 = String(item.DisplayBuffet || '').split(',')
              const add = String(item.BuffetAddMoney || '').split(',')
              const OutPrice = String(item.OutPrice || '').split(',')
              const MaxQua = String(item.MaxQua || '').split(',')
              for (let ppp = 0; ppp < busz.length; ppp++) {
                if (busz[ppp] === this.BuffetTypeID) {
                  item.IsBuffetGoods = 1
                  const addPrice = add[ppp] || ''
                  const priceMatch = addPrice.match(/:([\d.]+)$/)
                  item.Price = priceMatch ? parseFloat(priceMatch[1]) : 0
                }
              }
              for (let ppp = 0; ppp < OutPrice.length; ppp++) {
                const szlists = OutPrice[ppp].split(':')
                if (szlists[0] === this.BuffetTypeID) {
                  item.OutPrices = parseFloat(szlists[1]) || 0
                }
              }
              for (let ppp = 0; ppp < MaxQua.length; ppp++) {
                const szlists = MaxQua[ppp].split(':')
                if (szlists[0] === this.BuffetTypeID) {
                  item.MaxQuas = parseInt(szlists[1], 10) || 0
                }
              }
              for (let ppp = 0; ppp < busz2.length; ppp++) {
                if (busz2[ppp] === this.BuffetTypeID) {
                  jsonsz.push(item)
                }
              }
            }
            goodsList = jsonsz.filter(item => item && item.IsEmpty !== true && item.IsEmpty !== 'true' && item.IsEmpty !== 1 && item.IsEmpty !== '1')
          } else {
            goodsList = goodsList.filter(item => item && !item.IsBuffetDeskShow && item.IsEmpty !== true && item.IsEmpty !== 'true' && item.IsEmpty !== 1 && item.IsEmpty !== '1')
          }
          this.goodsList = goodsList
        })
        .catch(() => {
          this.goodsList = []
        })
    },
    getCategoryName(item) {
      if (!item) {
        return 'Category'
      }
      if (this.WXLangGoodsxb === 1) {
        return item.TwoTypeName || item.TypeName || item.ThreeTypeName || item.name || 'Category'
      }
      if (this.WXLangGoodsxb === 2) {
        return item.ThreeTypeName || item.TypeName || item.TwoTypeName || item.name || 'Category'
      }
      return item.TypeName || item.TwoTypeName || item.ThreeTypeName || item.name || 'Category'
    },
    getCategoryInitial(item) {
      const text = this.getCategoryName(item)
      return text ? text.slice(0, 1) : 'C'
    },
    getCategoryImage(item) {
      if (!this.ShopID || !(item.TypeID || item.typeId)) {
        return ''
      }
      return this.$lujin + '/Data/' + this.ShopID + '/TypePic/' + (item.TypeID || item.typeId) + '.png'
    },
    onCategoryError(typeId) {
      this.$set(this.categoryImageErrorMap, typeId, true)
    },
    getGoodsName(item) {
      if (!item) {
        return 'Item'
      }
      if (this.WXLangGoodsxb === 1) {
        return item.TwoGoods || item.Goods || item.ThreeGoods || 'Item'
      }
      if (this.WXLangGoodsxb === 2) {
        return item.ThreeGoods || item.Goods || item.TwoGoods || 'Item'
      }
      return item.Goods || item.TwoGoods || item.ThreeGoods || 'Item'
    },
	getGoodsUnit(item) {
	  console.log(item)
	  if (!item) {
	    return 'Item'
	  }
	  if (this.WXLangGoodsxb === 1) {
	    return item.TwoUnit
	  }
	  if (this.WXLangGoodsxb === 2) {
	    return item.ThreeUnit
	  }
	  return item.Unit
	},
    getGoodsDesc(item) {
      if (!item) {
        return ''
      }
      if (this.WXLangGoodsxb === 1) {
        return item.TwoDescription
      }
      if (this.WXLangGoodsxb === 2) {
        return item.ThreeDescription
      }
      return item.Description
    },
    getGoodsImage(item) {
      if (!this.ShopID || !item.GoodsID || this.goodsImageErrorMap[item.GoodsID]) {
        return this.fallbackBanner
      }
      return this.$lujin + '/Data/' + this.ShopID + '/GoodsPic/' + item.GoodsID + '.jpg?Time=' + 0
    },
    onGoodsImageError(goodsId) {
      this.$set(this.goodsImageErrorMap, goodsId, true)
    },
    getGoodsPrice(item) {
      let price
      if (this.IsBuffet && item.IsBuffetGoods) {
        price = Number(item.Price || 0)
      } else {
        price = item.MessyPrice !== undefined && item.MessyPrice !== null
          ? Number(item.MessyPrice)
          : Number(item.DeliveryPrice || 0)
      }
      return isFinite(price) ? price.toFixed(this.DecimalBit) : '0.00'
    },
    getIngredientIcons(item) {
      const icons = []
      for (let i = 1; i <= 15; i++) {
        if (item['IngredientsICO' + i]) {
          icons.push(this.$lujin + '/Data/' + this.ShopID + '/IngredientsICO/P' + i + '.png')
        }
      }
      return icons
    },
    roundDecimal(value, places) {
      const v = Number(value || 0)
      if (!isFinite(v)) return 0
      const p = Number(places || 0)
      if (!isFinite(p) || p < 0) return v
      const factor = Math.pow(10, p)
      return Math.round(v * factor) / factor
    },
    roundQty(value) {
      const v = Number(value || 0)
      if (!isFinite(v)) return 0
      return Math.round(v * 1000) / 1000
    },
    roundMoney(value) {
      return this.roundDecimal(value, this.DecimalBit || 2)
    },
    onLogoError(event) {
      event.target.style.display = 'none'
    },
    onBannerError(event) {
      event.target.src = this.fallbackBanner
    },
    refreshCartFromStorage() {
      if (!this.ShopID) {
        this.cartList = []
        return
      }
      try {
        const raw = localStorage.getItem(this.ShopID + 'list')
        const list = raw ? JSON.parse(raw) : []
        const normalized = this.normalizeCartList(Array.isArray(list) ? list : [])
        this.cartList = normalized
        localStorage.setItem(this.ShopID + 'list', JSON.stringify(normalized))
      } catch (e) {
        this.cartList = []
      }
    },
    clearUserCart() {
      try {
        if (this.ShopID) {
          localStorage.removeItem(this.ShopID + 'list')
        }
      } catch (e) {}
      this.cartList = []
      this.selectedCouponKeys = []
      this.persistMemberCouponCache()
    },
    normalizeCartList(list) {
      const normalized = []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (!item || typeof item !== 'object') {
          continue
        }
        const next = {}
        for (const key in item) {
          if (!Object.prototype.hasOwnProperty.call(item, key)) {
            continue
          }
          if (key && key.indexOf('xb_') === 0) {
            continue
          }
          next[key] = item[key]
        }
        if (next.zt === undefined) {
          next.zt = true
        }
        normalized.push(next)
      }
      return normalized
    },
    addToCart(item) {
      if (!this.ShopID || !item || !item.GoodsID) {
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const goodsId = item.GoodsID
      const idx = list.findIndex(v => v && v.id == goodsId && (v.IsChild === 0 || v.IsChild === '0' || v.IsChild === undefined))
      const current = idx >= 0 ? list[idx] : null
      const nextSl = Math.min(99, Number(current && current.sl ? current.sl : 0) + 1)
      let money
      if (this.IsBuffet && item.IsBuffetGoods) {
        money = Number(item.Price || 0)
      } else {
        money = item.MessyPrice !== undefined && item.MessyPrice !== null
          ? Number(item.MessyPrice)
          : Number(item.DeliveryPrice || 0)
      }
      const obj = {
        zt: true,
        sl: nextSl,
        bz: '',
        id: goodsId,
        typeid: item.TypeID,
        momey: isFinite(money) ? money : 0,
        Goods: item.Goods,
        TwoGoods: item.TwoGoods,
        ThreeGoods: item.ThreeGoods,
        IsBuffetGoods: !!item.IsBuffetGoods,
        addmomey: 0,
        FromID: 0,
        IsChild: 0,
        isRoot: 0,
        zf: '0,0,0,0,0,0,0,0',
        zuofa1: '',
        zuofa2: '',
        zuofa3: '',
        MinShare: item.MinShare || 0,
        getTime: (new Date()).getTime(),
        MaxQuas: item.MaxQuas ? item.MaxQuas : 0
      }
      if (current) {
        obj.zt = current.zt !== undefined ? current.zt : true
        obj.addmomey = current.addmomey !== undefined ? current.addmomey : 0
        obj.FromID = current.FromID !== undefined ? current.FromID : 0
        obj.IsChild = current.IsChild !== undefined ? current.IsChild : 0
        obj.isRoot = current.isRoot !== undefined ? current.isRoot : 0
        obj.zf = current.zf !== undefined ? current.zf : obj.zf
        obj.zuofa1 = current.zuofa1 !== undefined ? current.zuofa1 : ''
        obj.zuofa2 = current.zuofa2 !== undefined ? current.zuofa2 : ''
        obj.zuofa3 = current.zuofa3 !== undefined ? current.zuofa3 : ''
        obj.bz = current.bz !== undefined ? current.bz : ''
        list.splice(idx, 1, obj)
      } else {
        list.push(obj)
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
	changeGoodsQtys(item){
	  if (!item || !item.GoodsID) {
	    return
	  }
	  if (item.IsEmpty === true || item.IsEmpty === 'true' || item.IsEmpty === 1 || item.IsEmpty === '1') {
	    return
	  }
	  if (this.isWeightGoods(item)) {
    this.openWeightGoods(item)
    return
  }
  if (this.isFixedSetMeal(item)) {
    this.openSetMeal(item)
    return
  }
  if (this.isOptionalSetMeal(item)) {
    this.openOptionalSetMeal(item)
    return
  }
  if (this.isGroupedRemarkGoods(item)) {
    this.openGroupedRemarkGoods(item)
    return
  }
  if (this.isSimpleRemarkGoods(item)) {
    this.openRemarkGoods(item)
    return
  }
  if (this.isUnitGoods(item)) {
    this.openUnitPrice(item)
    return
  }
	  this.setMealGoods = item
	  this.setMealKind = ''
	  const minShare = Number(item && item.MinShare ? item.MinShare : 0)
	  this.setMealQty = minShare > 0 ? minShare : 1
	  this.setMealFixedList = []
	  this.setMealOptionalGroups = []
	  this.setMealRemarkList = []
	  this.setMealRemarkGroups = []
	  this.setMealVisible = true
	  this.setMealLoading = false
	  this.lockBodyScroll(true)
	},
    changeGoodsQty(item, delta, event) {
      if (!item || !item.GoodsID) {
        return
      }
      if (item.IsEmpty === true || item.IsEmpty === 'true' || item.IsEmpty === 1 || item.IsEmpty === '1') {
        return
      }
      if (this.isWeightGoods(item)) {
        this.openWeightGoods(item)
        return
      }
      if (Number(delta) > 0) {
        if (this.isFixedSetMeal(item)) {
          this.openSetMeal(item)
          return
        }
        if (this.isOptionalSetMeal(item)) {
          this.openOptionalSetMeal(item)
          return
        }
        if (this.isGroupedRemarkGoods(item)) {
          this.openGroupedRemarkGoods(item)
          return
        }
        if (this.isSimpleRemarkGoods(item)) {
          this.openRemarkGoods(item)
          return
        }
		if(this.isUnitGoods(item)){
		  this.openUnitPrice(item)
		  return
		}
        const currentQty = Number(this.goodsQtyMap[item.GoodsID] || 0)
        const maxQty = Number(item.MaxQuas || 0)
        if (maxQty > 0 && currentQty >= maxQty) {
          this.searchAddToastText = this.$lang[this.pickxb].l97
          this.searchAddToastVisible = true
          if (this.searchAddToastTimer) {
            clearTimeout(this.searchAddToastTimer)
            this.searchAddToastTimer = null
          }
          this.searchAddToastTimer = setTimeout(() => {
            this.searchAddToastVisible = false
            this.searchAddToastTimer = null
          }, 2000)
          return
        }
        if (this.IsBuffet && this.Numberpoints > 0 && item.IsBuffetGoods) {
          const cartList = Array.isArray(this.cartList) ? this.cartList : []
          let totalQty = 0
          for (let i = 0; i < cartList.length; i++) {
            const cartItem = cartList[i]
            if (cartItem && cartItem.IsBuffetGoods) {
              totalQty += Number(cartItem.sl || 0)
            }
          }
          if (totalQty >= this.Numberpoints) {
            this.searchAddToastText = this.$lang[this.pickxb].l97
            this.searchAddToastVisible = true
            if (this.searchAddToastTimer) {
              clearTimeout(this.searchAddToastTimer)
              this.searchAddToastTimer = null
            }
            this.searchAddToastTimer = setTimeout(() => {
              this.searchAddToastVisible = false
              this.searchAddToastTimer = null
            }, 2000)
            return
          }
        }
        this.playAddToCartEffect(event)
        this.addToCart(item)
        this.afterSearchAddToCartRestore()
        return
      }
      this.decreaseFromCart(item.GoodsID)
    },
    afterSearchAddToCartRestore() {
      const keyword = String(this.searchText || '').trim()
      if (!keyword) {
        return
      }
      const restoreCategoryId = this.searchRestoreCategoryId
      const restoreDepotId = this.searchRestoreMadeDepotId
      this.showSearchAddToast()
      this.searchText = ''
      this.$nextTick(() => {
        if (this.isMadeDepotEnabled && restoreDepotId) {
          const foundDepot = (Array.isArray(this.madeDepotList) ? this.madeDepotList : []).some(v => v && String(v.MadeDepotID || v.id) === String(restoreDepotId))
          if (foundDepot) {
            this.activeMadeDepotId = restoreDepotId
          }
        }
        if (restoreCategoryId) {
          this.activeCategoryId = restoreCategoryId
        }
        this.ensureActiveCategoryIdValid()
        this.$nextTick(() => {
          this.scrollGoodsToFirstRow()
        })
      })
    },
    showSearchAddToast() {
      if (this.searchAddToastTimer) {
        clearTimeout(this.searchAddToastTimer)
        this.searchAddToastTimer = null
      }
      this.searchAddToastText = this.$lang[this.pickxb].l78
      this.searchAddToastVisible = true
      this.searchAddToastTimer = setTimeout(() => {
        this.searchAddToastVisible = false
        this.searchAddToastTimer = null
      }, 2000)
    },
    isFixedSetMeal(item) {
      const isSetMeal = item && (item.IsSetMeal === 1 || item.IsSetMeal === '1' || item.IsSetMeal === true)
      const isFixup = item && (item.IsFixup === 1 || item.IsFixup === '1' || item.IsFixup === true)
      return !!(isSetMeal && isFixup)
    },
    isWeightGoods(item) {
      if (this.IsBuffet) {
        return false
      }
      const isWeight = item && (item.IsWeight === 1 || item.IsWeight === '1' || item.IsWeight === true)
      return !!(isWeight)
    },
    isOptionalSetMeal(item) {
      const isSetMeal = item && (item.IsSetMeal === 1 || item.IsSetMeal === '1' || item.IsSetMeal === true)
      const isFixupFalse = item && (item.IsFixup === false || item.IsFixup === 'false' || item.IsFixup === 0)
      return !!(isSetMeal && isFixupFalse)
    },
    isSimpleRemarkGoods(item) {
      const disRemark = item && (item.DisRemark === 1 || item.DisRemark === '1' || item.DisRemark === true)
      const isNew = this.IsNewGoodsRemark === 1 || this.IsNewGoodsRemark === '1' || this.IsNewGoodsRemark === true
      return !!(disRemark && !isNew)
    },
    isGroupedRemarkGoods(item) {
      const disRemark = item && (item.DisRemark === 1 || item.DisRemark === '1' || item.DisRemark === true)
      const isNew = this.IsNewGoodsRemark === 1 || this.IsNewGoodsRemark === '1' || this.IsNewGoodsRemark === true
      return !!(disRemark && isNew)
    },
	isUnitGoods(item) {
	  if (this.IsBuffet) {
	    return false
	  }
	  const disunit = item && (item.IsUnitPrice === 1 || item.IsUnitPrice === '1' || item.IsUnitPrice === true)
	  return !!(disunit)
	},
    openSetMeal(item) {
      if (this.isWeightGoods(item)) {
        const cartKg = this.goodsWeightMap && item && item.GoodsID ? this.goodsWeightMap[String(item.GoodsID)] : null
        this.openWeightSetMeal(item, cartKg != null ? Number(cartKg) : null)
        return
      }
      this.setMealKind = 'fixed'
      this.setMealGoods = item
      const minShare = Number(item && item.MinShare ? item.MinShare : 0)
      this.setMealQty = minShare > 0 ? minShare : 1
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealVisible = true
      this.setMealLoading = true
      this.lockBodyScroll(true)
      if (!this.ShopID || !item || !item.GoodsID) {
        this.setMealLoading = false
        return
      }
      this.axios
        .get(this.$lujin + '/api/Default/Guding?GoodsID=' + item.GoodsID + '&ShopID=' + this.ShopID)
        .then((res) => {
          let list = res && res.data && res.data.data ? res.data.data : (res ? res.data : [])
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          }
          const arr = Array.isArray(list) ? list : []
          const normalized = []
          for (let i = 0; i < arr.length; i++) {
            const row = arr[i]
            if (!row) {
              continue
            }
            if (row.IsEmpty === true || row.IsEmpty === 'true' || row.IsEmpty === 1 || row.IsEmpty === '1') {
              continue
            }
            const goodsId = row.GoodsID || row.ID || row.id
            normalized.push({
              ...row,
              GoodsID: goodsId,
              Qua: row.Qua !== undefined ? row.Qua : (row.jcQua !== undefined ? row.jcQua : 1)
            })
          }
          this.setMealFixedList = normalized
          this.setMealLoading = false
        })
        .catch(() => {
          this.setMealFixedList = []
          this.setMealLoading = false
        })
    },
    openSetMealById(goodsId, preferKind) {
      const id = goodsId != null ? String(goodsId) : ''
      if (!id || !this.ShopID) return
      const cartList = Array.isArray(this.cartList) ? this.cartList : []
      const cartItem = cartList.find(v => v && String(v.id) === id && !(v.IsChild === 1 || v.IsChild === '1'))
      let goods = null
      if (cartItem && cartItem._Goods) {
        goods = cartItem._Goods
      }
      if (!goods && Array.isArray(this.Menu)) {
        outer: for (let i = 0; i < this.Menu.length; i++) {
          const row = this.Menu[i] && typeof this.Menu[i] === 'object' ? this.Menu[i] : null
          const gList = row && Array.isArray(row.Goods) ? row.Goods : null
          if (!gList || !gList.length) continue
          for (let j = 0; j < gList.length; j++) {
            if (gList[j] && String(gList[j].GoodsID) === id) { goods = gList[j]; break outer }
          }
        }
      }
      if (!goods && Array.isArray(this.filteredGoods) && this.filteredGoods.length) {
        goods = this.filteredGoods.find(g => g && String(g.GoodsID) === id) || null
      }
      if (!goods && Array.isArray(this.flatCategoryGroups) && this.flatCategoryGroups.length) {
        outer2: for (let i = 0; i < this.flatCategoryGroups.length; i++) {
          const grp = this.flatCategoryGroups[i] && typeof this.flatCategoryGroups[i] === 'object' ? this.flatCategoryGroups[i] : null
          const items = grp && Array.isArray(grp.items) ? grp.items : null
          if (!items || !items.length) continue
          for (let j = 0; j < items.length; j++) {
            if (items[j] && String(items[j].GoodsID) === id) { goods = items[j]; break outer2 }
          }
        }
      }
      if (!goods) return
      const kind = String(preferKind || '').trim().toLowerCase()
      if (kind === 'weight' || this.isWeightGoods(goods)) {
        this.openWeightSetMeal(goods, cartItem && cartItem.sl != null ? Number(cartItem.sl) : null)
        return
      }
      this.openSetMeal(goods)
    },
    openWeightSetMeal(item, initialKg) {
      this.setMealKind = 'weight'
      this.setMealGoods = item || null
      const initial = Number(initialKg || 0)
      this.setMealQty = initial > 0 ? initial : (Number(item && item.MinShare || 0) > 0 ? Number(item.MinShare) : 0.1)
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealUnitList = []
      this.setMealUnitIndex = 0
      this.setMealVisible = true
      this.setMealLoading = false
      this.lockBodyScroll(true)
    },
    onWeightInputFocus(c) {
      // 不再拦截 focus，让输入框直接获得焦点弹出数字键盘
    },
    setCartWeightQty(c, rawValue) {
      if (!this.ShopID || !c || !c.id) {
        return
      }
      const raw = String(rawValue == null ? '' : rawValue).trim()
      if (raw.length === 0) {
        return
      }
      let num = Number(raw)
      if (!isFinite(num)) {
        num = 0
      }
      if (num < 0) num = 0
      const key = this.ShopID + 'list'
      let list = []
      try {
        const rawLs = localStorage.getItem(key)
        list = rawLs ? JSON.parse(rawLs) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) list = []
      list = this.normalizeCartList(list)
      const idx = list.findIndex(v => v && v.id == c.id && !(v.IsChild === 1 || v.IsChild === '1'))
      if (idx < 0) return
      const next = { ...list[idx] }
      if (num <= 0) {
        const fromId = next.FromID
        list.splice(idx, 1)
        if (next.isRoot === 1 || next.isRoot === '1') {
          list = list.filter(v => !(v && (v.IsChild === 1 || v.IsChild === '1') && v.FromID == fromId))
        }
      } else {
        next.sl = Math.min(999, Number(num.toFixed(3)))
        list.splice(idx, 1, next)
        if (next.isRoot === 1 || next.isRoot === '1') {
          const fromId = next.FromID
          for (let i = 0; i < list.length; i++) {
            const row = list[i]
            if (row && (row.IsChild === 1 || row.IsChild === '1') && row.FromID == fromId) {
              const jcQua = Math.max(1, parseInt(row.jcQua, 10) || 1)
              list[i] = { ...row, sl: jcQua * next.sl, zt: next.zt }
            }
          }
        }
      }
      try { localStorage.setItem(key, JSON.stringify(list)) } catch (e) {}
      this.cartList = list
    },
    onCartWeightInputBlur(c, e) {
      if (!c || !c.id) return
      const el = e && e.target ? e.target : null
      if (!el) return
      const raw = String(el.value || '').trim()
      if (raw.length === 0) {
        el.value = String(c.sl || 0)
        return
      }
      let num = Number(raw)
      if (!isFinite(num) || num <= 0) {
        el.value = String(c.sl || 0)
        return
      }
      this.setCartWeightQty(c, num)
      const numRounded = Math.min(999, Number(num.toFixed(3)))
      el.value = String(numRounded)
    },
    onCartWeightInputKeydown(c, e) {
      // 允许回车触发 blur 提交
      if (e && e.key === 'Enter' && e.target && typeof e.target.blur === 'function') {
        e.preventDefault()
        e.target.blur()
      }
    },
    changeCartQty(c, delta) {
      if (!this.ShopID || !c || !c.id) {
        return
      }
      if (this.isWeightGoods(c)) {
        try { this.openSetMealById(c.id, 'weight') } catch (e) {}
        return
      }
      if (Number(delta) > 0 && this.IsBuffet && this.Numberpoints > 0 && c.IsBuffetGoods) {
        const cartList = Array.isArray(this.cartList) ? this.cartList : []
        let totalQty = 0
        for (let i = 0; i < cartList.length; i++) {
          const cartItem = cartList[i]
          if (cartItem && cartItem.IsBuffetGoods) {
            totalQty += Number(cartItem.sl || 0)
          }
        }
        if (totalQty >= this.Numberpoints) {
          this.searchAddToastText = this.$lang[this.pickxb].l97
          this.searchAddToastVisible = true
          if (this.searchAddToastTimer) {
            clearTimeout(this.searchAddToastTimer)
            this.searchAddToastTimer = null
          }
          this.searchAddToastTimer = setTimeout(() => {
            this.searchAddToastVisible = false
            this.searchAddToastTimer = null
          }, 2000)
          return
        }
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const idx = list.findIndex(v => v && v.id == c.id && !(v.IsChild === 1 || v.IsChild === '1'))
      if (idx < 0) {
        return
      }
      const next = { ...list[idx] }
      const nextSl = Number(next.sl || 0) + Number(delta || 0)
      next.sl = Math.max(0, Math.min(99, nextSl))
      if (next.sl <= 0) {
        const fromId = next.FromID
        list.splice(idx, 1)
        if (next.isRoot === 1 || next.isRoot === '1') {
          list = list.filter(v => !(v && (v.IsChild === 1 || v.IsChild === '1') && v.FromID == fromId))
        }
      } else {
        list.splice(idx, 1, next)
        if (next.isRoot === 1 || next.isRoot === '1') {
          const fromId = next.FromID
          for (let i = 0; i < list.length; i++) {
            const row = list[i]
            if (row && (row.IsChild === 1 || row.IsChild === '1') && row.FromID == fromId) {
              const jcQua = Math.max(1, parseInt(row.jcQua, 10) || 1)
              list[i] = { ...row, sl: jcQua * next.sl, zt: next.zt }
            }
          }
        }
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
    openOptionalSetMeal(item) {
      this.setMealKind = 'optional'
      this.setMealGoods = item
      const minShare = Number(item && item.MinShare ? item.MinShare : 0)
      this.setMealQty = minShare > 0 ? minShare : 1
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealVisible = true
      this.setMealLoading = true
      this.lockBodyScroll(true)
      if (!this.ShopID || !item || !item.GoodsID) {
        this.setMealLoading = false
        return
      }
      this.axios
        .get(this.$lujin + '/api/Default/Kexuan?GoodsID=' + item.GoodsID + '&ShopID=' + this.ShopID)
        .then((res) => {
          let list = res && res.data && res.data.data ? res.data.data : (res ? res.data : [])
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          }
          const arr = Array.isArray(list) ? list : []
          this.setMealOptionalGroups = this.normalizeOptionalSetMealGroups(arr)
          this.setMealLoading = false
        })
        .catch(() => {
          this.setMealOptionalGroups = []
          this.setMealLoading = false
        })
    },
    openRemarkGoods(item) {
      this.setMealKind = 'remark'
      this.setMealGoods = item
      const minShare = Number(item && item.MinShare ? item.MinShare : 0)
      this.setMealQty = minShare > 0 ? minShare : 1
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealVisible = true
      this.setMealLoading = true
      this.lockBodyScroll(true)
      if (!this.ShopID || !item || !item.GoodsID) {
        this.setMealLoading = false
        return
      }
      const selectedIdSet = this.getCartSelectedRemarkIdSet(item.GoodsID)
      this.axios
        .get(this.$lujin + '/api/Default/GoodsRemark?name=' + item.GoodsID + '&ShopID=' + this.ShopID)
        .then((res) => {
          let list = res && res.data && res.data.data ? res.data.data : (res ? res.data : [])
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          }
          if (list && Array.isArray(list.Table)) {
            list = list.Table
          }
          const arr = Array.isArray(list) ? list : []
          const normalized = []
          for (let i = 0; i < arr.length; i++) {
            const row = arr[i]
            if (!row) {
              continue
            }
            const remarkId = row.RemarkID || row.ID || row.id
            normalized.push({
              ...row,
              RemarkID: remarkId,
              ZT: !!selectedIdSet[String(remarkId)]
            })
          }
          this.setMealRemarkList = normalized
          this.setMealLoading = false
        })
        .catch(() => {
          this.setMealRemarkList = []
          this.setMealLoading = false
        })
    },
    openGroupedRemarkGoods(item) {
      this.setMealKind = 'remark'
      this.setMealGoods = item
      const minShare = Number(item && item.MinShare ? item.MinShare : 0)
      this.setMealQty = minShare > 0 ? minShare : 1
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealVisible = true
      this.setMealLoading = true
      this.lockBodyScroll(true)
      if (!this.ShopID || !item || !item.GoodsID) {
        this.setMealLoading = false
        return
      }
      const selectedIdSet = this.getCartSelectedRemarkIdSet(item.GoodsID)
      this.axios
        .get(this.$lujin + '/api/Default/GetDisRemark?GoodsID=' + item.GoodsID + '&ShopID=' + this.ShopID)
        .then((res) => {
          let list = res && res.data && res.data.data ? res.data.data : (res ? res.data : [])
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          }
          if (list && Array.isArray(list.Table)) {
            list = list.Table
          }
          const arr = Array.isArray(list) ? list : []
          const normalized = []
          for (let i = 0; i < arr.length; i++) {
            const g = arr[i]
            if (!g) {
              continue
            }
            const items = Array.isArray(g.TRemarkGroupItemsTemp) ? g.TRemarkGroupItemsTemp : []
            const nextItems = []
            for (let j = 0; j < items.length; j++) {
              const row = items[j]
              if (!row) {
                continue
              }
              if (row.IsEmpty === true || row.IsEmpty === 'true' || row.IsEmpty === 1 || row.IsEmpty === '1') {
                continue
              }
              const remarkId = row.RemarkID || row.ID || row.id
              nextItems.push({
                ...row,
                RemarkID: remarkId,
                ZT: !!selectedIdSet[String(remarkId)]
              })
            }
            normalized.push({
              ...g,
              TRemarkGroupItemsTemp: nextItems
            })
          }
          this.setMealRemarkGroups = normalized
          this.setMealLoading = false
        })
        .catch(() => {
          this.setMealRemarkGroups = []
          this.setMealLoading = false
        })
    },
    getCartSelectedRemarkIdSet(goodsId) {
      const set = {}
      if (!goodsId) {
        return set
      }
      const row = this.cartList && this.cartList.find(v => v && v.id == goodsId && !(v.IsChild === 1 || v.IsChild === '1'))
      const zf = row && row.zf ? String(row.zf) : ''
      if (!zf) {
        return set
      }
      const parts = zf.split(',')
      for (let i = 0; i < parts.length; i++) {
        const v = String(parts[i] || '').trim()
        if (v && v !== '0') {
          set[v] = true
        }
      }
      return set
    },
    getRemarkName(item) {
	  console.log(item)
	  if(this.WXLangGoodsxb==1){
	  	  return item.TwoRemark || item.TwoWorkReMark 
	  }
	  if(this.WXLangGoodsxb==2){
	  	  return item.ThreeRemark || item.ThreeWorkReMark
	  }
      return item.Remark || item.WorkReMark 
    },
    getRemarkAddPrice(item) {
      const n = item && item.AddPrice !== undefined
        ? Number(item.AddPrice)
        : (item && item.Addprice !== undefined ? Number(item.Addprice) : (item && item.AddMoney !== undefined ? Number(item.AddMoney) : (item && item.Addmoney !== undefined ? Number(item.Addmoney) : 0)))
      return isFinite(n) ? n : 0
    },
    getRemarkGroupName(item) {
	  console.log(item)
	  if(this.WXLangGoodsxb==1){
		  return item.TwoGroupName
	  }
	  if(this.WXLangGoodsxb==2){
	  	  return item.ThreeGroupName
	  }
      return item.GroupName
    },
    getRemarkChooseRule() {
      const mode = this.setMealGoods && this.setMealGoods.IsMoreRemarkChoose !== undefined ? parseInt(this.setMealGoods.IsMoreRemarkChoose, 10) : 0
      const num = this.setMealGoods && this.setMealGoods.RemarkChooseNums !== undefined ? parseInt(this.setMealGoods.RemarkChooseNums, 10) : 0
      return {
        mode: isFinite(mode) ? mode : 0,
        num: isFinite(num) ? num : 0
      }
    },
    getSelectedRemarkCount() {
      const list = Array.isArray(this.setMealRemarkList) ? this.setMealRemarkList : []
      let count = 0
      for (let i = 0; i < list.length; i++) {
        if (list[i] && list[i].ZT) {
          count += 1
        }
      }
      return count
    },
    getSelectedRemarkCountInGroup(groupIndex) {
      const groups = Array.isArray(this.setMealRemarkGroups) ? this.setMealRemarkGroups : []
      const g = groups[groupIndex]
      if (!g || !Array.isArray(g.TRemarkGroupItemsTemp)) {
        return 0
      }
      let count = 0
      for (let i = 0; i < g.TRemarkGroupItemsTemp.length; i++) {
        if (g.TRemarkGroupItemsTemp[i] && g.TRemarkGroupItemsTemp[i].ZT) {
          count += 1
        }
      }
      return count
    },
    toggleSetMealRemark(index) {
      const list = Array.isArray(this.setMealRemarkList) ? this.setMealRemarkList.slice() : []
      const row = list[index]
      if (!row) {
        return
      }
      const nextOn = !row.ZT
      if (nextOn) {
        const rule = this.getRemarkChooseRule()
        const selectedCount = this.getSelectedRemarkCount()
        if ((rule.mode === 1 || rule.mode === 3) && rule.num > 0 && selectedCount >= rule.num) {
          if (rule.num === 1) {
            for (let i = 0; i < list.length; i++) {
              if (i !== index && list[i]) {
                list.splice(i, 1, { ...list[i], ZT: false })
              }
            }
          } else {
            this.showSetMealAlert(this.$lang[this.pickxb].l40, rule.mode === 1 ? (this.$lang[this.pickxb].l41 + ' ' + rule.num + ' ' + this.$lang[this.pickxb].l24) : (this.$lang[this.pickxb].l43 + ' ' + rule.num + ' ' + this.$lang[this.pickxb].l24))
            return
          }
        }
      }
      list.splice(index, 1, { ...row, ZT: nextOn })
      this.setMealRemarkList = list
    },
    toggleSetMealRemarkGroup(groupIndex, itemIndex) {
      const groups = Array.isArray(this.setMealRemarkGroups) ? this.setMealRemarkGroups.slice() : []
      const g = groups[groupIndex]
      if (!g || !Array.isArray(g.TRemarkGroupItemsTemp)) {
        return
      }
      const list = g.TRemarkGroupItemsTemp.slice()
      const row = list[itemIndex]
      if (!row) {
        return
      }
      const nextOn = !row.ZT
      if (nextOn) {
        const groupType = g.GroupType !== undefined ? parseInt(g.GroupType, 10) : 0
        const maxSel = g.MaxSelItems !== undefined ? parseInt(g.MaxSelItems, 10) : 0
        const selectedCount = this.getSelectedRemarkCountInGroup(groupIndex)
        if ((groupType === 1 || groupType === 3) && maxSel > 0 && selectedCount >= maxSel) {
          if (maxSel === 1) {
            for (let j = 0; j < list.length; j++) {
              if (j !== itemIndex && list[j]) {
                list.splice(j, 1, { ...list[j], ZT: false })
              }
            }
          } else {
            const name = this.getRemarkGroupName(g) || this.$lang[this.pickxb].l40
            this.showSetMealAlert(name, this.$lang[this.pickxb].l43 + ' ' + maxSel + ' ' + this.$lang[this.pickxb].l24)
            return
          }
        }
      }
      list.splice(itemIndex, 1, { ...row, ZT: nextOn })
      groups.splice(groupIndex, 1, { ...g, TRemarkGroupItemsTemp: list })
      this.setMealRemarkGroups = groups
    },
    getSetMealRemarkAddMoney() {
      if (this.setMealKind !== 'remark') {
        return 0
      }
      if (this.setMealRemarkGroups && this.setMealRemarkGroups.length) {
        const groups = Array.isArray(this.setMealRemarkGroups) ? this.setMealRemarkGroups : []
        let sum = 0
        for (let i = 0; i < groups.length; i++) {
          const g = groups[i]
          const items = g && Array.isArray(g.TRemarkGroupItemsTemp) ? g.TRemarkGroupItemsTemp : []
          for (let j = 0; j < items.length; j++) {
            if (items[j] && items[j].ZT) {
              const add = this.getRemarkAddPrice(items[j])
              if (isFinite(add)) {
                sum += add
              }
            }
          }
        }
        return sum
      }
      const list = Array.isArray(this.setMealRemarkList) ? this.setMealRemarkList : []
      let sum = 0
      for (let i = 0; i < list.length; i++) {
        if (list[i] && list[i].ZT) {
          const add = this.getRemarkAddPrice(list[i])
          if (isFinite(add)) {
            sum += add
          }
        }
      }
      return sum
    },
    getSetMealOptionalAddMoney() {
      let sum = 0
      const groups = Array.isArray(this.setMealOptionalGroups) ? this.setMealOptionalGroups : []
      for (let i = 0; i < groups.length; i++) {
        const g = groups[i]
        if (!g || !Array.isArray(g.list)) {
          continue
        }
        for (let j = 0; j < g.list.length; j++) {
          const row = g.list[j]
          const qua = parseInt(row.Qua, 10) || 0
          if (qua <= 0) {
            continue
          }
          const price = Number(row.Price || 0)
          if (isFinite(price) && price > 0) {
            sum += price * qua
          }
        }
      }
      return sum
    },
    getSetMealTotalMoney() {
      const base = Number(this.setMealGoods ? this.getGoodsPrice(this.setMealGoods) : 0)
      let add = 0
      if (this.setMealKind === 'unit') {
        add = Number(this.getUnitExtra(this.setMealUnitList && this.setMealUnitList[this.setMealUnitIndex]) || 0)
      } else if (this.setMealKind === 'optional') {
        add = Number(this.getSetMealOptionalAddMoney() || 0)
      } else {
        add = Number(this.getSetMealRemarkAddMoney() || 0)
      }
      const qty = Number(this.setMealQty || 1)
      const unit = (isFinite(base) ? base : 0) + (isFinite(add) ? add : 0)
      const total = unit * (isFinite(qty) ? qty : 1)
      return isFinite(total) ? total.toFixed(this.DecimalBit) : (0).toFixed(this.DecimalBit)
    },
    normalizeOptionalSetMealGroups(groups) {
      const normalized = []
      const source = Array.isArray(groups) ? groups : []
      for (let i = 0; i < source.length; i++) {
        const g = source[i]
        if (!g || typeof g !== 'object') {
          continue
        }
        const isFixup = g.IsFixup
        const rawList = Array.isArray(g.list) ? g.list : (Array.isArray(g.List) ? g.List : [])
        const list = []
        for (let j = 0; j < rawList.length; j++) {
          const row = rawList[j]
          if (!row) {
            continue
          }
          if (row.IsEmpty === true || row.IsEmpty === 'true' || row.IsEmpty === 1 || row.IsEmpty === '1') {
            continue
          }
          const goodsId = row.GoodsID || row.ID || row.id || row.GoodsId || row.Id
          const next = { ...row, GoodsID: goodsId }
          if (String(isFixup) === '1') {
            const qua = parseInt(next.Qua, 10)
            next.Qua = isFinite(qua) && qua > 0 ? qua : 1
            next.zt = true
          } else {
            next.Qua = 0
            next.zt = false
          }
          list.push(next)
        }
        const minSel = parseInt(g.MinSelItems, 10)
        const maxSel = parseInt(g.MaxSelItems, 10)
        let sl = 0
        for (let k = 0; k < list.length; k++) {
          sl += parseInt(list[k].Qua, 10) || 0
        }
        normalized.push({
          ...g,
          list,
          sl,
          MinSelItems: isFinite(minSel) ? minSel : 0,
          MaxSelItems: isFinite(maxSel) ? maxSel : 0
        })
      }
      return normalized
    },
    getSetMealGroupName(group) {
      return group && (group.SetMealGroup || group.TwoSetMealGroup || group.ThreeSetMealGroup) ? (group.SetMealGroup || group.TwoSetMealGroup || group.ThreeSetMealGroup) : this.$lang[this.pickxb].l98
    },
    getSetMealGroupTip(group) {
      if (!group) {
        return ''
      }
      const type = String(group.IsFixup)
      const min = Number(group.MinSelItems || 0)
      const max = Number(group.MaxSelItems || 0)
      const sl = Number(group.sl || 0)
      if (type === '1') {
        return ''
      }
      if (type === '2') {
        return '(' + sl + '/' + max + ')'
      }
      if (type === '0') {
        const required = min > 0 ? min : max
        return '(' + sl + '/' + required + ')'
      }
      if (type === '3') {
        return '(' + min + '~' + max + ') ' + sl + '/' + max
      }
      return ''
    },
    changeSetMealOptionQty(groupIndex, itemIndex, delta) {
      const groups = Array.isArray(this.setMealOptionalGroups) ? this.setMealOptionalGroups.slice() : []
      const g = groups[groupIndex]
      if (!g || !Array.isArray(g.list)) {
        return
      }
      if (String(g.IsFixup) === '1') {
        return
      }
      const row = g.list[itemIndex]
      if (!row) {
        return
      }
      const cur = parseInt(row.Qua, 10) || 0
      const next = Math.max(0, Math.min(99, cur + Number(delta || 0)))
      if (next === cur) {
        return
      }
      let currentTotal = 0
      for (let i = 0; i < g.list.length; i++) {
        currentTotal += parseInt(g.list[i].Qua, 10) || 0
      }
      const nextTotal = currentTotal - cur + next
      const type = String(g.IsFixup)
      const min = Number(g.MinSelItems || 0)
      const max = Number(g.MaxSelItems || 0)
      if (Number(delta) > 0) {
        if (type === '2' && max > 0 && nextTotal > max) {
          return
        }
        if (type === '0') {
          const required = min > 0 ? min : max
          if (required > 0 && nextTotal > required) {
            return
          }
        }
        if (type === '3' && max > 0 && nextTotal > max) {
          return
        }
      }
      const nextRow = { ...row, Qua: next, zt: next > 0 }
      const nextList = g.list.slice()
      nextList.splice(itemIndex, 1, nextRow)
      const nextGroup = { ...g, list: nextList, sl: nextTotal }
      groups.splice(groupIndex, 1, nextGroup)
      this.setMealOptionalGroups = groups
    },
    getSetMealChildId(row) {
      return row && (row.GoodsID || row.ID || row.id || row.GoodsId || row.Id)
    },
    getSetMealChildImage(row) {
      const id = this.getSetMealChildId(row)
      return this.getGoodsImage({ GoodsID: id })
    },
    onSetMealChildImageError(row) {
      const id = this.getSetMealChildId(row)
      if (id) {
        this.onGoodsImageError(id)
      }
    },
    closeSetMeal() {
      this.setMealVisible = false
      this.setMealLoading = false
      this.setMealKind = 'fixed'
      this.setMealGoods = null
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealUnitList = []
      this.setMealUnitIndex = 0
      this.setMealQty = 1
      this.setMealAlertVisible = false
      this.setMealAlertTitle = this.$lang[this.pickxb].l17
      this.setMealAlertText = ''
      this.lockBodyScroll(this.cartVisible)
    },
    showSetMealAlert(title, text) {
      this.setMealAlertTitle = title || this.$lang[this.pickxb].l17
      this.setMealAlertText = text || ''
      this.setMealAlertVisible = true
    },
    closeSetMealAlert() {
      this.setMealAlertVisible = false
      this.setMealAlertTitle = this.$lang[this.pickxb].l17
      this.setMealAlertText = ''
    },
    getFirstSetMealValidationError() {
      const groups = Array.isArray(this.setMealOptionalGroups) ? this.setMealOptionalGroups : []
      for (let i = 0; i < groups.length; i++) {
        const g = groups[i]
        if (!g) {
          continue
        }
        const type = String(g.IsFixup)
        if (type === '1') {
          continue
        }
        const min = Number(g.MinSelItems || 0)
        const max = Number(g.MaxSelItems || 0)
        const sl = Number(g.sl || 0)
        const name = this.getSetMealGroupName(g)
        if (type === '2') {
          if (max > 0 && sl <= 0) {
            return {
              title: name,
              text: max === 1 ? (this.$lang[this.pickxb].l44 + ' 1 ' + this.$lang[this.pickxb].l24) : (this.$lang[this.pickxb].l44 + ' 1~' + max + ' ' + this.$lang[this.pickxb].l24)
            }
          }
          continue
        }
        if (type === '0') {
          const required = min > 0 ? min : max
          if (required > 0 && sl !== required) {
            return {
              title: name,
              text: this.$lang[this.pickxb].l41 + ' ' + required + ' ' + this.$lang[this.pickxb].l24
            }
          }
        }
        if (type === '3') {
          if ((min > 0 && sl < min) || (max > 0 && sl > max)) {
            return {
              title: name,
              text: this.$lang[this.pickxb].l41 + ' ' + min + '~' + max + ' ' + this.$lang[this.pickxb].l24
            }
          }
        }
      }
      return null
    },
    changeSetMealQty(delta) {
      const isWeight = String(this.setMealKind) === 'weight'
      const stepRaw = Number(delta || 0)
      const step = isWeight && stepRaw !== 0 ? (stepRaw > 0 ? 0.1 : -0.1) : stepRaw
      const next = Number(this.setMealQty || (isWeight ? 0 : 1)) + Number(step || 0)
      if (isWeight) {
        const clamped = Math.max(0.01, Math.min(999.99, isFinite(next) ? next : 0.01))
        this.setMealQty = Number(clamped.toFixed(2))
        return
      }
      this.setMealQty = Math.max(1, Math.min(99, isFinite(next) ? next : 1))
    },
    confirmSetMealAdd() {
		console.log(this.setMealKind)
      if (!this.ShopID || !this.setMealGoods || !this.setMealGoods.GoodsID) {
        this.closeSetMeal()
        return
      }
      if (this.setMealKind === 'weight') {
        this.confirmWeightAdd()
        return
      }
      if (this.setMealKind === 'unit') {
        this.confirmUnitAdd()
        return
      }
      if (this.setMealKind === 'remark') {
        this.confirmRemarkAdd()
        return
      }
      if (this.setMealKind === 'optional') {
        const firstError = this.getFirstSetMealValidationError()
        if (firstError) {
          this.showSetMealAlert(firstError.title, firstError.text)
          return
        }
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const goodsId = this.setMealGoods.GoodsID
      const addQty = Math.max(1, Number(this.setMealQty || 1))
      let money
      if (this.IsBuffet && this.setMealGoods.IsBuffetGoods) {
        money = Number(this.setMealGoods.Price || 0)
      } else {
        money = this.setMealGoods.MessyPrice !== undefined && this.setMealGoods.MessyPrice !== null
          ? Number(this.setMealGoods.MessyPrice)
          : Number(this.setMealGoods.DeliveryPrice || 0)
      }
      let selectedChildren = []
      let selectedChildRemarkKey = ''
      if (this.setMealKind === 'fixed') {
        selectedChildren = Array.isArray(this.setMealFixedList) ? this.setMealFixedList : []
        selectedChildRemarkKey = ''
      } else {
        const groups = Array.isArray(this.setMealOptionalGroups) ? this.setMealOptionalGroups : []
        const arr = []
        const cpkArr = []
        for (let i = 0; i < groups.length; i++) {
          const g = groups[i]
          if (!g || !Array.isArray(g.list)) {
            continue
          }
          const isFixup = String(g.IsFixup)
          const groupId = g && g.GroupID !== undefined ? String(g.GroupID) : ('g' + i)
          for (let j = 0; j < g.list.length; j++) {
            const row = g.list[j]
            const childId = row && (row.GoodsID || row.ID || row.id)
            if (!childId) {
              continue
            }
            const qua = parseInt(row.Qua, 10) || 0
            if (isFixup === '1') {
              const q = qua > 0 ? qua : 1
              arr.push({ ...row, GoodsID: childId, Qua: q })
              cpkArr.push(String(groupId) + ':' + String(childId) + 'x' + q)
              continue
            }
            if (qua > 0) {
              arr.push({ ...row, GoodsID: childId, Qua: qua })
              cpkArr.push(String(groupId) + ':' + String(childId) + 'x' + qua)
            }
          }
        }
        selectedChildren = arr
        selectedChildRemarkKey = cpkArr.sort().join('|')
      }
      const selectedChildIdSet = {}
      for (let i = 0; i < selectedChildren.length; i++) {
        const row = selectedChildren[i]
        const childId = row && (row.GoodsID || row.ID || row.id)
        if (childId) {
          selectedChildIdSet[String(childId)] = true
        }
      }
      const rootIdx = list.findIndex(v => {
        if (!(v && v.id == goodsId && (v.isRoot === 1 || v.isRoot === '1') && !(v.IsChild === 1 || v.IsChild === '1'))) {
          return false
        }
        if (!(this.setMealKind === 'optional')) {
          return true
        }
        const vk = v && v._setMealChildKey ? String(v._setMealChildKey) : ''
        return vk === selectedChildRemarkKey
      })
      if (rootIdx >= 0) {
        const root = { ...list[rootIdx] }
        root.FromID = root.FromID || Math.floor(Math.random() * 100000)
        root.sl = Math.min(99, Number(root.sl || 0) + addQty)
        root.zt = root.zt !== undefined ? root.zt : true
        root.momey = root.momey !== undefined ? root.momey : (isFinite(money) ? money : 0)
        root.typeid = root.typeid !== undefined ? root.typeid : this.setMealGoods.TypeID
        root.isRoot = 1
        root.IsChild = 0
        if (this.setMealKind === 'optional') {
          root._setMealChildKey = selectedChildRemarkKey
        }
        list.splice(rootIdx, 1, root)
        const fromId = root.FromID
        if (this.setMealKind === 'optional') {
          list = list.filter(v => {
            if (!(v && (v.IsChild === 1 || v.IsChild === '1') && v.FromID == fromId)) {
              return true
            }
            return !!selectedChildIdSet[String(v.id)]
          })
        }
        const children = Array.isArray(selectedChildren) ? selectedChildren : []
        for (let i = 0; i < children.length; i++) {
          const row = children[i]
          const childId = row && (row.GoodsID || row.ID || row.id)
          if (!childId) {
            continue
          }
          const jcQua = Math.max(1, parseInt(row.Qua, 10) || 1)
          const childIdx = list.findIndex(v => v && (v.IsChild === 1 || v.IsChild === '1') && v.FromID == fromId && v.id == childId)
          const childMoney = row && row.Price !== undefined ? Number(row.Price) : 0
          const childObj = {
            zt: root.zt,
            sl: jcQua * root.sl,
            jcQua: jcQua,
            bz: '',
            id: childId,
            typeid: row.TypeID,
            momey: 0,
            Goods: row.Goods,
            TwoGoods: row.TwoGoods,
            ThreeGoods: row.ThreeGoods,
            IsBuffetGoods: 0,
            addmomey: isFinite(childMoney) && childMoney > 0 ? childMoney : 0,
            FromID: fromId,
            IsChild: 1,
            isRoot: 0,
            zf: '0,0,0,0,0,0,0,0',
            zuofa1: '',
            zuofa2: '',
            zuofa3: '',
            getTime: (new Date()).getTime() - Math.floor(Math.random() * 1000)
          }
          if (childIdx >= 0) {
            list.splice(childIdx, 1, { ...list[childIdx], ...childObj })
          } else {
            list.push(childObj)
          }
        }
      } else {
        const fromId = Math.floor(Math.random() * 100000)
        list.push({
          zt: true,
          sl: addQty,
          bz: '',
          id: goodsId,
          typeid: this.setMealGoods.TypeID,
          momey: isFinite(money) ? money : 0,
          Goods: this.setMealGoods.Goods,
          TwoGoods: this.setMealGoods.TwoGoods,
          ThreeGoods: this.setMealGoods.ThreeGoods,
          IsBuffetGoods: !!this.setMealGoods.IsBuffetGoods,
          addmomey: 0,
          FromID: fromId,
          IsChild: 0,
          isRoot: 1,
          zf: '0,0,0,0,0,0,0,0',
          zuofa1: '',
          zuofa2: '',
          zuofa3: '',
          MinShare: this.setMealGoods.MinShare || 0,
          getTime: (new Date()).getTime(),
          MaxQuas: this.setMealGoods.MaxQuas ? this.setMealGoods.MaxQuas : 0,
          _setMealChildKey: this.setMealKind === 'optional' ? selectedChildRemarkKey : ''
        })
        const children = Array.isArray(selectedChildren) ? selectedChildren : []
        for (let i = 0; i < children.length; i++) {
          const row = children[i]
          const childId = row && (row.GoodsID || row.ID || row.id)
          if (!childId) {
            continue
          }
          const jcQua = Math.max(1, parseInt(row.Qua, 10) || 1)
          const childMoney = row && row.Price !== undefined ? Number(row.Price) : 0
          list.push({
            zt: true,
            sl: jcQua * addQty,
            jcQua: jcQua,
            bz: '',
            id: childId,
            typeid: row.TypeID,
            momey: isFinite(childMoney) ? childMoney : 0,
            Goods: row.Goods,
            TwoGoods: row.TwoGoods,
            ThreeGoods: row.ThreeGoods,
            IsBuffetGoods: 0,
            addmomey: 0,
            FromID: fromId,
            IsChild: 1,
            isRoot: 0,
            zf: '0,0,0,0,0,0,0,0',
            zuofa1: '',
            zuofa2: '',
            zuofa3: '',
            getTime: (new Date()).getTime() - Math.floor(Math.random() * 1000)
          })
        }
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
      this.closeSetMeal()
    },
    confirmRemarkAdd() {
      if (!this.ShopID || !this.setMealGoods || !this.setMealGoods.GoodsID) {
        this.closeSetMeal()
        return
      }
      let selected = []
      if (this.setMealRemarkGroups && this.setMealRemarkGroups.length) {
        const groups = Array.isArray(this.setMealRemarkGroups) ? this.setMealRemarkGroups : []
        for (let i = 0; i < groups.length; i++) {
          const g = groups[i]
          if (!g) {
            continue
          }
          const groupType = g.GroupType !== undefined ? parseInt(g.GroupType, 10) : 0
          const maxSel = g.MaxSelItems !== undefined ? parseInt(g.MaxSelItems, 10) : 0
          const items = Array.isArray(g.TRemarkGroupItemsTemp) ? g.TRemarkGroupItemsTemp : []
          let choose = 0
          for (let j = 0; j < items.length; j++) {
            if (items[j] && items[j].ZT) {
              choose += 1
              selected.push(items[j])
            }
          }
          const name = this.getRemarkGroupName(g) || this.$lang[this.pickxb].l40
          if (groupType === 1 && maxSel > 0 && choose !== maxSel) {
            this.showSetMealAlert(name, this.$lang[this.pickxb].l41 + ' ' + maxSel + ' ' + this.$lang[this.pickxb].l24)
            return
          }
          if (groupType === 2 && maxSel > 0 && choose < maxSel) {
            this.showSetMealAlert(name, this.$lang[this.pickxb].l42 + ' ' + maxSel + ' ' + this.$lang[this.pickxb].l24)
            return
          }
          if (groupType === 3 && maxSel > 0 && choose > maxSel) {
            this.showSetMealAlert(name, this.$lang[this.pickxb].l43 + ' ' + maxSel + ' ' + this.$lang[this.pickxb].l24)
            return
          }
        }
      } else {
        const list0 = Array.isArray(this.setMealRemarkList) ? this.setMealRemarkList : []
        for (let i = 0; i < list0.length; i++) {
          if (list0[i] && list0[i].ZT) {
            selected.push(list0[i])
          }
        }
        const rule = this.getRemarkChooseRule()
        const chooseCount = selected.length
        if (rule.mode === 1 && rule.num > 0 && chooseCount !== rule.num) {
          this.showSetMealAlert(this.$lang[this.pickxb].l40, this.$lang[this.pickxb].l41 + ' ' + rule.num + ' ' + this.$lang[this.pickxb].l24)
          return
        }
        if (rule.mode === 2 && rule.num > 0 && chooseCount < rule.num) {
          this.showSetMealAlert(this.$lang[this.pickxb].l40, this.$lang[this.pickxb].l42 + ' ' + rule.num + ' ' + this.$lang[this.pickxb].l24)
          return
        }
        if (rule.mode === 3 && rule.num > 0 && chooseCount > rule.num) {
          this.showSetMealAlert(this.$lang[this.pickxb].l40, this.$lang[this.pickxb].l43 + ' ' + rule.num + ' ' + this.$lang[this.pickxb].l24)
          return
        }
      }
      const ids = []
      let addmomey = 0
      let zuofa1 = ''
      let zuofa2 = ''
      let zuofa3 = ''
      for (let i = 0; i < selected.length; i++) {
        const row = selected[i]
        const id = row && (row.RemarkID || row.ID || row.id)
        if (id) {
          ids.push(String(id))
        }
        const add = this.getRemarkAddPrice(row)
        if (isFinite(add)) {
          addmomey += add
        }
        const n1 = row && row.Remark ? String(row.Remark) : ''
        const n2 = row && row.TwoWorkReMark ? String(row.TwoWorkReMark) : (row && row.TwoRemark ? String(row.TwoRemark) : '')
        const n3 = row && row.ThreeWorkReMark ? String(row.ThreeWorkReMark) : (row && row.ThreeRemark ? String(row.ThreeRemark) : '')
        if (n1) {
          zuofa1 += (zuofa1 ? ';' : '') + n1
        }
        if (n2) {
          zuofa2 += (zuofa2 ? ';' : '') + n2
        }
        if (n3) {
          zuofa3 += (zuofa3 ? ';' : '') + n3
        }
      }
      const maxLen = 8
      const idArr = ids.slice(0, maxLen)
      let zf = ''
      if (!idArr.length) {
        zf = '0,0,0,0,0,0,0,0'
      } else {
        zf = idArr.join(',')
        if (idArr.length < maxLen) {
          for (let i = idArr.length; i < maxLen; i++) {
            zf += ',0'
          }
        }
      }

      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const goodsId = this.setMealGoods.GoodsID
      const sameRemarkFilter = v => {
        if (!(v && v.id == goodsId && (v.IsChild === 0 || v.IsChild === '0' || v.IsChild === undefined))) {
          return false
        }
        const vZf = String(v && v.zf !== undefined ? v.zf : '')
        const vZ1 = String(v && v.zuofa1 !== undefined ? v.zuofa1 : '')
        const vZ2 = String(v && v.zuofa2 !== undefined ? v.zuofa2 : '')
        const vZ3 = String(v && v.zuofa3 !== undefined ? v.zuofa3 : '')
        if (vZf !== String(zf)) return false
        if (vZ1 !== String(zuofa1)) return false
        if (vZ2 !== String(zuofa2)) return false
        if (vZ3 !== String(zuofa3)) return false
        return true
      }
      const idx = list.findIndex(sameRemarkFilter)
      const current = idx >= 0 ? list[idx] : null
      const addQty = Math.max(1, Number(this.setMealQty || 1))
      const nextSl = Math.min(99, Number(current && current.sl ? current.sl : 0) + addQty)
      let money
      if (this.IsBuffet && this.setMealGoods.IsBuffetGoods) {
        money = Number(this.setMealGoods.Price || 0)
      } else {
        money = this.setMealGoods.MessyPrice !== undefined && this.setMealGoods.MessyPrice !== null
          ? Number(this.setMealGoods.MessyPrice)
          : Number(this.setMealGoods.DeliveryPrice || 0)
      }
      const obj = {
        zt: true,
        sl: nextSl,
        bz: '',
        id: goodsId,
        typeid: this.setMealGoods.TypeID,
        momey: isFinite(money) ? money : 0,
        Goods: this.setMealGoods.Goods,
        TwoGoods: this.setMealGoods.TwoGoods,
        ThreeGoods: this.setMealGoods.ThreeGoods,
        IsBuffetGoods: !!this.setMealGoods.IsBuffetGoods,
        addmomey: isFinite(addmomey) ? addmomey : 0,
        FromID: 0,
        IsChild: 0,
        isRoot: 0,
        zf: zf,
        zuofa1: zuofa1,
        zuofa2: zuofa2,
        zuofa3: zuofa3,
        MinShare: this.setMealGoods.MinShare || 0,
        getTime: (new Date()).getTime(),
        MaxQuas: this.setMealGoods.MaxQuas ? this.setMealGoods.MaxQuas : 0
      }
      if (current) {
        obj.zt = current.zt !== undefined ? current.zt : true
        obj.FromID = current.FromID !== undefined ? current.FromID : 0
        obj.IsChild = current.IsChild !== undefined ? current.IsChild : 0
        obj.isRoot = current.isRoot !== undefined ? current.isRoot : 0
        obj.bz = current.bz !== undefined ? current.bz : ''
        list.splice(idx, 1, obj)
      } else {
        list.push(obj)
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
      this.closeSetMeal()
    },
    playAddToCartEffect(event) {
      if (!event || !event.currentTarget || !event.currentTarget.getBoundingClientRect) {
        return
      }
      const startRect = event.currentTarget.getBoundingClientRect()
      const startX = startRect.left + startRect.width / 2
      const startY = startRect.top + startRect.height / 2
      const cartEl = this.$refs.cartBtn
      if (!cartEl || !cartEl.getBoundingClientRect) {
        return
      }
      const endRect = cartEl.getBoundingClientRect()
      const endX = endRect.left + endRect.width / 2
      const endY = endRect.top + endRect.height / 2
      const id = this.flyBallSeed++
      const ball = {
        id,
        x: startX,
        y: startY,
        dx: endX - startX,
        dy: endY - startY,
        moved: false
      }
      this.flyBalls = this.flyBalls.concat(ball)
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.flyBalls = this.flyBalls.map(b => (b.id === id ? { ...b, moved: true } : b))
          setTimeout(() => {
            this.flyBalls = this.flyBalls.filter(b => b.id !== id)
          }, 720)
        })
      })
    },
    decreaseFromCart(goodsId) {
      if (!this.ShopID || !goodsId) {
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const idx = list.findIndex(v => v && v.id == goodsId && !(v.IsChild === 1 || v.IsChild === '1'))
      if (idx < 0) {
        return
      }
      const next = { ...list[idx] }
      const nextSl = Number(next.sl || 0) - 1
      next.sl = Math.max(0, nextSl)
      if (next.sl <= 0) {
        const fromId = next.FromID
        list.splice(idx, 1)
        if (next.isRoot === 1 || next.isRoot === '1') {
          list = list.filter(v => !(v && (v.IsChild === 1 || v.IsChild === '1') && v.FromID == fromId))
        }
      } else {
        list.splice(idx, 1, next)
        if (next.isRoot === 1 || next.isRoot === '1') {
          const fromId = next.FromID
          for (let i = 0; i < list.length; i++) {
            const row = list[i]
            if (row && (row.IsChild === 1 || row.IsChild === '1') && row.FromID == fromId) {
              const jcQua = Math.max(1, parseInt(row.jcQua, 10) || 1)
              list[i] = { ...row, sl: jcQua * next.sl, zt: next.zt }
            }
          }
        }
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
    openUnitPrice(item) {
      this.setMealKind = 'unit'
      this.setMealGoods = item
      const minShare = Number(item && item.MinShare ? item.MinShare : 0)
      this.setMealQty = minShare > 0 ? minShare : 1
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealUnitList = []
      this.setMealUnitIndex = 0
      this.setMealVisible = true
      this.setMealLoading = true
      this.lockBodyScroll(true)
      if (!this.ShopID || !item || !item.GoodsID) {
        this.setMealLoading = false
        return
      }
      const base = Number(this.getGoodsPrice(item) || 0)
      const matched = this.cartList.find(v => v && v.id == item.GoodsID && v.unitExtra !== undefined && !(v.IsChild === 1 || v.IsChild === '1'))
      const currentExtra = matched ? Number(matched.unitExtra) : (matched ? (Number(matched.momey || 0) - base) : 0)
      this.axios
        .get(this.$lujin + '/api/Default/UnitPrice?GoodsID=' + item.GoodsID + '&ShopID=' + this.ShopID)
        .then((res) => {
          let list = res && res.data && res.data.data ? res.data.data : (res ? res.data : [])
          if (typeof list === 'string') {
            try {
              list = JSON.parse(list)
            } catch (e) {
              list = []
            }
          }
          if (list && Array.isArray(list.data)) {
            list = list.data
          }
          if (list && Array.isArray(list.Table)) {
            list = list.Table
          }
          const arr = Array.isArray(list) ? list : []
          this.setMealUnitList = arr
          if (arr.length) {
            const idx = arr.findIndex(v => isFinite(Number(v && v.MessyPrice)) && Number(v.MessyPrice) === Number(currentExtra))
            this.setMealUnitIndex = idx >= 0 ? idx : 0
          } else {
            this.setMealUnitIndex = 0
          }
          this.setMealLoading = false
        })
        .catch(() => {
          this.setMealUnitList = []
          this.setMealUnitIndex = 0
          this.setMealLoading = false
        })
    },
    selectSetMealUnit(index) {
      const idx = Number(index)
      if (!isFinite(idx) || idx < 0) {
        return
      }
      if (!(this.setMealUnitList && this.setMealUnitList.length)) {
        return
      }
      if (idx >= this.setMealUnitList.length) {
        return
      }
      this.setMealUnitIndex = idx
    },
    getUnitLabel(u) {
      return u && u.Unit ? String(u.Unit) : ''
    },
    getUnitExtra(u) {
      const num = Number(u && u.MessyPrice !== undefined ? u.MessyPrice : 0)
      return isFinite(num) ? num : 0
    },
    confirmUnitAdd() {
      if (!this.ShopID || !this.setMealGoods || !this.setMealGoods.GoodsID) {
        this.closeSetMeal()
        return
      }
      const u = this.setMealUnitList && this.setMealUnitList[this.setMealUnitIndex]
      if (!u) {
        this.closeSetMeal()
        return
      }
      const qty = Math.max(1, Number(this.setMealQty || 1))
      this.addToCartWithUnit(this.setMealGoods, u, qty)
      this.closeSetMeal()
    },
    addToCartWithUnit(item, unitRow, qty) {
      if (!this.ShopID || !item || !item.GoodsID) {
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const goodsId = item.GoodsID
      const unitName = this.getUnitLabel(unitRow)
      const unitExtra = this.getUnitExtra(unitRow)
      const idx = list.findIndex(v => v && v.id == goodsId && (v.IsChild === 0 || v.IsChild === '0' || v.IsChild === undefined) && String(v.unitName || '') === String(unitName) && Number(v.unitExtra || 0) === Number(unitExtra))
      const current = idx >= 0 ? list[idx] : null
      const nextSl = Math.min(99, Number(current && current.sl ? current.sl : 0) + Math.max(1, Number(qty || 1)))
      const baseMoney = item.MessyPrice !== undefined && item.MessyPrice !== null
        ? Number(item.MessyPrice)
        : Number(item.DeliveryPrice || 0)
      const money = (isFinite(unitExtra) ? unitExtra : 0)
      const obj = {
        zt: true,
        sl: nextSl,
        bz: '',
        id: goodsId,
        typeid: item.TypeID,
        momey: isFinite(money) ? money : 0,
        Goods: item.Goods,
        TwoGoods: item.TwoGoods,
        ThreeGoods: item.ThreeGoods,
        IsBuffetGoods: !!item.IsBuffetGoods,
        addmomey: 0,
        FromID: 0,
        IsChild: 0,
        isRoot: 0,
        zf: '0,0,0,0,0,0,0,0',
        zuofa1: '',
        zuofa2: '',
        zuofa3: '',
        MinShare: item.MinShare || 0,
        getTime: (new Date()).getTime(),
        MaxQuas: item.MaxQuas ? item.MaxQuas : 0,
        unit: unitName,
        unitExtra: unitExtra
      }
      if (current) {
        obj.zt = current.zt !== undefined ? current.zt : true
        obj.addmomey = current.addmomey !== undefined ? current.addmomey : 0
        obj.FromID = current.FromID !== undefined ? current.FromID : 0
        obj.IsChild = current.IsChild !== undefined ? current.IsChild : 0
        obj.isRoot = current.isRoot !== undefined ? current.isRoot : 0
        obj.zf = current.zf !== undefined ? current.zf : obj.zf
        obj.zuofa1 = current.zuofa1 !== undefined ? current.zuofa1 : ''
        obj.zuofa2 = current.zuofa2 !== undefined ? current.zuofa2 : ''
        obj.zuofa3 = current.zuofa3 !== undefined ? current.zuofa3 : ''
        obj.bz = current.bz !== undefined ? current.bz : ''
        list.splice(idx, 1, obj)
      } else {
        list.push(obj)
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
	  console.log(list)
    },
    openWeightGoods(item) {
      this.setMealKind = 'weight'
      this.setMealGoods = item
      this.setMealQty = Number(item && item.MinShare ? item.MinShare : 0.5)
      if (!isFinite(Number(this.setMealQty)) || Number(this.setMealQty) <= 0) {
        this.setMealQty = 0.5
      }
      this.setMealQty = Number(Number(this.setMealQty).toFixed(2))
      this.setMealFixedList = []
      this.setMealOptionalGroups = []
      this.setMealRemarkList = []
      this.setMealRemarkGroups = []
      this.setMealUnitList = []
      this.setMealUnitIndex = 0
      this.setMealVisible = true
      this.setMealLoading = false
      this.lockBodyScroll(true)
    },
    onWeightQtyInput(e) {
      const raw = e && e.target ? e.target.value : ''
      if (raw === '' || raw === null || raw === undefined) {
        return
      }
      const num = Number(String(raw).replace(/[^\d.]/g, ''))
      if (!isFinite(num)) {
        return
      }
      const clamped = Math.max(0.01, Math.min(999.99, num))
      this.setMealQty = Number(clamped.toFixed(2))
    },
    confirmWeightAdd() {
      if (!this.ShopID || !this.setMealGoods || !this.setMealGoods.GoodsID) {
        this.closeSetMeal()
        return
      }
      const qty = Number(this.setMealQty || 0)
      if (!isFinite(qty) || qty <= 0) {
        this.showSetMealAlert('', '请输入有效的称重数量')
        return
      }
      const clampedQty = Number(Math.max(0.01, Math.min(999.99, qty)).toFixed(2))
      this.addToCartWithWeight(this.setMealGoods, clampedQty)
      this.closeSetMeal()
    },
    addToCartWithWeight(item, qty) {
      if (!this.ShopID || !item || !item.GoodsID) {
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const goodsId = item.GoodsID
      const baseMoney = item.MessyPrice !== undefined && item.MessyPrice !== null
        ? Number(item.MessyPrice)
        : Number(item.DeliveryPrice || 0)
      const currentIdx = list.findIndex(v => v && v.id == goodsId && v.IsWeight === 1 && (v.IsChild === 0 || v.IsChild === '0' || v.IsChild === undefined))
      const current = currentIdx >= 0 ? list[currentIdx] : null
      const currentSl = current && current.sl !== undefined && isFinite(Number(current.sl)) ? Number(current.sl) : 0
      const nextSl = Number((Number(currentSl) + Number(qty || 0)).toFixed(2))
      const obj = {
        zt: true,
        sl: nextSl,
        bz: '',
        id: goodsId,
        typeid: item.TypeID,
        momey: isFinite(baseMoney) ? baseMoney : 0,
        Goods: item.Goods,
        TwoGoods: item.TwoGoods,
        ThreeGoods: item.ThreeGoods,
        IsBuffetGoods: !!item.IsBuffetGoods,
        addmomey: 0,
        FromID: 0,
        IsChild: 0,
        isRoot: 0,
        zf: '0,0,0,0,0,0,0,0',
        zuofa1: '',
        zuofa2: '',
        zuofa3: '',
        MinShare: item.MinShare || 0,
        getTime: (new Date()).getTime(),
        MaxQuas: item.MaxQuas ? item.MaxQuas : 0,
        IsWeight: 1,
        WeightUnit: 'kg'
      }
      if (current) {
        obj.zt = current.zt !== undefined ? current.zt : true
        obj.addmomey = current.addmomey !== undefined ? current.addmomey : 0
        obj.FromID = current.FromID !== undefined ? current.FromID : 0
        obj.IsChild = current.IsChild !== undefined ? current.IsChild : 0
        obj.isRoot = current.isRoot !== undefined ? current.isRoot : 0
        obj.zf = current.zf !== undefined ? current.zf : obj.zf
        obj.zuofa1 = current.zuofa1 !== undefined ? current.zuofa1 : ''
        obj.zuofa2 = current.zuofa2 !== undefined ? current.zuofa2 : ''
        obj.zuofa3 = current.zuofa3 !== undefined ? current.zuofa3 : ''
        obj.bz = current.bz !== undefined ? current.bz : ''
        list.splice(currentIdx, 1, obj)
      } else {
        list.push(obj)
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
    openCart() {
      this.refreshCartFromStorage()
      this.syncSelectedCoupons()
      this.cartVisible = true
      this.lockBodyScroll(true)
    },
    closeCart() {
      this.couponDialogVisible = false
      this.cartVisible = false
      this.lockBodyScroll(false)
    },
    lockBodyScroll(locked) {
      const body = document && document.body
      if (!body) {
        return
      }
      if (locked) {
        if (this.bodyOverflowBackup === null || this.bodyOverflowBackup === undefined) {
          this.bodyOverflowBackup = body.style.overflow || ''
        }
        body.style.overflow = 'hidden'
        return
      }
      body.style.overflow = this.bodyOverflowBackup || ''
      this.bodyOverflowBackup = null
    },
    getCartItemName(c) {
      if (!c) {
        return ''
      }
	  if (this.WXLangGoodsxb === 1) {
	    return c.TwoGoods || c.Goods || c.ThreeGoods || ''
	  }
	  if (this.WXLangGoodsxb === 2) {
	    return c.ThreeGoods || c.Goods || c.TwoGoods || ''
	  }
      return c.Goods || c.TwoGoods || c.ThreeGoods || ''
    },
    getCartItemZuofa(c) {
      if (!c) {
        return ''
      }
	  if (this.WXLangGoodsxb === 1) {
	    return c.zuofa2
	  }
	  if (this.WXLangGoodsxb === 2) {
	    return c.zuofa3
	  }
      const text = c.zuofa1
      return text ? String(text).trim() : ''
    },
    isCartSetMealRoot(c) {
      if (!c) {
        return false
      }
      const isRoot = c.isRoot === 1 || c.isRoot === '1' || c.isRoot === true
      const fromId = c.FromID !== undefined && c.FromID !== null ? String(c.FromID) : ''
      if (!isRoot || !fromId || fromId === '0') {
        return false
      }
      const list = Array.isArray(this.cartList) ? this.cartList : []
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        if (row && (row.IsChild === 1 || row.IsChild === '1') && String(row.FromID) === fromId) {
          return true
        }
      }
      return false
    },
    getCartSetMealChildren(c) {
      if (!c) {
        return []
      }
      const fromId = c.FromID !== undefined && c.FromID !== null ? String(c.FromID) : ''
      if (!fromId || fromId === '0') {
        return []
      }
      const list = Array.isArray(this.cartList) ? this.cartList : []
      const children = []
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        if (row && (row.IsChild === 1 || row.IsChild === '1') && String(row.FromID) === fromId) {
          children.push(row)
        }
      }
      return children
    },
    getCartSetMealTotalPrice(c) {
      if (!c) {
        return 0
      }
      const basePrice = Number(c.momey || 0)
      const children = this.getCartSetMealChildren(c)
      let addPrice = 0
      for (let i = 0; i < children.length; i++) {
        const child = children[i]
        const childAdd = Number(child.addmomey || 0)
        if (isFinite(childAdd) && childAdd > 0) {
          addPrice += childAdd * (Number(child.jcQua || 1) || 1)
        }
      }
      return isFinite(basePrice) ? basePrice + addPrice : addPrice
    },
    getCartItemImage(c) {
      const id = c && c.id
      if (!this.ShopID || !id) {
        return this.fallbackBanner
      }
      if (this.goodsImageErrorMap[id]) {
        return this.fallbackBanner
      }
      return this.$lujin + '/Data/' + this.ShopID + '/GoodsPic/' + id + '.jpg?Time=' + 0
    },
    formatCartMoney(value) {
      const num = Number(value || 0)
      if (!isFinite(num)) {
        return (0).toFixed(this.DecimalBit)
      }
      return num.toFixed(this.DecimalBit)
    },
    changeCartQty(c, delta) {
      if (!this.ShopID || !c || !c.id) {
        return
      }
      if (Number(delta) > 0 && this.IsBuffet && this.Numberpoints > 0 && c.IsBuffetGoods) {
        const cartList = Array.isArray(this.cartList) ? this.cartList : []
        let totalQty = 0
        for (let i = 0; i < cartList.length; i++) {
          const cartItem = cartList[i]
          if (cartItem && cartItem.IsBuffetGoods) {
            totalQty += Number(cartItem.sl || 0)
          }
        }
        if (totalQty >= this.Numberpoints) {
          this.searchAddToastText = this.$lang[this.pickxb].l97
          this.searchAddToastVisible = true
          if (this.searchAddToastTimer) {
            clearTimeout(this.searchAddToastTimer)
            this.searchAddToastTimer = null
          }
          this.searchAddToastTimer = setTimeout(() => {
            this.searchAddToastVisible = false
            this.searchAddToastTimer = null
          }, 2000)
          return
        }
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const idx = list.findIndex(v => v && v.id == c.id && !(v.IsChild === 1 || v.IsChild === '1'))
      if (idx < 0) {
        return
      }
      const next = { ...list[idx] }
      const nextSl = Number(next.sl || 0) + Number(delta || 0)
      next.sl = Math.max(0, Math.min(99, nextSl))
      if (next.sl <= 0) {
        const fromId = next.FromID
        list.splice(idx, 1)
        if (next.isRoot === 1 || next.isRoot === '1') {
          list = list.filter(v => !(v && (v.IsChild === 1 || v.IsChild === '1') && v.FromID == fromId))
        }
      } else {
        list.splice(idx, 1, next)
        if (next.isRoot === 1 || next.isRoot === '1') {
          const fromId = next.FromID
          for (let i = 0; i < list.length; i++) {
            const row = list[i]
            if (row && (row.IsChild === 1 || row.IsChild === '1') && row.FromID == fromId) {
              const jcQua = Math.max(1, parseInt(row.jcQua, 10) || 1)
              list[i] = { ...row, sl: jcQua * next.sl, zt: next.zt }
            }
          }
        }
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
    toggleCartSelect(c) {
      if (!this.ShopID || !c || !c.id) {
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const idx = list.findIndex(v => v && v.id == c.id && !(v.IsChild === 1 || v.IsChild === '1'))
      if (idx < 0) {
        return
      }
      const next = { ...list[idx] }
      next.zt = !next.zt
      list.splice(idx, 1, next)
      if (next.isRoot === 1 || next.isRoot === '1') {
        const fromId = next.FromID
        for (let i = 0; i < list.length; i++) {
          const row = list[i]
          if (row && (row.IsChild === 1 || row.IsChild === '1') && row.FromID == fromId) {
            list[i] = { ...row, zt: next.zt }
          }
        }
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
    toggleSelectAll() {
      if (!this.ShopID) {
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const nextState = !this.cartAllSelected
      const rootFromIds = []
      for (let i = 0; i < list.length; i++) {
        if (!(list[i] && typeof list[i] === 'object')) {
          continue
        }
        if (list[i].IsChild === 1 || list[i].IsChild === '1') {
          continue
        }
        list[i] = { ...list[i], zt: nextState }
        if (list[i].isRoot === 1 || list[i].isRoot === '1') {
          rootFromIds.push(list[i].FromID)
        }
      }
      if (rootFromIds.length) {
        for (let i = 0; i < list.length; i++) {
          const row = list[i]
          if (row && (row.IsChild === 1 || row.IsChild === '1') && rootFromIds.indexOf(row.FromID) > -1) {
            list[i] = { ...row, zt: nextState }
          }
        }
      }
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
    },
    openRemark(c) {
      if (!c || !c.id) {
        return
      }
      this.remarkTargetId = c.id
      this.remarkText = (c.bz || '').toString()
      this.remarkVisible = true
      this.lockBodyScroll(true)
    },
    closeRemark() {
      this.remarkVisible = false
      this.remarkText = ''
      this.remarkTargetId = ''
      this.syncBodyScrollLock()
    },
    openCartDeleteConfirm() {
      this.cartDeleteVisible = true
      this.syncBodyScrollLock()
    },
    closeCartDeleteConfirm() {
      this.cartDeleteVisible = false
      this.syncBodyScrollLock()
    },
    openCartOrderConfirm() {
      if (this.orderSubmitting || this.orderLoadingVisible) {
        return
      }
      const list = this.readCartFromStorage()
      const selected = this.getSelectedOrderList(list)
      if (!selected.length) {
        this.cartOrderTipMode = true
        this.cartOrderConfirmText = this.$lang[this.pickxb].l26
      } else {
        this.cartOrderTipMode = false
        this.cartOrderConfirmText = this.$lang[this.pickxb].l25
      }
      if (this.IsBuffet && this.Numberpoints > 0) {
        let totalQty = 0
        for (let i = 0; i < selected.length; i++) {
          const item = selected[i]
          if (item && item.IsBuffetGoods) {
            totalQty += Number(item.sl || 0)
          }
        }
        if (totalQty > this.Numberpoints) {
          this.cartOrderTipMode = true
          this.cartOrderConfirmText = this.$lang[this.pickxb].l27
        }
      }
      this.cartOrderVisible = true
      this.syncBodyScrollLock()
    },
    closeCartOrderConfirm() {
      this.cartOrderVisible = false
      this.syncBodyScrollLock()
    },
    confirmCartOrder() {
      if (this.cartOrderTipMode) {
        this.closeCartOrderConfirm()
        return
      }
      if (this.orderSubmitting || this.orderLoadingVisible) {
        return
      }
      this.closeCartOrderConfirm()
      this.placeOrder()
    },
    confirmCartDelete() {
      if (!this.ShopID) {
        this.closeCartDeleteConfirm()
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const removeFromIdSet = {}
      let hasSelected = false
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        if (!row || (row.IsChild === 1 || row.IsChild === '1')) {
          continue
        }
        if (row.zt) {
          hasSelected = true
          if (row.isRoot === 1 || row.isRoot === '1') {
            removeFromIdSet[String(row.FromID)] = true
          }
        }
      }
      if (!hasSelected) {
        this.closeCartDeleteConfirm()
        return
      }
      list = list.filter(row => {
        if (!row) {
          return false
        }
        if (row.IsChild === 1 || row.IsChild === '1') {
          return !removeFromIdSet[String(row.FromID)]
        }
        return !row.zt
      })
      try {
        localStorage.setItem(key, JSON.stringify(list))
      } catch (e) {}
      this.cartList = list
      this.closeCartDeleteConfirm()
    },
    stopOrderPoll() {
      if (this.orderPollTimer) {
        clearInterval(this.orderPollTimer)
        this.orderPollTimer = null
      }
    },
    readCartFromStorage() {
	  console.log(this.cartDisplayList)
      if (!this.ShopID) {
        return []
      }
      try {
        const raw = this.cartDisplayList
        const list = raw ? raw : []
        return this.normalizeCartList(Array.isArray(list) ? list : [])
      } catch (e) {
        return []
      }
    },
    getSelectedOrderList(list) {
	  console.log(list)
      const arr = Array.isArray(list) ? list : []
      const rootFromIdSet = {}
      for (let i = 0; i < arr.length; i++) {
        const row = arr[i]
        if (!row || (row.IsChild === 1 || row.IsChild === '1')) {
          continue
        }
        if (row.zt && (row.isRoot === 1 || row.isRoot === '1')) {
          rootFromIdSet[String(row.FromID)] = true
        }
      }
      const selected = []
      for (let i = 0; i < arr.length; i++) {
        const row = arr[i]
        if (!row) {
          continue
        }
        if (row.IsChild === 1 || row.IsChild === '1') {
          if (rootFromIdSet[String(row.FromID)]) {
            selected.push(row)
          }
          continue
        }
        if (row.zt) {
          selected.push(row)
        }
      }
	  console.log(selected)
      return selected
    },
    buildOpTime() {
      const d = new Date()
      const yy = d.getFullYear()
      const mm = d.getMonth() + 1
      const dd = d.getDate()
      const hh = d.getHours()
      const mf = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      const ss = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
      return yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
    },
    normalizeOrderRow(row) {
      const next = { ...(row || {}) }
      next.IsBuffetGoods = next.IsBuffetGoods ? 1 : 0
      next.IsChild = !!next.IsChild
      next.isRoot = !!next.isRoot
      next.cm = 0
      next.unit = next.unit ? next.unit : ''
      return next
    },
    removeSelectedFromCart(list) {
      const arr = Array.isArray(list) ? list : []
      const rootFromIdSet = {}
      for (let i = 0; i < arr.length; i++) {
        const row = arr[i]
        if (!row || (row.IsChild === 1 || row.IsChild === '1')) {
          continue
        }
        if (row.zt && (row.isRoot === 1 || row.isRoot === '1')) {
          rootFromIdSet[String(row.FromID)] = true
        }
      }
      return arr.filter(row => {
        if (!row) {
          return false
        }
        if (row.IsChild === 1 || row.IsChild === '1') {
          return !rootFromIdSet[String(row.FromID)]
        }
        return !row.zt
      })
    },
    showOrderTip(text) {
      this.cartOrderTipMode = true
      this.cartOrderConfirmText = (text || '').toString()
      this.cartOrderVisible = true
      this.syncBodyScrollLock()
    },
    placeOrder() {
	  //下单
      if (!this.ShopID || !this.DeskID) {
        this.showOrderTip(this.$lang[this.pickxb].l99)
        return
      }
      const list = this.readCartFromStorage()
      const selected = this.getSelectedOrderList(list)
      if (!selected.length) {
        this.showOrderTip(this.$lang[this.pickxb].l26)
        return
      }
      if (this.DeskID === 'Food') {
        if (!this.foods.name || !this.foods.phone) {
          this.showOrderTip(this.foodlist[this.pickxb].on3 + this.foodlist[this.pickxb].on4 + this.$lang[this.pickxb].l100)
          return
        }
      }
      if (this.isOnlinePayEnabled) {
		//在线支付
        if (this.DeskID === 'Food' && this.foods.phone) {
          try {
            localStorage.setItem(this.ShopID + '_foodPhone', this.foods.phone)
          } catch (e) {}
        }
        this.syncSelectedCoupons(true)
        if (this.getOrderTotal() <= 0) {
		  //付款是否是0
          this.submitZeroAmountOnlineOrder()
          return
        }
		//在线支付
        this.prepareOnlinePay()
        return
      }
      this.orderSubmitting = true
      this.orderLoadingVisible = true
      this.orderLoadingText = this.$lang[this.pickxb].l28
      this.syncBodyScrollLock()
      const sj = this.data_s || this.buildOpTime()
      const payload = {
        bz: '',
        zhuoid: this.DeskID,
        ShopID: this.ShopID,
        list: selected.map(v => this.normalizeOrderRow(v)),
        OrderMen: this.foods.name || '',
        OrderPhone: this.foods.phone || '',
        OrderAddress: this.foodzt === 1 ? (this.foods.dizi || '') : '',
        PostCode:this.foods.youb,
        OpTime: this.buildOpTime(),
        CompleteTime: this.DeskID === 'Food' && this.foodzt === 1 ? sj : '1900-01-01 00:00:00',
        ToshopTime: this.DeskID === 'Food' && this.foodzt === 0 ? sj : '1900-01-01 00:00:00',
        ServerMoney: 0,
		PackMoney:0,
		TipMoney:0,
        SheetState: this.DeskID === 'Food' && this.foodzt === 0 ? 4 : (this.DeskID === 'Food' && this.foodzt === 1 ? 3 : 0),
        PayState: 0,
        IsPay: 0,
        UserAgent: navigator.userAgent,
        IsOnlinePay: false,
        trad_id: ''
      }
	  console.log(payload)
      this.axios
        .post(this.$lujin + '/api/Default/Place_the_order', payload)
        .then((res) => {
		  console.log("普通餐楼",res)
          const ok = !!(res && res.data && res.data.state)
          const sheet = res && res.data ? (res.data.sheet || '') : ''
          if (!ok || !sheet) {
            this.orderSubmitting = false
            this.orderLoadingVisible = false
            this.orderLoadingText = ''
            this.syncBodyScrollLock()
            this.showOrderTip(this.$lang[this.pickxb].l29)
            return
          }
          this.startOrderPoll(sheet)
        })
        .catch(() => {
          this.orderSubmitting = false
          this.orderLoadingVisible = false
          this.orderLoadingText = ''
          this.syncBodyScrollLock()
          this.showOrderTip(this.$lang[this.pickxb].l29)
        })
    },
    startOrderPoll(sheet) {
      this.stopOrderPoll()
      this.orderLoadingVisible = true
      this.orderLoadingText = this.$lang[this.pickxb].l30
      this.syncBodyScrollLock()
      let i = 0
      this.orderPollTimer = setInterval(() => {
        i += 1
        if (i >= 12) {
          this.stopOrderPoll()
          this.orderSubmitting = false
          this.orderLoadingVisible = false
          this.orderLoadingText = ''
          this.syncBodyScrollLock()
          this.showOrderTip(this.$lang[this.pickxb].l31)
          return
        }
        this.axios
          .get(this.$lujin + '/api/Default/ddstate?SheetID=' + sheet + '&ShopID=' + this.ShopID + '&DeskID=' + this.DeskID)
          .then(async (res) => {
			console.log(res)
            const row = res && res.data && res.data[0] ? res.data[0] : null
            const state = row ? String(row.State || '') : ''
            if (state === '1') {
              this.stopOrderPoll()
              const list = this.readCartFromStorage()
              const selected = this.getSelectedOrderList(list)
              const rest = this.removeSelectedFromCart(list)
              const finishSuccess = () => {
                try {
                  localStorage.setItem(this.ShopID + 'list', JSON.stringify(rest))
                } catch (e) {}
                this.cartList = rest
                this.orderSubmitting = false
                this.orderLoadingVisible = false
                this.orderLoadingText = ''
                this.syncBodyScrollLock()
              }
              if (this.isOnlinePayEnabled && this.memberSN && this.memberDisplayName && this.DeskID=="Food") {
                try {
                  await this.uploadMemberConsumeOrder(sheet, row, selected, (row && (row.OpTime || row.opTime)) || this.buildOpTime())
                  this.finishMemberCouponConsume()
                } catch (e) {
                  finishSuccess()
                  this.showSetMealAlert(this.$lang[this.pickxb].l17, (e && e.message) ? e.message : this.$lang[this.pickxb].l89)
                  return
                }
              }
              finishSuccess()
              try {
                this.redirectAfterOrderSuccess()
              } catch (e) {}
              return
            }
            if (state === '2') {
              const failure = row ? String(row.Failure || '') : ''
              let msg = this.$lang[this.pickxb].l29
              if (failure === '1') msg = this.$lang[this.pickxb].l32
              if (failure === '4') msg = this.$lang[this.pickxb].l31
              if (failure === '3') msg = this.$lang[this.pickxb].l33
              if (failure === '11') msg = this.$lang[this.pickxb].l34
              if (failure === '12') msg = this.$lang[this.pickxb].l35
              if (failure === '13') msg = this.$lang[this.pickxb].l36
              if (failure === '14') msg = this.$lang[this.pickxb].l37
              if (failure === '15') msg = this.$lang[this.pickxb].l38
              this.stopOrderPoll()
              this.orderSubmitting = false
              this.orderLoadingVisible = false
              this.orderLoadingText = ''
              this.syncBodyScrollLock()
              this.showOrderTip(msg)
            }
          })
          .catch(() => {})
      }, 1000)
    },
    saveRemark() {
      if (!this.ShopID || !this.remarkTargetId) {
        this.closeRemark()
        return
      }
      const key = this.ShopID + 'list'
      let list = []
      try {
        const raw = localStorage.getItem(key)
        list = raw ? JSON.parse(raw) : []
      } catch (e) {
        list = []
      }
      if (!Array.isArray(list)) {
        list = []
      }
      list = this.normalizeCartList(list)
      const idx = list.findIndex(v => v && v.id == this.remarkTargetId && !(v.IsChild === 1 || v.IsChild === '1'))
      if (idx >= 0) {
        const next = { ...list[idx] }
        next.bz = (this.remarkText || '').toString().trim()
        list.splice(idx, 1, next)
        try {
          localStorage.setItem(key, JSON.stringify(list))
        } catch (e) {}
        this.cartList = list
      }
      this.closeRemark()
    },
    onCategoryClick(item) {
      const nextId = item && (item.TypeID || item.typeId)
      if (!nextId) {
        return
      }
      if (this.useCategoryFlatMode) {
        this.activeCategoryId = nextId
        this.$nextTick(() => {
          this.ensureCategoryInView()
          this.scrollToCategoryAnchor(nextId)
        })
        return
      }
      if (nextId === this.activeCategoryId) {
        this.$nextTick(() => {
          this.ensureCategoryInView()
        })
        return
      }
      this.activeCategoryId = nextId
      this.$nextTick(() => {
        this.ensureCategoryInView()
        this.scrollGoodsToFirstRow()
      })
    },
    scrollToCategoryAnchor(typeId) {
      if (!typeId) {
        return
      }
      this.categoryScrollLockUntil = Date.now() + 800
      const goodsEl = this.$refs.goodsGrid
      const topStickyEl = this.$refs.topSticky
      const topStickyHeight = topStickyEl && topStickyEl.getBoundingClientRect
        ? topStickyEl.getBoundingClientRect().height
        : 0
      try {
        const anchor = goodsEl && goodsEl.querySelector
          ? goodsEl.querySelector('.menu-goods-category-flat[data-category-type-id="' + String(typeId) + '"]')
          : null
        if (!anchor) {
          this.scrollGoodsToFirstRow()
          return
        }
        const rect = anchor.getBoundingClientRect ? anchor.getBoundingClientRect() : null
        if (!rect) {
          this.scrollGoodsToFirstRow()
          return
        }
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        const targetTop = Math.max(0, currentScrollTop + rect.top - topStickyHeight - 4)
        const delta = Math.abs(targetTop - currentScrollTop)
        if (delta < 2) {
          return
        }
        try {
          window.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' })
        } catch (e) {
          window.scrollTo(0, targetTop)
        }
      } catch (e) {
        this.scrollGoodsToFirstRow()
      }
    },
    getTopStickyTotalOffset() {
      const topStickyEl = this.$refs.topSticky
      return topStickyEl && topStickyEl.getBoundingClientRect
        ? Number(topStickyEl.getBoundingClientRect().height) || 0
        : 0
    },
    onGoodsScroll() {
      if (this.scrollSyncRaf) {
        return
      }
      this.scrollSyncRaf = 1
      const run = () => {
        this.scrollSyncRaf = 0
        try {
          if (!this.useCategoryFlatMode) {
            return
          }
          if (Date.now() < Number(this.categoryScrollLockUntil || 0)) {
            return
          }
          const goodsEl = this.$refs.goodsGrid
          if (!goodsEl) {
            return
          }
          const anchors = goodsEl.querySelectorAll
            ? Array.prototype.slice.call(goodsEl.querySelectorAll('.menu-goods-category-flat[data-category-type-id]'))
            : []
          if (!anchors.length) {
            return
          }
          const offset = this.getTopStickyTotalOffset() + 12
          let matchedTypeId = ''
          let matchedTop = -Infinity
          for (let i = 0; i < anchors.length; i++) {
            const a = anchors[i]
            const rect = a && a.getBoundingClientRect ? a.getBoundingClientRect() : null
            if (!rect) {
              continue
            }
            const localTop = rect.top - offset
            if (localTop <= 0 && localTop > matchedTop) {
              matchedTop = localTop
              const tid = a.getAttribute && a.getAttribute('data-category-type-id')
              matchedTypeId = tid != null ? String(tid) : ''
            }
          }
          if (!matchedTypeId) {
            const first = anchors[0]
            if (first && first.getAttribute) {
              const t = first.getAttribute('data-category-type-id')
              matchedTypeId = t != null ? String(t) : ''
            }
          }
          if (matchedTypeId && String(matchedTypeId) !== String(this.activeCategoryId)) {
            this.activeCategoryId = matchedTypeId
            this.$nextTick(() => {
              this.ensureCategoryInView()
            })
          }
        } catch (e) {}
      }
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(run)
      } else {
        setTimeout(run, 16)
      }
    },
    scrollGoodsToFirstRow() {
      const goodsEl = this.$refs.goodsGrid
      if (!goodsEl) {
        return
      }
      const topStickyEl = this.$refs.topSticky
      const topStickyHeight = topStickyEl && topStickyEl.getBoundingClientRect
        ? topStickyEl.getBoundingClientRect().height
        : 0
      const rect = goodsEl.getBoundingClientRect ? goodsEl.getBoundingClientRect() : null
      if (!rect) {
        return
      }
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const targetTop = Math.max(0, currentScrollTop + rect.top - topStickyHeight - 8)
      if (Math.abs(targetTop - currentScrollTop) < 2) {
        return
      }
      try {
        window.scrollTo(0, targetTop)
      } catch (e) {
        window.scrollTo(0, targetTop)
      }
    }
  }
}
</script>

<style>
.menu-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #101114 0%, #15171c 45%, #1b1e24 100%);
  padding: 0 .24rem 1.65rem;
  box-sizing: border-box;
}

.menu-intro {
  min-height: 100vh;
  padding: .24rem .24rem calc(env(safe-area-inset-bottom, 0px) + .24rem);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: .28rem;
}

.menu-intro-banner {
  width: 100%;
  margin-top: .36rem;
}

.menu-intro-banner-card {
  width: 100%;
  height: 3.9rem;
  border-radius: .28rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
}

.menu-intro-banner-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.menu-intro-card {
  width: 100%;
  border-radius: .28rem;
  background: rgba(24, 27, 32, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: .3rem .3rem .36rem;
  box-sizing: border-box;
  text-align: left;
}

.menu-intro-title {
  color: #fff;
  font-size: .44rem;
  line-height: .52rem;
  letter-spacing: .01rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 auto;
  min-width: 0;
}

.menu-intro-title-row {
  display: flex;
  align-items: center;
  gap: .16rem;
  flex-wrap: nowrap;
}

.menu-intro-logo {
  width: 1.12rem;
  height: 1.12rem;
  border-radius: .24rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
  flex: 0 0 auto;
}

.menu-intro-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.menu-intro-desc {
  margin-top: .22rem;
  color: rgba(255, 255, 255, 0.72);
  font-size: .28rem;
  line-height: .42rem;
  word-break: break-word;
}

.menu-intro-phone {
  margin-top: .26rem;
  display: flex;
  align-items: baseline;
  gap: .14rem;
  color: rgba(255, 255, 255, 0.92);
  font-size: .3rem;
  line-height: .42rem;
}

.menu-intro-phone-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: .24rem;
  line-height: .34rem;
  flex: 0 0 auto;
}

.menu-intro-phone-value {
  color: rgba(255, 255, 255, 0.92);
  font-size: .32rem;
  line-height: .42rem;
  font-weight: 800;
  word-break: break-word;
}

.menu-intro-table-row {
  margin-top: .26rem;
  display: flex;
  align-items: baseline;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: .14rem;
  color: rgba(255, 255, 255, 0.92);
  font-size: .3rem;
  line-height: .42rem;
  text-align: left;
  width: 100%;
}

.menu-intro-table-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: .24rem;
  line-height: .34rem;
}

.menu-intro-table-value {
  color: rgba(255, 255, 255, 0.92);
  font-size: .32rem;
  line-height: .42rem;
  font-weight: 800;
}

.menu-intro-table-value.desk {
  font-size: .5rem;
  line-height: .6rem;
}

@media (max-width: 360px) {
  .menu-intro-table-row {
    flex-wrap: wrap;
  }
}

.menu-intro-table-split {
  width: 1px;
  height: .26rem;
  background: rgba(255, 255, 255, 0.16);
  display: inline-block;
  align-self: center;
}

.menu-intro-lang-title {
  margin-top: .34rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: .28rem;
  line-height: .38rem;
  font-weight: 700;
}

.menu-intro-langs {
  margin-top: .2rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: .16rem;
}

.menu-intro-lang {
  height: .78rem;
  line-height: .78rem;
  text-align: center;
  border-radius: .78rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: .28rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.menu-intro-lang.on {
  background: #f04e05;
  border-color: rgba(240, 78, 5, 0.6);
  color: #fff;
}

.menu-intro-start {
  margin-top: .4rem;
  width: 100%;
  height: .98rem;
  line-height: .98rem;
  text-align: center;
  border-radius: .98rem;
  background: #f04e05;
  color: #fff;
  font-size: .36rem;
  font-weight: 800;
  letter-spacing: .02rem;
}

.menu-shell {
  width: 100%;
  max-width: 7.5rem;
  margin: 0 auto;
}

.menu-top-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 26;
  background: linear-gradient(180deg, #101114 0%, #15171c 60%, #1b1e24 100%);
  padding: .18rem .24rem .1rem;
  box-sizing: border-box;
  overflow-x: hidden;
}

.menu-top-inner {
  width: 100%;
  max-width: 7.5rem;
  margin: 0 auto;
}

.menu-header {
  display: flex;
  align-items: center;
  margin-bottom: .12rem;
  justify-content: space-between;
}

.menu-brand {
  display: flex;
  align-items: center;
  min-width: 0;
}
.menu-image{
        min-width:0.8rem;
        min-height:0.8rem;
        display:flex;
        align-items:center;
        justify-content:flex-end;
}

.menu-image img{
	width:0.8rem;
	height:0.8rem;
}

.menu-member-greet {
  max-width: 2.2rem;
  color: #fff;
  font-size: .28rem;
  line-height: .36rem;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-logo {
  width: 1rem;
  height: 1rem;
  border-radius: .2rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
  border: 1px dashed rgba(255, 255, 255, 0.22);
  flex: 0 0 auto;
}

.menu-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.menu-meta {
  margin-left: .18rem;
  min-width: 0;
}

.menu-title {
  color: #fff;
  font-size: .36rem;
  font-weight: 700;
  line-height: .46rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align:left;
}

.menu-desk {
  color: rgba(255, 255, 255, 0.82);
  font-size: .3rem;
  line-height: .42rem;
  text-align: left;
}

.menu-desk span {
  color: #ff8b3d;
  font-weight: 700;
  margin-left: .08rem;
}

.menu-lang {
  width: .52rem;
  height: .52rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.menu-lang img {
  width: .52rem;
  height: .52rem;
}

.menu-banner {
  width: 100%;
}

.menu-search {
  display: flex;
  align-items: center;
  gap: .02rem;
  margin-bottom: 0;
}

.menu-search-input {
  flex: 1;
  min-width: 0;
  height: .86rem;
  border-radius: .2rem;
  background: rgba(35, 38, 45, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.03);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
  overflow: hidden;
}

.menu-search-input input {
  width: 100%;
  height: 100%;
  line-height: .86rem;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: .3rem;
  padding: 0 .24rem;
  box-sizing: border-box;
  display: block;
  -webkit-appearance: none;
  border-radius: 0;
}

.menu-search-input input::placeholder {
  color: rgba(255, 255, 255, 0.48);
}

.menu-search-btn {
  width: .86rem;
  height: .86rem;
  border-radius: .2rem;
  background: rgba(35, 38, 45, 0.96);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.menu-search-btn img {
  width: .36rem;
  height: .36rem;
  opacity: .82;
}

.menu-banner-card {
  width: 100%;
  height: 3.35rem;
  border-radius: .26rem;
  overflow: hidden;
  background: rgba(28, 31, 37, 0.96);
  box-shadow: 0 .16rem .3rem rgba(0, 0, 0, 0.24);
}

.menu-banner-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.menu-banner-pagination {
  margin-top: -.65rem;
  text-align: center;
  position: static;
}

.menu-banner-dot {
  display: inline-block;
  width: .12rem;
  height: .12rem;
  background: rgba(255, 255, 255, 0.45);
  margin: 0 .06rem;
  border-radius: 50%;
}

.menu-banner-dot.on {
  width: .3rem;
  border-radius: .12rem;
  background: #ff7a2f;
}

.menu-categories {
  width: 100vw;
  margin-left: calc(50% - 50vw);
  box-sizing: border-box;
  margin-top: -.28rem;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-left: .24rem;
  padding-right: .24rem;
  padding-bottom: .02rem;
  min-height: .94rem;
  position: relative;
  z-index: 1;
  background: transparent;
}

.menu-depot-categories {
  margin-top: -.28rem;
}

.menu-categories-has-depot {
  margin-top: -.32rem;
}

.menu-categories-empty {
  visibility: hidden;
}

.menu-categories::-webkit-scrollbar {
  display: none;
}

.menu-categories-track {
  display: inline-flex;
  gap: .14rem;
  min-width: 100%;
  padding-right: 0;
  box-sizing: border-box;
}

.menu-category-item {
  display: inline-flex;
  align-items: center;
  width: auto;
  height: .72rem;
  padding: 0 .18rem;
  border-radius: .36rem;
  background: rgba(33, 37, 46, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.02);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.02);
  box-sizing: border-box;
  flex: 0 0 auto;
  overflow: hidden;
}

.menu-category-item.on {
  background: #f04e05;
  color:#fff;
}

.menu-category-item.on .menu-category-name {
  color: #fff;
  font-weight: 500;
}

.menu-category-item.on .menu-category-thumb {
  border-color: rgba(17, 19, 23, 0.35);
}

.menu-category-thumb {
  width: .5rem;
  height: .5rem;
  border-radius: .08rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-category-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.menu-category-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff8b3d;
  font-size: .24rem;
  font-weight: 700;
}

.menu-category-name {
  margin-left: .1rem;
  color: #fff;
  font-size: .24rem;
  font-weight: 500;
  line-height: .3rem;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.menu-goods {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .18rem .12rem;
  margin-top: .06rem;
}

.menu-goods-category {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgba(255, 255, 255, 0.92);
  font-size: .38rem;
  font-weight: 700;
  line-height: .48rem;
  text-align: left;
  margin-top: .02rem;
}

.menu-goods-category-flat {
  position: relative;
  margin-top: .36rem;
  margin-bottom: .06rem;
  padding: .12rem .02rem .04rem;
  z-index: 2;
}

.menu-goods-category-flat::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, rgba(240, 78, 5, 0.85), rgba(240, 78, 5, 0.08) 60%, rgba(240, 78, 5, 0));
  opacity: 0.9;
}

.menu-goods-category-title {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-goods-view-toggle {
  width: .46rem;
  height: .46rem;
  border-radius: .12rem;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.04);
  box-sizing: border-box;
  margin-left: .14rem;
  position: relative;
  flex: 0 0 auto;
}

.menu-goods-view-toggle::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: .22rem;
  height: 2px;
  background: #f04e05;
  transform: translate(-50%, -50%);
  box-shadow: 0 -.1rem 0 #f04e05, 0 .1rem 0 #f04e05;
}

.menu-goods.mode-2 {
  grid-template-columns: 1fr;
  gap: .18rem;
}

.menu-goods.mode-2 .menu-goods-card {
  flex-direction: column;
  width: 92%;
  margin: 0 auto;
}

.menu-goods.mode-2 .menu-goods-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: .28rem;
  margin: 0;
}

.menu-goods.mode-2 .menu-goods-body {
  padding: .18rem .18rem .22rem .18rem;
}

.menu-goods.mode-2 .menu-goods-name {
  font-size: .32rem;
  line-height: .42rem;
  -webkit-line-clamp: 2;
}

.menu-goods.mode-2 .menu-goods-icons img {
  width: .4rem;
  height: .4rem;
}

.menu-goods.mode-2 .menu-goods-desc {
  font-size: .26rem;
  line-height: .34rem;
}

.menu-goods.mode-2 .menu-goods-footer {
  min-height: .5rem;
}

.menu-goods.mode-2 .menu-goods-add {
  width: .5rem;
  height: .5rem;
  line-height: .5rem;
  font-size: .38rem;
}

.menu-goods.mode-2 .menu-goods-step-btn {
  width: .5rem;
  height: .5rem;
  line-height: .48rem;
  font-size: .36rem;
}

.menu-goods.mode-2 .menu-goods-step-qty {
  min-width: .5rem;
  font-size: .3rem;
}

.menu-goods.mode-3 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .14rem .14rem;
}

.menu-goods.mode-3 .menu-goods-image {
  display: none;
}

.menu-goods.mode-3 .menu-goods-body {
  padding: .14rem .14rem .14rem;
}

.menu-goods.mode-3 .menu-goods-name {
  font-size: .26rem;
  line-height: .32rem;
  -webkit-line-clamp: 2;
}

.menu-goods.mode-3 .menu-goods-icons {
  display: flex;
  margin-top: .06rem;
  min-height: .32rem;
  gap: .01rem;
}

.menu-goods.mode-3 .menu-goods-icons img {
  width: .32rem;
  height: .32rem;
}

.menu-goods.mode-3 .menu-goods-desc {
  font-size: .22rem;
  line-height: .3rem;
  margin-top: .04rem;
}

.menu-goods.mode-3 .menu-goods-price {
  font-size: .28rem;
}

.menu-goods.mode-3 .menu-goods-add {
  width: .4rem;
  height: .4rem;
  line-height: .4rem;
  font-size: .32rem;
}

.menu-goods.mode-3 .menu-goods-step-btn {
  width: .4rem;
  height: .4rem;
  line-height: .38rem;
  font-size: .3rem;
}

.menu-goods.mode-3 .menu-goods-step-qty {
  min-width: .36rem;
  font-size: .26rem;
}

.menu-goods-card {
  background: linear-gradient(180deg, rgba(28, 31, 39, 0.98) 0%, rgba(23, 26, 34, 0.98) 100%);
  border-radius: .28rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.03);
  box-shadow: 0 .14rem .28rem rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.menu-goods-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  background: rgba(255, 255, 255, 0.04);
  border-radius: .28rem;
  overflow: hidden;
}

.menu-goods-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: inherit;
}

.menu-goods-body {
  padding: .16rem .16rem .18rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.menu-goods-name {
  color: #fff;
  font-size: .28rem;
  line-height: .3rem;
  min-height: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.menu-goods-meta {
  margin-top: auto;
}

.menu-goods-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: .12rem;
  min-height: .38rem;
}

.menu-goods-icons {
  display: flex;
  align-items: center;
  gap: .01rem;
  margin-top: .08rem;
  min-height: .38rem;
  flex-wrap: nowrap;
}

.menu-goods-icons img {
  width: .38rem;
  height: .38rem;
  display: block;
}

.menu-goods-desc {
  margin-top: .06rem;
  color: rgba(255, 255, 255, 0.55);
  font-size: .24rem;
  line-height: .32rem;
  text-align: left;
  display: block;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}

.menu-goods-price {
  margin-top: 0;
  color: #ff7a2f;
  font-size: .3rem;
  line-height: .32rem;
  font-weight: 700;
  text-align: left;
  flex: 1;
}

.menu-goods-add {
  width: .42rem;
  height: .42rem;
  border-radius: 50%;
  background: #ff7a2f;
  color: #fff;
  font-size: .34rem;
  line-height: .42rem;
  text-align: center;
  font-weight: 700;
  flex: 0 0 auto;
  box-shadow: 0 .06rem .14rem rgba(255, 122, 47, 0.28);
}

.menu-goods-step {
  display: inline-flex;
  align-items: center;
  gap: .1rem;
  flex: 0 0 auto;
}

.menu-goods-step-btn {
  width: .42rem;
  height: .42rem;
  border-radius: 50%;
  text-align: center;
  font-size: .32rem;
  line-height: .4rem;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-goods-step-btn.minus {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.86);
}

.menu-goods-step-btn.plus {
  background: #f04e05;
  border: 1px solid #f04e05;
  color: #fff;
}

.menu-goods-step-qty {
  min-width: .42rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: .28rem;
  line-height: .34rem;
  font-weight: 700;
}

.menu-goods-step-btn.disabled {
  opacity: 0.55 !important;
  pointer-events: none;
}

.menu-goods-add.disabled {
  opacity: 0.55 !important;
  pointer-events: none;
}

.menu-goods-weight-entry {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 .1rem;
  height: .44rem;
  border-radius: .22rem;
  background: #f04e05;
  color: #fff;
  font-size: .26rem;
  line-height: 1;
  font-weight: 700;
  flex: 0 0 auto;
  cursor: pointer;
  white-space: nowrap;
}
.menu-goods-weight-entry .menu-goods-weight-unit {
  margin-left: .04rem;
  font-size: .22rem;
  font-weight: 600;
  opacity: 0.9;
}

.menu-cart-weight-qty-input {
  width: 1.2rem;
  height: .44rem;
  border-radius: .08rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.95);
  font-size: .26rem;
  font-weight: 700;
  text-align: right;
  padding: 0 .1rem 0 .12rem;
  outline: none;
  box-sizing: border-box;
  -moz-appearance: textfield;
}
.menu-cart-weight-qty-input::-webkit-outer-spin-button,
.menu-cart-weight-qty-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.menu-cart-weight-unit {
  margin-left: .06rem;
  font-size: .22rem;
  color: rgba(255, 255, 255, 0.88);
  font-weight: 600;
  white-space: nowrap;
}

.menu-fly-layer {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 120;
}

.menu-fly-ball {
  position: fixed;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #f04e05;
  box-shadow: 0 6px 14px rgba(240, 78, 5, 0.35);
  transition: transform 680ms cubic-bezier(0.22, 0.85, 0.28, 1), opacity 680ms cubic-bezier(0.22, 0.85, 0.28, 1);
  will-change: transform, opacity;
}

.menu-setmeal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 110;
  background: #0f1116;
  display: flex;
  flex-direction: column;
}

.menu-setmeal-top {
  height: 1.06rem;
  padding: 0 .24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: #0f1116;
}

.menu-setmeal-top-left {
  display: inline-flex;
  align-items: center;
  gap: .08rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: .28rem;
}

.menu-setmeal-top-title {
  flex: 1;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: .32rem;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.menu-setmeal-top-right {
  width: 1rem;
}

.menu-setmeal-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 .24rem 1.28rem;
  box-sizing: border-box;
}

.menu-setmeal-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: .22rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
}

.menu-setmeal-image img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.menu-setmeal-info {
  margin-top: .16rem;
  padding: .16rem .18rem .14rem;
  border-radius: .22rem;
  background: rgba(33, 37, 46, 0.92);
}

.menu-setmeal-name {
  color: rgba(255, 255, 255, 0.92);
  font-size: .34rem;
  line-height: .44rem;
  font-weight: 700;
  text-align: left;
}

.menu-setmeal-desc {
  margin-top: .06rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: .24rem;
  line-height: .34rem;
  text-align: left;
  display: block;
  white-space: normal;
  word-break: break-word;
}

.menu-setmeal-icons {
  display: flex;
  align-items: center;
  gap: .08rem;
  margin-top: .08rem;
  flex-wrap: nowrap;
}

.menu-setmeal-icons img {
  width: .28rem;
  height: .28rem;
  display: block;
}

.menu-setmeal-money {
  color: #f04e05;
  font-size: .34rem;
  line-height: .44rem;
  font-weight: 800;
  text-align: left;
}

.menu-setmeal-money-row {
  margin-top: .1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .16rem;
}

.menu-setmeal-block {
  margin-top: .2rem;
  padding: .18rem .18rem .1rem;
  border-radius: .22rem;
  background: rgba(33, 37, 46, 0.92);
}

.menu-setmeal-block-title {
  color: rgba(255, 255, 255, 0.9);
  font-size: .28rem;
  font-weight: 700;
  line-height: .36rem;
}

.menu-setmeal-block-head {
  display: flex;
  align-items: center;
  justify-content:start;
  gap: .12rem;
  margin-bottom: .06rem;
}

.menu-setmeal-block-tip {
  color: rgba(255, 255, 255, 0.58);
  font-size: .22rem;
  line-height: .3rem;
  white-space: nowrap;
  flex: 0 0 auto;
}

.menu-setmeal-loading,
.menu-setmeal-empty {
  padding: .18rem 0 .22rem;
  color: rgba(255, 255, 255, 0.55);
  font-size: .24rem;
}

.menu-setmeal-grid {
  padding: .2rem 0 .06rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: .16rem .14rem;
}

.menu-setmeal-remark-groups {
  padding: .12rem 0 .06rem;
}

.menu-setmeal-remark-group + .menu-setmeal-remark-group {
  margin-top: .16rem;
}

.menu-setmeal-remark-group-title {
  margin-bottom: .1rem;
  color: rgba(255, 255, 255, 0.86);
  font-size: .26rem;
  line-height: .34rem;
  font-weight: 700;
}

.menu-setmeal-remark-grid {
  padding: .16rem 0 .06rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .12rem .12rem;
}

.menu-setmeal-remark-item {
  padding: .16rem .18rem;
  min-height: 1.1rem;
  border-radius: .2rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-setmeal-remark-item.on {
  border-color: rgba(240, 78, 5, 0.6);
  background: #f04e05;
}

.menu-setmeal-remark-text {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: .04rem;
  text-align: center;
}

.menu-setmeal-remark-name {
  color: rgba(255, 255, 255, 0.9);
  font-size: .26rem;
  line-height: .34rem;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-setmeal-remark-item.on .menu-setmeal-remark-name {
  color: #fff;
}

.menu-setmeal-remark-price {
  color: #f04e05;
  font-size: .24rem;
  line-height: .34rem;
  font-weight: 700;
  white-space: nowrap;
}

.menu-setmeal-remark-item.on .menu-setmeal-remark-price {
  color: #fff;
}

.menu-setmeal-empty {
  grid-column: 1 / -1;
}

.menu-setmeal-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .08rem;
  padding: .1rem .12rem .08rem;
  border-radius: .18rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-sizing: border-box;
}

.menu-setmeal-card-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: .18rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
  margin-top: .06rem;
}

.menu-setmeal-card-image img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.menu-setmeal-card-name {
  width: 100%;
  color: rgba(255, 255, 255, 0.86);
  font-size: .22rem;
  line-height: .28rem;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.menu-setmeal-card-addmoney {
  width: 100%;
  color: #ff0000;
  font-size: .22rem;
  line-height: .28rem;
  text-align: center;
  font-weight: 700;
}

.menu-setmeal-card-qty {
  color: rgba(255, 255, 255, 0.62);
  font-size: .22rem;
  line-height: .28rem;
}

.menu-setmeal-card-stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: .02rem;
  width: 100%;
}

.menu-setmeal-card-stepper-inner {
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-setmeal-card-step-btn {
  width: .36rem;
  height: .36rem;
  border-radius: 50%;
  text-align: center;
  font-size: .28rem;
  line-height: .34rem;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-setmeal-card-step-btn.minus {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.86);
}

.menu-setmeal-card-step-btn.plus {
  background: #f04e05;
  border: 1px solid #f04e05;
  color: #fff;
}

.menu-setmeal-card-step-qty {
  min-width: .32rem;
  flex: 1;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: .24rem;
  line-height: .3rem;
  font-weight: 700;
}

.menu-setmeal-card-step-hidden {
  visibility: hidden;
  pointer-events: none;
}

.menu-weight-stepper {
  display: inline-flex;
  align-items: center;
  gap: .1rem;
  margin-left: auto;
  padding: .06rem .08rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.menu-weight-stepper.in-info {
  margin-left: 0;
}

.menu-weight-step-btn {
  width: .46rem;
  height: .46rem;
  border-radius: 50%;
  text-align: center;
  font-size: .34rem;
  line-height: .44rem;
  font-weight: 700;
  box-sizing: border-box;
  flex-shrink: 0;
}

.menu-weight-step-btn.minus {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.86);
}

.menu-weight-step-btn.plus {
  background: #f04e05;
  border: 1px solid #f04e05;
  color: #fff;
}

.menu-weight-input {
  min-width: .96rem;
  max-width: 1.2rem;
  height: .48rem;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: .28rem;
  line-height: .48rem;
  font-weight: 700;
  text-align: center;
  padding: 0 .06rem;
  border-radius: .24rem;
}

.menu-weight-input::placeholder {
  color: rgba(255, 255, 255, 0.42);
  font-weight: 400;
}

.menu-weight-unit {
  color: rgba(255, 255, 255, 0.7);
  font-size: .22rem;
  line-height: .28rem;
  font-weight: 600;
  flex-shrink: 0;
}

.menu-weight-card {
  margin-top: .16rem;
  padding: .28rem .24rem;
  background: linear-gradient(180deg, rgba(255, 99, 25, 0.08) 0%, rgba(255, 99, 25, 0.02) 100%);
  border: 1px solid rgba(240, 78, 5, 0.32);
  border-radius: .24rem;
}

.menu-weight-card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .16rem;
  margin-bottom: .24rem;
}

.menu-weight-card-row:last-child {
  margin-bottom: 0;
}

.menu-weight-card-label {
  color: rgba(255, 255, 255, 0.74);
  font-size: .26rem;
  line-height: .34rem;
  font-weight: 500;
  flex-shrink: 0;
}

.menu-weight-card-subtotal {
  color: #ffb886;
  font-size: .36rem;
  line-height: .44rem;
  font-weight: 700;
}

.menu-weight-card-control {
  display: inline-flex;
  align-items: center;
  gap: .08rem;
  padding: .06rem .1rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.menu-weight-card-input {
  min-width: 1.1rem;
  max-width: 1.3rem;
  height: .5rem;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: .3rem;
  line-height: .5rem;
  font-weight: 700;
  text-align: center;
  padding: 0 .06rem;
  border-radius: .26rem;
}

.menu-weight-card-unit {
  color: rgba(255, 255, 255, 0.74);
  font-size: .24rem;
  line-height: .3rem;
  font-weight: 600;
  flex-shrink: 0;
}

.menu-weight-card-tips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .14rem;
  margin-top: .12rem;
}

.menu-weight-card-chip {
  padding: .1rem .22rem;
  border-radius: .36rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.88);
  font-size: .22rem;
  line-height: .28rem;
  font-weight: 600;
}

.menu-weight-card-chip:active {
  background: rgba(240, 78, 5, 0.18);
  border-color: rgba(240, 78, 5, 0.42);
  color: #fff;
}

.menu-setmeal-row {
  padding: .14rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.menu-setmeal-row:last-child {
  border-bottom: 0;
}

.menu-setmeal-row-name {
  color: rgba(255, 255, 255, 0.86);
  font-size: .26rem;
  line-height: .34rem;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-setmeal-row-qty {
  margin-left: .16rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: .24rem;
}

.menu-setmeal-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: .14rem .24rem calc(env(safe-area-inset-bottom, 0px) + .14rem);
  display: flex;
  align-items: center;
  gap: .14rem;
  box-sizing: border-box;
  background: #0f1116;
}

.menu-setmeal-price {
  color: #f04e05;
  font-size: .34rem;
  font-weight: 700;
  line-height: .44rem;
}

.menu-setmeal-stepper {
  display: inline-flex;
  align-items: center;
  gap: .1rem;
  margin-left: auto;
}

.menu-setmeal-stepper.in-info {
  margin-left: 0;
}

.menu-setmeal-step-btn {
  width: .46rem;
  height: .46rem;
  border-radius: 50%;
  text-align: center;
  font-size: .34rem;
  line-height: .44rem;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-setmeal-step-btn.minus {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.86);
}

.menu-setmeal-step-btn.plus {
  background: #f04e05;
  border: 1px solid #f04e05;
  color: #fff;
}

.menu-setmeal-step-qty {
  min-width: .42rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: .28rem;
  line-height: .34rem;
  font-weight: 700;
}

.menu-setmeal-add-btn {
  width: 1.4rem;
  height: .72rem;
  border-radius: .36rem;
  background: #f04e05;
  color: #fff;
  font-size: .28rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-setmeal-add-btn.full {
  width: 80%;
  height: .74rem;
  border-radius: .56rem;
  font-size: .3rem;
  margin: 0 auto;
}

.menu-goods-empty {
  grid-column: 1 / -1;
  text-align: center;
  color: rgba(255, 255, 255, 0.55);
  font-size: .28rem;
  padding: .32rem 0;
}

.menu-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1.6rem;
  padding: 0 .34rem calc(env(safe-area-inset-bottom, 0px) + .05rem);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  z-index: 30;
  box-sizing: border-box;
}

.menu-bottom-flow {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1.08rem;
  background: url('../../static/images/xin/butbj.png') no-repeat center bottom;
  background-size: 100% 100%;
  box-shadow: none;
  overflow: visible;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}



.menu-bottom-item,
.menu-bottom-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  z-index: 3;
}

.menu-bottom-item {
  width: 1.18rem;
  padding-bottom: .18rem;
}

.menu-bottom-center {
  position: relative;
  margin-top: -.9rem;
  width: 1.42rem;
}

.menu-bottom-icon {
  width: .52rem;
  height: .52rem;
  border: 1px dashed rgba(255, 255, 255, 0.28);
  border-radius: .1rem;
  position: relative;
  box-sizing: border-box;
  opacity: .74;
  background: rgba(255, 255, 255, 0.02);
}

.menu-bottom-order::before,
.menu-bottom-order::after,
.menu-bottom-checkout::before,
.menu-bottom-checkout::after,
.menu-bottom-center-icon::before,
.menu-bottom-center-icon::after {
  content: '';
  position: absolute;
  display: block;
}

.menu-bottom-order::before {
  left: .09rem;
  right: .09rem;
  top: .12rem;
  height: 2px;
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 .09rem 0 rgba(255, 255, 255, 0.4), 0 .18rem 0 rgba(255, 255, 255, 0.4);
}

.menu-bottom-checkout::before {
  left: .09rem;
  right: .09rem;
  top: .1rem;
  bottom: .1rem;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: .06rem;
  box-sizing: border-box;
}

.menu-bottom-checkout::after {
  left: .16rem;
  right: .16rem;
  top: .2rem;
  height: 2px;
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 .08rem 0 rgba(255, 255, 255, 0.4);
}

.menu-bottom-center-btn {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: linear-gradient(180deg, #f47a34 0%, #eb6526 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  border: none;
  position: relative;
  bottom:0.35rem;
}

.menu-bottom-center-icon {
  width: .42rem;
  height: .32rem;
  border: 2px solid #fff;
  border-radius: .06rem;
  position: relative;
  box-sizing: border-box;
}

.menu-bottom-center-icon::before {
  width: .2rem;
  height: .08rem;
  border: 2px solid #fff;
  border-bottom: 0;
  border-radius: .1rem .1rem 0 0;
  left: 50%;
  top: -.14rem;
  transform: translateX(-50%);
  box-sizing: border-box;
}

.menu-bottom-center-icon::after {
  width: .18rem;
  height: 2px;
  background: #fff;
  left: 50%;
  top: .08rem;
  transform: translateX(-50%);
  box-shadow: 0 .08rem 0 #fff;
}

.menu-bottom-badge {
  position: absolute;
  top: -.06rem;
  right: .06rem;
  min-width: .38rem;
  height: .38rem;
  padding: 0 .08rem;
  border-radius: .19rem;
  background: #f04e05;
  color: #fff;
  font-size: .24rem;
  line-height: .38rem;
  text-align: center;
  font-weight: 700;
  box-sizing: border-box;
  box-shadow: none;
}

.menu-cart {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 80;
  background: #101114;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 1.3rem);
  box-sizing: border-box;
}

.menu-cart-top {
  position: sticky;
  top: 0;
  z-index: 81;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 .24rem;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: #101114;
}

.menu-cart-top-left,
.menu-cart-top-right {
  width: 1.8rem;
  display: flex;
  align-items: center;
}

.menu-cart-top-right {
  justify-content: flex-end;
}

.menu-cart-del {
  width: .44rem;
  height: .44rem;
  border-radius: .14rem;
  border: 1px solid rgba(240, 78, 5, 0.55);
  background: rgba(240, 78, 5, 0.08);
  position: relative;
  box-sizing: border-box;
}

.sblw{
	color:#f04e05;
	font-size:0.22rem;
	width:90%;
	margin:0 auto .1rem auto;
	line-height:.32rem;
	text-align:left;
}

.menu-cart-del::before,
.menu-cart-del::after {
  content: '';
  position: absolute;
  left: 50%;
  display: block;
}

.menu-cart-del::before {
  width: .22rem;
  height: .18rem;
  border: 2px solid rgba(240, 78, 5, 0.9);
  border-top: 0;
  border-radius: 0 0 .04rem .04rem;
  top: .16rem;
  transform: translateX(-50%);
  box-sizing: border-box;
}

.menu-cart-del::after {
  width: .26rem;
  height: 2px;
  background: rgba(240, 78, 5, 0.9);
  top: .12rem;
  transform: translateX(-50%);
}

.menu-cart-top-left {
  justify-content: flex-start;
  gap: .1rem;
  color: rgba(255, 255, 255, 0.92);
}

.menu-cart-top-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: .34rem;
  font-weight: 700;
}

.menu-cart-back-text {
  font-size: .3rem;
  line-height: .36rem;
}

.menu-cart-back-arrow {
  width: .16rem;
  height: .16rem;
  border-left: 2px solid rgba(255, 255, 255, 0.92);
  border-bottom: 2px solid rgba(255, 255, 255, 0.92);
  transform: rotate(45deg);
  display: inline-block;
  margin-top: .02rem;
}

.menu-cart-body {
  padding: .22rem .24rem 0;
  box-sizing: border-box;
}

.menu-cart-item {
  width: 100%;
  display: flex;
  align-items: center;
  background: #181b20;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: .18rem;
  overflow: hidden;
  margin-bottom: .18rem;
  padding: .22rem .18rem;
  box-sizing: border-box;
}

.menu-cart-check {
  width: .34rem;
  height: .34rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.34);
  box-sizing: border-box;
  margin-right: .18rem;
  flex: 0 0 auto;
  position: relative;
}

.menu-cart-thumb {
  width: 1.9rem;
  height: 1.36rem;
  border-radius: .16rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.04);
  border: 1px dashed rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  flex: 0 0 auto;
}

.menu-cart-check.on {
  border-color: #f04e05;
  background: #f04e05;
}

.menu-cart-check.on::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 46%;
  width: .18rem;
  height: .1rem;
  border-left: 2px solid #101114;
  border-bottom: 2px solid #101114;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.menu-cart-check.small {
  width: .3rem;
  height: .3rem;
  margin-right: .12rem;
}

.menu-cart-selectall {
  display: inline-flex;
  align-items: center;
  margin-bottom: .02rem;
}

.menu-cart-selectall-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: .28rem;
  line-height: .32rem;
}

.menu-cart-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.menu-cart-name {
  color: #fff;
  font-size: .3rem;
  line-height: .38rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.menu-cart-main {
  flex: 1;
  min-width: 0;
  padding-left: .18rem;
  box-sizing: border-box;
}

.menu-cart-main-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-cart-price {
  color: #f04e05;
  font-size: .3rem;
  font-weight: 700;
}

.menu-cart-edit {
  width: .34rem;
  height: .34rem;
  border: 1px solid rgba(240, 78, 5, 0.7);
  border-radius: .08rem;
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  opacity: .9;
}

.menu-cart-edit::before {
  content: '';
  position: absolute;
  width: .18rem;
  height: 2px;
  background: #f04e05;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(-35deg);
}

.menu-cart-edit::after {
  content: '';
  position: absolute;
  width: .06rem;
  height: .06rem;
  background: #f04e05;
  right: .07rem;
  bottom: .07rem;
  transform: rotate(-35deg);
}

.menu-cart-remark {
  margin-top: .1rem;
  font-size: .24rem;
  line-height: .32rem;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-cart-remark-label {
  color: #f04e05;
  margin-right: .08rem;
}

.menu-cart-remark-text {
  color: rgba(255, 255, 255, 0.72);
}

.menu-cart-zuofa {
  margin-top: .08rem;
  font-size: .24rem;
  line-height: .34rem;
  text-align: left;
  display: flex;
  align-items: baseline;
  gap: .08rem;
}

.menu-cart-zuofa-label {
  color: #f04e05;
  flex: 0 0 auto;
}

.menu-cart-zuofa-text {
  color: rgba(255, 255, 255, 0.72);
  flex: 1;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}

.menu-cart-zuofa-add {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 700;
  flex: 0 0 auto;
  white-space: nowrap;
}

.menu-cart-setmeal {
  margin-top: .1rem;
  padding: .14rem .14rem;
  border-radius: .16rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-sizing: border-box;
}

.menu-cart-setmeal-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: .24rem;
  line-height: .34rem;
  color: rgba(255, 255, 255, 0.82);
  font-weight: 700;
}

.menu-cart-setmeal-qty {
  color: #f04e05;
  font-weight: 700;
}

.menu-cart-setmeal-list {
  margin-top: .08rem;
  display: flex;
  flex-direction: column;
  gap: .06rem;
}

.menu-cart-setmeal-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: .12rem;
  font-size: .24rem;
  line-height: .34rem;
  color: rgba(255, 255, 255, 0.72);
}

.menu-cart-setmeal-item-name {
  flex: 1;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
}

.menu-cart-setmeal-item-qty {
  flex: 0 0 auto;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 700;
}

.menu-cart-setmeal-item-add {
  flex: 0 0 auto;
  white-space: nowrap;
  color: #ff0000;
  font-weight: 700;
  font-size: .24rem;
}

.menu-cart-main-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: .16rem;
}

.menu-cart-stepper {
  display: flex;
  align-items: center;
  gap: .12rem;
  margin-right: -.06rem;
  margin-top: .06rem;
}

.menu-cart-step-btn {
  width: .52rem;
  height: .52rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: .34rem;
  line-height: .5rem;
  text-align: center;
  box-sizing: border-box;
}

.menu-cart-step-btn.plus {
  background: #f04e05;
  border-color: #f04e05;
  color: #fff;
}

.menu-cart-step-qty {
  min-width: .6rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: .3rem;
  text-align: center;
}

.menu-cart-empty {
  padding: 1.2rem 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: .3rem;
}

.menu-cart-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 82;
  height: 1.18rem;
  padding: 0 .24rem calc(env(safe-area-inset-bottom, 0px) + .08rem);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #111317;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.menu-cart-bottom-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: .06rem;
}

.menu-cart-subtotal-label {
  color: rgba(255, 255, 255, 0.72);
  font-size: .28rem;
  line-height: .32rem;
}

.menu-cart-subtotal-value {
  color: #f04e05;
  font-size: .36rem;
  line-height: .42rem;
  font-weight: 700;
}

.menu-cart-checkout-btn {
  font-size: .34rem;
  width: 2.9rem;
  height: .92rem;
  background: #f04e05;
  line-height: .92rem;
  color: #fff;
  border-radius: .92rem;
  font-weight: 700;
  text-align: center;
}

.menu-cart-checkout-btn.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.menu-food-form {
  padding:0 .24rem;
  background: #1a1d24;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.menu-food-tabs {
  display: flex;
  margin-bottom: .24rem;
}

.menu-food-tabs div {
  flex: 1;
  height: .72rem;
  line-height: .72rem;
  text-align: center;
  font-size: .28rem;
  color: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: .16rem;
  margin-right: .16rem;
  cursor: pointer;
  transition: all 0.2s;
}

.menu-food-tabs div:last-child {
  margin-right: 0;
}

.menu-food-tabs div.active {
  background: #f04e05;
  color: #fff;
  border-color: #f04e05;
}

.menu-food-inputs {
  display: flex;
  flex-direction: column;
}

.menu-food-input-item {
  display: flex;
  align-items: center;
  margin-bottom: .16rem;
}

.menu-food-input-item:last-child {
  margin-bottom: 0;
}

.menu-food-input-label {
  font-size: .26rem;
  color: #f04e05;
  margin-right: .12rem;
  flex-shrink: 0;
}

.menu-food-input-item input {
  flex: 1;
  height: .72rem;
  padding: 0 .24rem;
  font-size: .28rem;
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: .12rem;
  outline: none;
  box-sizing: border-box;
}

.menu-food-input-item input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.menu-food-time {
  display: flex;
  align-items: center;
  padding: .18rem .24rem;
  margin:.18rem 0;
  border-radius: .18rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #1a1a1a;
}

.menu-food-time span {
  color: rgba(255, 255, 255, 0.7);
  font-size: .28rem;
  margin-right: .16rem;
  white-space: nowrap;
}

.menu-time-selects {
  display: flex;
  flex: 1;
  gap: .12rem;
}

.menu-time-date,
.menu-time-time {
  flex: 1;
  height: .6rem;
  padding: 0 .16rem;
  font-size: .26rem;
  color: #fff;
  background: #0d0d0d;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: .12rem;
  outline: none;
  appearance: none;
  cursor: pointer;
  text-align:center;
}

.menu-time-date option,
.menu-time-time option {
  background: #1a1a1a;
  color: #fff;
  padding: .1rem 0;
}

.menu-time-date::-webkit-scrollbar,
.menu-time-time::-webkit-scrollbar {
  width: 6px;
}

.menu-time-date::-webkit-scrollbar-track,
.menu-time-time::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.menu-time-date::-webkit-scrollbar-thumb,
.menu-time-time::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}



.menu-food-tip-quick {
  padding: .24rem;
}

.menu-food-tip-quick-list {
  display: flex;
  gap: .16rem;
}

.menu-food-tip-quick-item {
  flex: 1;
  height: .72rem;
  line-height: .72rem;
  text-align: center;
  border-radius: .36rem;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: .26rem;
}

.menu-food-fee-summary {
  padding: .24rem;
  background: rgba(255, 255, 255, 0.04);
}

.menu-food-fee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: .72rem;
  color: rgba(255, 255, 255, 0.7);
  font-size: .26rem;
}

.menu-food-fee-item.clickable {
  cursor: pointer;
}

.menu-food-fee-link {
  color: #f5b52f;
  font-weight: 700;
}

.menu-food-fee-item.discount {
  color: #f5b52f;
}

.menu-food-fee-discount {
  color: #f5b52f;
  font-weight: 700;
}

.menu-coupon-dialog {
  width: 100%;
  max-width: 6.4rem;
  max-height: 8.6rem;
  overflow: hidden;
  border-radius: .24rem;
  background: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 .2rem .5rem rgba(0, 0, 0, 0.38);
  padding: .3rem;
  box-sizing: border-box;
}

.menu-coupon-title {
  color: #fff;
  font-size: .34rem;
  line-height: .42rem;
  font-weight: 700;
  text-align: center;
}

.menu-coupon-subtitle {
  margin-top: .12rem;
  color: rgba(255, 255, 255, 0.62);
  font-size: .24rem;
  text-align: center;
}

.menu-coupon-list {
  margin-top: .24rem;
  max-height: 5.8rem;
  overflow-y: auto;
}

.menu-coupon-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .2rem;
  padding: .22rem .24rem;
  margin-bottom: .16rem;
  border-radius: .2rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.04);
}

.menu-coupon-item.active {
  border-color: rgba(240, 78, 5, 0.8);
  background: rgba(240, 78, 5, 0.12);
}

.menu-coupon-item.disabled {
  opacity: 0.55;
}

.menu-coupon-item-main {
  flex: 1;
  min-width: 0;
}

.menu-coupon-item-name {
  color: #fff;
  font-size: .28rem;
  line-height: .36rem;
  font-weight: 700;
  word-break: break-all;
}

.menu-coupon-item-desc {
  margin-top: .08rem;
  color: rgba(255, 255, 255, 0.62);
  font-size: .24rem;
  line-height: .32rem;
}

.menu-coupon-item-side {
  flex-shrink: 0;
  text-align: right;
}

.menu-coupon-item-money {
  color: #f5b52f;
  font-size: .34rem;
  line-height: .4rem;
  font-weight: 700;
}

.menu-coupon-item-check {
  margin-top: .08rem;
  color: rgba(255, 255, 255, 0.68);
  font-size: .24rem;
}

.menu-coupon-empty {
  padding: .6rem 0;
  color: rgba(255, 255, 255, 0.62);
  font-size: .28rem;
  text-align: center;
}

.menu-coupon-actions {
  margin-top: .24rem;
  display: flex;
  justify-content: flex-end;
  gap: .16rem;
}

.menu-coupon-btn {
  min-width: 1.5rem;
  height: .72rem;
  line-height: .72rem;
  padding: 0 .28rem;
  border-radius: .72rem;
  font-size: .28rem;
  text-align: center;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-coupon-btn.secondary {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.menu-coupon-btn.primary {
  color: #fff;
  background: #f04e05;
  border: 1px solid rgba(240, 78, 5, 0.6);
}

.menu-cart-remark-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 90;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .24rem;
  box-sizing: border-box;
}

.menu-cart-remark-dialog {
  width: 100%;
  max-width: 6.6rem;
  background: #181b20;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: .22rem;
  padding: .24rem;
  box-sizing: border-box;
}

.menu-cart-remark-title {
  color: #fff;
  font-size: .32rem;
  font-weight: 700;
  text-align: left;
}

.menu-cart-remark-input {
  width: 100%;
  height: 1.8rem;
  margin-top: .18rem;
  border-radius: .18rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-size: .28rem;
  padding: .18rem;
  box-sizing: border-box;
  outline: none;
  resize: none;
}

.menu-cart-remark-actions {
  margin-top: .18rem;
  display: flex;
  justify-content: flex-end;
  gap: .16rem;
}

.menu-cart-remark-btn {
  height: .72rem;
  line-height: .72rem;
  padding: 0 .34rem;
  border-radius: .72rem;
  font-size: .3rem;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-cart-remark-cancel {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.menu-cart-remark-ok {
  color: #fff;
  background: #f04e05;
  border: 1px solid rgba(240, 78, 5, 0.6);
}

.menu-cart-del-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 92;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .24rem;
  box-sizing: border-box;
}

.menu-cart-del-dialog {
  width: 100%;
  max-width: 5.8rem;
  border-radius: .24rem;
  background: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 .2rem .5rem rgba(0, 0, 0, 0.38);
  padding: .28rem .28rem .22rem;
  box-sizing: border-box;
}

.menu-cart-del-title {
  color: #fff;
  font-size: .32rem;
  line-height: .4rem;
  font-weight: 700;
  text-align: center;
}

.menu-cart-del-text {
  margin-top: .16rem;
  color: rgba(255, 255, 255, 0.84);
  font-size: .28rem;
  line-height: .4rem;
  text-align: center;
}

.menu-cart-del-actions {
  margin-top: .24rem;
  display: flex;
  justify-content: flex-end;
  gap: .16rem;
}

.menu-cart-del-btn {
  height: .72rem;
  line-height: .72rem;
  padding: 0 .34rem;
  border-radius: .72rem;
  font-size: .3rem;
  font-weight: 700;
  box-sizing: border-box;
}

.menu-cart-del-btn.cancel {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.menu-cart-del-btn.ok {
  color: #fff;
  background: #f04e05;
  border: 1px solid rgba(240, 78, 5, 0.6);
}

.menu-cart-order-loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 95;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .24rem;
  box-sizing: border-box;
}

.menu-cart-order-loading-dialog {
  width: 100%;
  max-width: 5.6rem;
  border-radius: .24rem;
  background: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: .28rem;
  box-sizing: border-box;
}

.menu-cart-order-loading-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: .3rem;
  line-height: .44rem;
  text-align: center;
}

.menu-toast {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.menu-toast-box {
  padding: .22rem .34rem;
  background: rgba(0, 0, 0, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: .2rem;
  color: #fff;
  font-size: .32rem;
  line-height: .42rem;
  font-weight: 700;
  max-width: 6.2rem;
  text-align: center;
  word-break: break-word;
}

.menu-setmeal-alert-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 170;
  background: rgba(0, 0, 0, 0.58);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .24rem;
  box-sizing: border-box;
}

.menu-setmeal-alert-dialog {
  width: 100%;
  max-width: 5.6rem;
  border-radius: .24rem;
  background: #1a1d24;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 .2rem .5rem rgba(0, 0, 0, 0.38);
  padding: .28rem .28rem .24rem;
  box-sizing: border-box;
}

.menu-setmeal-alert-title {
  color: #fff;
  font-size: .32rem;
  line-height: .4rem;
  font-weight: 700;
  text-align: center;
}

.menu-setmeal-alert-text {
  margin-top: .16rem;
  color: rgba(255, 255, 255, 0.82);
  font-size: .28rem;
  line-height: .4rem;
  text-align: center;
  word-break: break-word;
}

.menu-setmeal-alert-actions {
  margin-top: .24rem;
  display: flex;
  justify-content: center;
}

.menu-setmeal-alert-btn {
  min-width: 2.2rem;
  height: .76rem;
  line-height: .76rem;
  border-radius: .76rem;
  background: #f04e05;
  color: #fff;
  font-size: .3rem;
  font-weight: 700;
  text-align: center;
  box-sizing: border-box;
}

.menu-member-login-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 150;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(.1rem);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: .6rem .24rem;
  box-sizing: border-box;
}

.menu-member-login-dialog {
  width: 100%;
  max-width: 5.8rem;
  border-radius: .32rem;
  background: linear-gradient(145deg, #2a2f38, #1e232a);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 
    0 .4rem 1.2rem rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.03) inset;
  padding: .48rem .4rem .4rem;
  box-sizing: border-box;
}

.menu-member-login-title {
  color: #fff;
  font-size: .38rem;
  font-weight: 600;
  text-align: center;
  line-height: .5rem;
  letter-spacing: .02rem;
}

.menu-member-login-form {
  margin-top: .4rem;
}

.menu-member-login-input-item {
  margin-bottom: .28rem;
  position: relative;
}

.menu-member-login-input {
  width: 100%;
  height: .96rem;
  border-radius: .16rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: .28rem;
  padding: 0 .28rem;
  box-sizing: border-box;
  outline: none;
  transition: all .3s ease;
}

.menu-member-login-input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.menu-member-login-input:focus {
  border-color: rgba(240, 78, 5, 0.5);
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 
    0 0 0 3px rgba(240, 78, 5, 0.1),
    0 0 .2rem rgba(240, 78, 5, 0.2);
}

.menu-member-login-actions {
  display: flex;
  gap: .2rem;
}

.menu-member-login-btn {
  flex: 1;
  height: .92rem;
  line-height: .92rem;
  border-radius: .46rem;
  font-size: .28rem;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: all .3s ease;
  letter-spacing: .01rem;
}

.menu-member-login-btn.login {
  color: #fff;
  background: linear-gradient(135deg, #f04e05, #d44000);
  border: none;
  box-shadow: 
    0 .15rem .3rem rgba(240, 78, 5, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.menu-member-login-btn.login:active {
  transform: scale(.98);
  box-shadow: 
    0 .08rem .15rem rgba(240, 78, 5, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.menu-member-login-btn.register {
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-member-login-btn.register:active {
  background: rgba(255, 255, 255, 0.08);
}

.menu-member-register-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 160;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(.1rem);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: .6rem .24rem;
  box-sizing: border-box;
}

.menu-member-register-dialog {
  width: 100%;
  max-width: 6.6rem;
  border-radius: .32rem;
  background: linear-gradient(145deg, #2a2f38, #1e232a);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 
    0 .4rem 1.2rem rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.03) inset;
  padding: .48rem .4rem .4rem;
  box-sizing: border-box;
}

.menu-member-register-title {
  color: #fff;
  font-size: .38rem;
  font-weight: 600;
  text-align: center;
  line-height: .5rem;
  letter-spacing: .02rem;
}

.menu-member-register-form {
  margin-top: .4rem;
}

.menu-member-register-input-item {
  margin-bottom: .28rem;
  position: relative;
}

.menu-member-register-input-item.code {
  display: flex;
  align-items: center;
  gap: .16rem;
}

.menu-member-register-input {
  width: 100%;
  height: .96rem;
  border-radius: .16rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: .28rem;
  padding: 0 .28rem;
  box-sizing: border-box;
  outline: none;
  transition: all .3s ease;
}

.menu-member-register-input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.menu-member-register-input:focus {
  border-color: rgba(240, 78, 5, 0.5);
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 
    0 0 0 3px rgba(240, 78, 5, 0.1),
    0 0 .2rem rgba(240, 78, 5, 0.2);
}

.menu-member-register-input-item.code .menu-member-register-input {
  flex: 1 1 auto;
  min-width: 0;
}

.menu-member-register-code-btn {
  flex: 0 0 1.92rem;
  height: .96rem;
  line-height: .96rem;
  border-radius: .16rem;
  text-align: center;
  font-size: .24rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #f04e05, #d44000);
  box-shadow: 0 .12rem .24rem rgba(240, 78, 5, 0.3);
}

.menu-member-register-code-btn.disabled {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.45);
  box-shadow: none;
}

.menu-member-register-actions {
  display: flex;
  gap: .2rem;
  margin-top: .36rem;
}

.menu-member-register-btn {
  flex: 1;
  height: .92rem;
  line-height: .92rem;
  border-radius: .46rem;
  font-size: .28rem;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  transition: all .3s ease;
  letter-spacing: .01rem;
}

.menu-member-register-btn.register {
  color: #fff;
  background: linear-gradient(135deg, #f04e05, #d44000);
  border: none;
  box-shadow: 
    0 .15rem .3rem rgba(240, 78, 5, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.menu-member-register-btn.register:active {
  transform: scale(.98);
  box-shadow: 
    0 .08rem .15rem rgba(240, 78, 5, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.menu-member-register-btn.register.disabled {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.4);
  box-shadow: none;
}

.menu-member-register-btn.cancel {
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-member-register-btn.cancel:active {
  background: rgba(255, 255, 255, 0.08);
}

.menu-member-login-btn.disabled,
.menu-member-register-btn.disabled {
  cursor: not-allowed;
  opacity: 0.7;
  pointer-events: none;
}

.menu-member-login-btn.login.disabled,
.menu-member-register-btn.register.disabled {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: none;
}

.menu-member-login-btn.register.disabled,
.menu-member-register-btn.cancel.disabled {
  background: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.4);
  box-shadow: none;
}

.menu-member-login-btn.login {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .16rem;
}

.menu-member-register-btn.register {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .16rem;
}

.menu-member-login-btn-spinner {
  width: .36rem;
  height: .36rem;
  border-radius: 50%;
  border: .04rem solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  animation: spin 0.9s linear infinite;
  flex: 0 0 auto;
}

.menu-member-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
}

.menu-member-loading-dialog {
  min-width: 3.6rem;
  max-width: 80%;
  background: rgba(22, 24, 30, 0.95);
  border-radius: .2rem;
  padding: .48rem .4rem .4rem;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 .3rem 1rem rgba(0, 0, 0, 0.4);
}

.menu-member-loading-spinner {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: .1rem solid rgba(255, 255, 255, 0.15);
  border-top-color: #f04e05;
  margin: 0 auto;
  animation: spin 0.9s linear infinite;
}

.menu-member-loading-text {
  margin-top: .28rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: .28rem;
  line-height: 1.4;
  font-weight: 500;
}

.menu-pay-loading-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-pay-loading-panel {
  width: 5.6rem;
  background: rgba(30, 30, 30, 0.95);
  border-radius: .2rem;
  padding: .6rem .4rem .4rem .4rem;
  box-sizing: border-box;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-pay-loading-spinner {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  border: .12rem solid rgba(255, 255, 255, 0.15);
  border-top-color: #f04e05;
  margin: 0 auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.menu-pay-loading-text {
  margin-top: .35rem;
  font-size: .32rem;
  color: rgba(255, 255, 255, 0.85);
}

.menu-pay-loading-cancel {
  margin: .45rem auto 0 auto;
  width: 3.6rem;
  height: .88rem;
  line-height: .88rem;
  border-radius: .44rem;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.85);
  font-size: .3rem;
  text-align: center;
}









</style>



// WEBPACK FOOTER //
// src/components/Menu.vue